'use strict';

// TODO make sure the build process wraps this in a IIFE

angular.module('filters-client', ['qstrap', 'ripsaw', 'mgcrea.ngStrap', 'ngSanitize']).constant('PAGINATION_LIMIT', 100).config(['$httpProvider', function ($httpProvider) {

	if (!$httpProvider.defaults.headers.get) {
		$httpProvider.defaults.headers.get = {};
	}
	// Disable stupid IE ajax request caching angular get requests
	$httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
}]);
'use strict';

angular.module('filters-client').controller('fc.EnumerableValueController', ['$scope', '$rootScope', 'fc.filterData', 'fc.operators', '$filter', '$q', 'PAGINATION_LIMIT', '$timeout', 'fc.utilService', function ($scope, $rootScope, filterData, operatorTranslations, $filter, $q, PAGINATION_LIMIT, $timeout, util) {
	var hasLabels;

	var pagination = {
		limit: PAGINATION_LIMIT
	};
	var uiOperandBlackList = ['isEmpty', 'isNotEmpty'];

	angular.extend($scope, {
		uiOperator: operatorToUiOperator(),
		pagination: pagination,
		getOperands: getOperands,
		getOperandLabel: getOperandLabel,
		updateFilter: updateFilter,
		onSelection: onSelection
	});

	$scope.operandDisabled = operandDisabled(); // has to be outside of extend since it depends on uiOperator

	activate();

	function activate() {
		if (!isSet() && _.get($scope.displayedFilter, 'filter.operator') === 'equals') {
			$scope.displayedFilter.filter.operator = 'in';
			$scope.displayedFilter.filter.operand = [$scope.displayedFilter.filter.operand];
		}
		$scope.$watch('type', setupOperators);
		$scope.$watch('displayedFilter.filter.field', getHasLabels);
		$scope.$watch('displayedFilter.filter.operand', getOperandLabel);
	}

	function getHasLabels() {
		filterData.getField($scope.displayedFilter.filter.field).then(setHasLabels);
	}

	function setHasLabels(field) {
		hasLabels = field.labels;
		getOperandLabel();
	}

	function getOperands(search) {
		return filterData.getFieldValueMenuItems($scope.displayedFilter.filter.field, useLabels(), search, $scope.displayedFilter.filter.operand);
	}

	function useLabels() {
		//even though responseSet is not numeric, we want to show both domain and label in the menu
		return isSet() && hasLabels || $scope.displayedFilter.filter.field === 'responseSet';
	}

	function getOperandLabel() {
		return $q.when().then(function () {
			if (!$scope.displayedFilter.filter.operand || !$scope.displayedFilter.filter.operand.length) {
				return $filter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
			}
			if ($scope.displayedFilter.filter.operand.length > 3) {
				return $scope.displayedFilter.filter.operand.length + ' ' + $filter('fcTranslate')('FSFILTERS.SELECTED');
			}
			return getOperands().then(function (menu) {
				return _.chain($scope.displayedFilter.filter.operand).map(function (op) {
					return _.find(menu, {
						value: op
					});
				}).map('label').value().join(', ');
			});
		}).then(setOperandLabel);
	}

	function setOperandLabel(label) {
		$scope.operandLabel = label;
	}

	function onSelection(value, selected) {
		var existingOperand = $scope.displayedFilter.filter.operand || [];
		if (selected) {
			updateFilter(existingOperand.concat([value]));
		} else {
			updateFilter(_.reject(existingOperand, function (val) {
				return val === value;
			}));
		}
	}

	function updateFilter(value) {
		$timeout(function () {
			$scope.operandDisabled = operandDisabled();
			if ($scope.operandDisabled) {
				$scope.displayedFilter.filter.operator = 'present';
				$scope.displayedFilter.filter.operand = $scope.uiOperator === 'isNotEmpty';
			} else {
				$scope.displayedFilter.filter.operator = $scope.uiOperator;
				$scope.displayedFilter.filter.operand = value;
			}
			$rootScope.$broadcast('filterChanged');
		});
	}

	function setupOperators() {
		$scope.operators = getOperators();
		$scope.operatorMenu = _.map(getOperators(true), getMenuItem);
		getOperandLabel();
	}

	function getMenuItem(value, key) {
		return {
			label: $filter('fcTranslate')(value),
			value: key
		};
	}

	function getOperators(ignoreEquals) {
		if (isSet()) {
			return {
				'includesAny': operatorTranslations.includesAny,
				'lacksAll': operatorTranslations.lacksAll,
				'isEmpty': operatorTranslations.isEmpty,
				'isNotEmpty': operatorTranslations.isNotEmpty
			};
		} else {
			var nonSetOperators = {
				'in': operatorTranslations.is,
				'notIn': operatorTranslations.isNot,
				'isEmpty': operatorTranslations.isEmpty,
				'isNotEmpty': operatorTranslations.isNotEmpty
			};
			if (!ignoreEquals) {
				nonSetOperators.equals = operatorTranslations.is;
			}
			return nonSetOperators;
		}
	}

	function isSet() {
		return $scope.typeMap[$scope.type].indexOf('Set') !== -1;
	}

	function operatorToUiOperator() {
		if ($scope.displayedFilter.filter.operator === 'present') {
			return $scope.displayedFilter.filter.operand ? 'isNotEmpty' : 'isEmpty';
		} else {
			return $scope.displayedFilter.filter.operator;
		}
	}

	function operandDisabled() {
		return util.includes(uiOperandBlackList, $scope.uiOperator);
	}
}]);
'use strict';

angular.module('filters-client').controller('fc.FilterController', ['$scope', 'fc.fieldsetViewMenu', 'fc.typeMap', 'fc.filterData', '$filter', 'fc.displayedFilter', 'fc.filteredResponseCount', 'fc.modalService', function ($scope, fieldsetViewMenu, typeMap, filterData, $filter, displayedFilter, filteredResponseCount, modalService) {

	angular.extend($scope, {
		typeMap: typeMap,
		getMenuItems: fieldsetViewMenu.getMenuItems,
		filterChanged: filterChanged,
		fieldChanged: fieldChanged
	});

	activate();

	function activate() {
		//todo are these necessary
		fieldChanged(($scope.displayedFilter && $scope.displayedFilter.filter || {}).field, true);
		$scope.$on('filterChanged', displayedFilter.simpleFilterChanged);
	}

	function fieldChanged(value, firstChange) {

		function afterGetField(field) {

			function fieldHasNameAndIsNotEmbedded(fieldValue) {
				return !fieldValue.meta || !/.*ED.*/.test(fieldValue.meta.fullType) && fieldValue.name;
			}

			if (field) {
				if (fieldHasNameAndIsNotEmbedded(field)) {
					$scope.fieldLabel = field.name + ' - ' + $filter('fcRemoveHTML')(field.description);
				} else {
					$scope.fieldLabel = $filter('fcRemoveHTML')(field.description);
				}

				$scope.type = field.type;
			} else {
				$scope.fieldLabel = $filter('fcTranslate')('FSFILTERS.SELECT_FIELD');
				$scope.type = null;
			}
		}

		filterData.getField(value).then(afterGetField);

		if (!firstChange) {
			if (_.get($scope.displayedFilter, 'filter.operator') === 'isEmptyText') {
				$scope.displayedFilter.filter.field = value;
			} else {
				$scope.displayedFilter.filter = { field: $scope.displayedFilter.filter.field };
			}

			if (!modalService.isManagerFilterModalOpen()) {
				filteredResponseCount.removeFilteredResponseCount();
			}

			filterChanged();
		}
	}

	function filterChanged() {
		$scope.$emit('filterChanged');
	}
}]);
'use strict';

angular.module('filters-client').controller('fc.FiltersModalController', ['$scope', '$filter', 'fc.filterValidator', 'fc.savedFilters', 'fc.displayedFilter', 'fc.fieldsetViewMenu', 'fc.filterStructure', 'fc.filteredResponseCount', 'fc.modalService', '$timeout', 'fc.filterModalChanges', 'fc.messageService', 'fc.sumoService', function ($scope, $filter, filterValidator, savedFilters, displayedFilter, fieldsetViewMenu, filterStructure, filteredResponseCount, modalService, $timeout, filterModalChanges, messageService, sumoService) {

	$scope.saving = false;
	var HEIGHT_ADJUST = 101;
	var treeIsValid = void 0;
	var isCreatingNew = true;
	var currentTempId = 0;
	var allFilterWrappers = void 0;

	$timeout(function () {
		angular.element('.filters-client .filter-modal-body').scroll(function () {
			var top = angular.element('.filters-client .filter-modal-body').scrollTop();
			angular.element('.filters-client .fs-sidebar-section').css('top', top);
		});
	});

	initModal();

	// in the modal, simple filters are displayed as a node in an array of children.
	function initModal() {

		function afterGetSavedFilters(data) {
			allFilterWrappers = data;
			$scope.searchedFilterWrappers = data;
			var currentFilter = displayedFilter.getDisplayedFilter();
			var currentFilterMetaData = displayedFilter.getDisplayedFilterMetadata();

			if (currentFilterMetaData.filterId) {
				// saved filter already exists
				var filterWrapper = _.find(allFilterWrappers, function (filter) {
					return filter.filterId === currentFilterMetaData.filterId;
				});

				$scope.previewFilter(filterWrapper);
			} else if (currentFilter.type) {
				// adhoc filter exists
				var _filterWrapper = getNewFilterWrapper(currentFilter);
				addNewFilter(_filterWrapper);
				$scope.previewFilter(_filterWrapper, true);
				$timeout(focusTitleInput);
			} else {
				if ($scope.searchedFilterWrappers.length) {
					$scope.previewFilter($scope.searchedFilterWrappers[0]);
				} else {
					$scope.noFilters = true;
				}
			}
			isCreatingNew = false;
		}

		savedFilters.getFilters().then(afterGetSavedFilters);

		filteredResponseCount.removeFilteredResponseCount($scope);
	}

	function addNewFilter(filterWrapper) {
		$timeout(function () {
			allFilterWrappers.splice(0, 0, filterWrapper);
			filterModalChanges.addNewFilter(filterWrapper);
		});
	}

	function getTempFilterId() {
		currentTempId += 1;
		return currentTempId;
	}

	function getNewFilterWrapper(filter) {
		return {
			filterName: '',
			filter: filter,
			filterId: getTempFilterId()
		};
	}

	function focusTitleInput() {
		angular.element('.filter-title').focus();
	}

	function orNewFilterText(value) {
		return $filter('fcRemoveHTML')(value) || messageService.get('FSFILTERS.NEW_FILTER');
	}

	function applyFilterAndCloseModal() {
		if (_.isEmpty(allFilterWrappers)) {
			displayedFilter.unapplyFilter();
		} else {
			var filterToApply = $scope.currentFilterWrapper.filter;

			if (filterStructure.canReduceToSimpleFilter($scope.currentFilterWrapper.filter)) {
				filterToApply = $scope.currentFilterWrapper.filter.children[0];
			}

			var filterName = orNewFilterText($scope.currentFilterWrapper.filterName);
			displayedFilter.applyFilter(filterToApply, $scope.currentFilterWrapper.filterId, filterName, $scope.currentFilterWrapper.timezone);
		}

		modalService.closeManageFilters();
	}

	$scope.getMenuItems = fieldsetViewMenu.getMenuItems;

	$scope.searchFilters = function searchFilters(query) {
		if (query.length < 1) {
			$scope.searchedFilterWrappers = allFilterWrappers;
			return;
		}

		$scope.searchedFilterWrappers = _.filter(allFilterWrappers, function (f) {
			return f.filterName.toLowerCase().indexOf(query.toLowerCase()) > -1;
		});
	};

	function deleteFilter(filterId) {
		var index = _.findIndex(allFilterWrappers, function (value) {
			return value.filterId === filterId;
		});

		allFilterWrappers.splice(index, 1);
		filterModalChanges.removeFilter(filterId);

		// if the selected filter was deleted select the first filter or show no filters
		if ($scope.currentFilterWrapper.filterId === filterId) {
			if (!allFilterWrappers.length) {
				filteredResponseCount.removeFilteredResponseCount($scope);
				$scope.noFilters = true;
			} else {
				$scope.previewFilter(allFilterWrappers[0]);
			}
		}

		modalService.closeConfirmDelete();
	}

	$scope.copyFilter = function copyFilter(filterId) {
		var oldFilterWrapper = _.find(allFilterWrappers, function (f) {
			return f.filterId === filterId;
		});

		var newFilterWrapper = {
			filterId: getTempFilterId(),
			filterName: messageService.get('FSFILTERS.FILTER_NAME_COPY', { name: orNewFilterText(oldFilterWrapper.filterName) }),
			filter: angular.copy(oldFilterWrapper.filter),
			timezone: oldFilterWrapper.timezone
		};

		addNewFilter(newFilterWrapper);
		$scope.previewFilter(newFilterWrapper);
	};

	$scope.confirmDeleteFilter = function confirmDeleteFilter(filterId, filterName) {
		modalService.showConfirmDelete(deleteFilter, {
			id: filterId,
			name: filterName
		});
	};

	$scope.saveFilters = function saveFilters() {
		$scope.saving = true;

		var currentFilterId = $scope.currentFilterWrapper && $scope.currentFilterWrapper.filterId;
		filterModalChanges.saveChangesAndStopTracking(currentFilterId).then(function () {
			$scope.saving = false;

			if (!_.isNumber(currentFilterId)) {
				sumoService.logAction('appliedSavedFilter');
			}

			applyFilterAndCloseModal();
		}).catch(function () {
			modalService.closeManageFilters();
			modalService.showWarningModal(messageService.get('FSFILTERS.BREAKOUT_WARNING'), messageService.get('FSFILTERS.BREAKOUT_MESSAGE_ERROR_ON_CLOSE'), messageService.get('FSFILTERS.CLOSE'));
		});
	};

	$scope.previewFilter = function previewFilter(filterWrapper, checkAddChild) {
		filterModalChanges.saveFilterEditsOnSaveAndApply(filterWrapper);
		$scope.currentFilterWrapper = filterWrapper;

		if (filterWrapper.filter.type === 'filter') {
			$scope.currentFilterWrapper.filter = {
				type: 'and',
				children: [filterWrapper.filter]
			};

			if (checkAddChild && $scope.addChild) {
				$scope.currentFilterWrapper.filter.children.push({ type: 'filter', filter: {} });
			}
		}

		$scope.$emit('filterChanged');
	};

	function getNewFilter() {
		return {
			type: 'and',
			children: [{
				type: 'filter',
				filter: {
					field: null
				}
			}]
		};
	}

	$scope.closeModal = function closeModal() {
		if (!$scope.permissions.readOnly && filterModalChanges.haveUnsavedChanges()) {
			modalService.showConfirmCancelWithoutSave();
		} else {
			modalService.closeManageFilters();
		}
	};

	$scope.haveInvalidFilters = function haveInvalidFilters() {
		return _.some(allFilterWrappers, 'isNotValid');
	};

	$scope.$on('filterChanged', function () {
		treeIsValid = filterValidator.isValid($scope.currentFilterWrapper.filter);
		$scope.currentFilterWrapper.isNotValid = !treeIsValid;

		if (treeIsValid) {
			filteredResponseCount.updateFilteredResponseCount($scope.currentFilterWrapper.filter, $scope);
		} else {
			filteredResponseCount.removeFilteredResponseCount($scope);
		}
	});

	$scope.$on('updateTimezone', function (event, timezone) {
		$scope.currentFilterWrapper.timezone = timezone;
	});

	$scope.sideBarHeight = function () {
		return angular.element('.filters-client .filter-modal-body').height() - HEIGHT_ADJUST;
	};

	$scope.createNewFilter = function createNewFilter() {
		isCreatingNew = true;
		$scope.noFilters = false;
		var filterWrapper = getNewFilterWrapper(getNewFilter());
		addNewFilter(filterWrapper);
		$scope.previewFilter(filterWrapper, true);
		$timeout(focusTitleInput).then(function () {
			return isCreatingNew = false;
		});
	};

	$scope.getPlaceHolder = function getPlaceHolder() {
		if (isCreatingNew) {
			return '';
		}

		return messageService.get('FSFILTERS.NEW_FILTER');
	};

	$scope.isTemporaryFilterId = function isTemporaryFilterId(filterId) {
		return _.isNumber(filterId);
	};
}]);

'use strict';

angular.module('filters-client').controller('fc.FreeFormController', ['$scope', 'fc.operators', '$filter', 'rsEnvironment', '$timeout', 'fc.utilService', 'fc.permissionsService', function ($scope, operators, $filter, env, $timeout, util, permissionsService) {

	var operandBlackList = ['isEmpty', 'isNotEmpty'];
	var operatorBlackList = ['contains', 'notContains'];

	angular.extend($scope, {
		uiOperator: operatorToUiOperator(),
		operators: {
			'equals': operators.is,
			'notEquals': operators.isNot,
			'contains': operators.contains,
			'notContains': operators.notContains,
			'isEmpty': operators.isEmpty,
			'isNotEmpty': operators.isNotEmpty
		},
		getOperators: getOperators,
		updateFilter: _.debounce(updateFilter, 200),
		updateOperator: updateOperator
	});
	$scope.operandDisabled = operandDisabled(); // has to be outside of extend since it depends on uiOperator

	function getOperators() {
		return _.chain($scope.operators).map(getOperatorMenuItem).compact().value();
	}

	function getOperatorMenuItem(value, key) {
		return isOperatorBlackListed(key) ? null : {
			value: key,
			label: $filter('fcTranslate')(value)
		};
	}

	function isOperatorBlackListed(key) {
		return permissionsService.getUserPermissions().isBrandEncrypted && util.includes(operatorBlackList, key);
	}

	function updateOperator() {

		$scope.operandDisabled = operandDisabled();

		if (typeof $scope.displayedFilter.filter.operand === 'boolean') {
			$scope.displayedFilter.filter.operand = undefined;
		}

		if ($scope.operandDisabled) {
			$scope.displayedFilter.filter.operator = 'isEmptyText';
			$scope.displayedFilter.filter.operand = $scope.uiOperator === 'isEmpty';
		} else {
			$scope.displayedFilter.filter.operator = $scope.uiOperator;
		}
		updateFilter();
	}

	function operatorToUiOperator() {
		if ($scope.displayedFilter.filter.operator === 'isEmptyText') {
			return $scope.displayedFilter.filter.operand ? 'isEmpty' : 'isNotEmpty';
		} else {
			return $scope.displayedFilter.filter.operator;
		}
	}

	function updateFilter() {
		$timeout(function () {
			$scope.$emit('filterChanged');
		});
	}

	function operandDisabled() {
		return util.includes(operandBlackList, $scope.uiOperator);
	}
}]);
'use strict';

angular.module('filters-client').controller('fc.NestedFiltersController', ['$scope', 'fc.messageService', function ($scope, messageService) {
	var READ_ONLY_FILTERS = {
		'pr-custom-360-all': 0,
		'pr-custom-360-others': 0,
		'pr-custom-360-self': 0
	};

	$scope.filterTypes = {
		or: 'FSFILTERS.ANY_FILTERS',
		and: 'FSFILTERS.ALL_FILTERS'
	};

	$scope.getTypeMenu = function getTypeMenu() {
		// In a fn so we have time to $watch .language and call setLang
		return _.map($scope.filterTypes, function (label, value) {
			return {
				label: messageService.get(label),
				value: value
			};
		});
	};

	$scope.insert = function insert(index) {
		if (!$scope.filter.children) {
			$scope.filter.children = [];
		}
		$scope.filter.children.splice(index + 1, 0, {
			type: 'filter',
			filter: {}
		});

		$scope.$emit('filterChanged');
	};

	$scope.insertNewSet = function insertNewSet() {
		if (!$scope.filter.children) {
			$scope.filter.children = [];
		}
		$scope.filter.children.push({
			type: $scope.filter.type === 'and' ? 'or' : 'and',
			children: [{
				type: 'filter',
				filter: {}
			}]
		});
		$scope.$emit('filterChanged');
	};

	$scope.remove = function remove(index) {
		$scope.filter.children.splice(index, 1);
		if (!$scope.filter.children.length && $scope.parentFilter) {
			$scope.$parent.remove($scope.listIndex);
		} else {
			$scope.$emit('filterChanged');
		}
	};

	$scope.removeList = function removeList(index) {
		$scope.parentFilter.children.splice.apply($scope.parentFilter.children, [index, 1].concat($scope.filter.children));
		$scope.$emit('filterChanged');
	};

	$scope.typeChanged = function typeChanged() {
		$scope.$emit('filterChanged');
	};

	$scope.isReadOnlyCustomFilter = function isReadOnlyCustomFilter(filterId) {
		return filterId in READ_ONLY_FILTERS;
	};
}]);
'use strict';

angular.module('filters-client').controller('fc.ScalarValueController', ['$scope', '$rootScope', 'fc.filterData', 'fc.operators', '$filter', '$q', 'PAGINATION_LIMIT', '$timeout', 'fc.utilService', function ($scope, $rootScope, filterData, operators, $filter, $q, PAGINATION_LIMIT, $timeout, util) {

	var uiOperandBlackList = ['isEmpty', 'isNotEmpty'];

	var operatorMapWithLabels = {
		'in': operators.is,
		'notIn': operators.isNot
	};

	var operatorMap = ['equals', 'notEquals', 'greaterThan', 'greaterThanOrEqualTo', 'lessThan', 'lessThanOrEqualTo', 'isEmpty', 'isNotEmpty'];

	$scope.uiOperator = operatorToUiOperator();

	$scope.pagination = {
		limit: PAGINATION_LIMIT
	};

	$scope.getOperators = function getOperators() {
		var scalarOperators = _.map(operatorMap, function (op) {
			return {
				value: op,
				label: $filter('fcTranslate')(operators[op])
			};
		});

		if (!$scope.hasLabels) {
			return scalarOperators;
		}

		var enumerableOperators = _.map(operatorMapWithLabels, function (label, op) {
			return {
				label: $filter('fcTranslate')(label),
				value: op
			};
		});

		return enumerableOperators.concat([{
			divider: true
		}]).concat(scalarOperators);
	};

	$scope.getOperatorLabel = function getOperatorLabel() {
		return $filter('fcTranslate')(operatorMapWithLabels[$scope.uiOperator] || operators[$scope.uiOperator] || 'FSFILTERS.SELECT_OPERATOR');
	};

	$scope.getOperands = function getOperands(search) {
		return filterData.getFieldValueMenuItems($scope.displayedFilter.filter.field, $scope.hasLabels, search, $scope.displayedFilter.filter.operand);
	};

	$scope.multiSelect = function multiSelect() {
		return operatorMapWithLabels[$scope.uiOperator];
	};

	$scope.updateFilter = function updateFilter(value) {
		$timeout(function () {
			$scope.operandDisabled = operandDisabled();
			if ($scope.operandDisabled) {
				$scope.displayedFilter.filter.operator = 'present';
				$scope.displayedFilter.filter.operand = $scope.uiOperator === 'isNotEmpty';
			} else {
				$scope.displayedFilter.filter.operator = $scope.uiOperator;
				$scope.displayedFilter.filter.operand = value;
			}

			$scope.fireFilterChanged();
		});
	};

	$scope.fireFilterChanged = function fireFilterChanged() {
		$rootScope.$broadcast('filterChanged');
	};

	$scope.getOperandLabel = function getOperandLabel() {
		return $q.when().then(function () {
			if (!$scope.displayedFilter.filter.operand) {
				return $filter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
			} else if (angular.isArray($scope.displayedFilter.filter.operand)) {
				if (!$scope.displayedFilter.filter.operand.length) {
					return $filter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
				}
				if ($scope.displayedFilter.filter.operand.length > 3) {
					return $scope.displayedFilter.filter.operand.length + ' ' + $filter('fcTranslate')('FSFILTERS.SELECTED'); //TODO: translate
				}
				return $scope.getOperands().then(function (menu) {
					return _.chain($scope.displayedFilter.filter.operand).map(function getLabelValueForOperand(op) {
						return _.find(menu, matchesOperand(op));
					}).map('label').value().join(', ');
				});
			} else {
				return $scope.getOperands().then(function (menu) {
					var menuItem = _.find(menu, matchesOperand($scope.displayedFilter.filter.operand));
					return menuItem && menuItem.label;
				});
			}
		}).then(setOperandLabel);
	};

	$scope.onSelection = function onSelection(value, selected) {
		var existingOperand = $scope.displayedFilter.filter.operand || [];
		if (selected) {
			$scope.updateFilter(existingOperand.concat([value]));
		} else {
			$scope.updateFilter(_.reject(existingOperand, function (val) {
				return val === value;
			}));
		}
	};

	$scope.operandDisabled = operandDisabled(); //depends on uiOperator

	activate();

	function activate() {
		$scope.$watch('displayedFilter.filter.field', getHasLabels);
		$scope.$watch('displayedFilter.filter.field', resetUiVariables);
		$scope.$watch('displayedFilter.filter.operand', $scope.getOperandLabel);
	}

	function resetUiVariables() {
		$scope.uiOperator = operatorToUiOperator();
		$scope.operandDisabled = operandDisabled();
	}

	function getHasLabels() {
		filterData.getField($scope.displayedFilter.filter.field).then(setHasLabels);
	}

	function setHasLabels(field) {
		$scope.hasLabels = field.labels;
		$scope.getOperandLabel();
	}

	function setOperandLabel(label) {
		$scope.operandLabel = label;
	}

	function operatorToUiOperator() {
		if ($scope.displayedFilter.filter.operator === 'present') {
			return $scope.displayedFilter.filter.operand ? 'isNotEmpty' : 'isEmpty';
		} else {
			return $scope.displayedFilter.filter.operator;
		}
	}

	function operandDisabled() {
		return util.includes(uiOperandBlackList, $scope.uiOperator);
	}

	function matchesOperand(op) {
		return function (item) {
			return item.value === op || item.value === +op;
		};
	}
}]);
'use strict';
angular.module('filters-client').directive('fc.customFilter', ['$rootScope', '$filter', 'fc.customFilterService', function ($rootScope, $filter, customFilterService) {
	return {
		template: '<ng-include src="template()"></ng-include>',
		link: function link($scope, $element, $attrs) {
			customFilterService.linkDirective($rootScope, $filter, $scope, $element, $attrs);
		}
	};
}]);
/* globals moment: true */
/* SEE type-map.js FOR FILTERS THAT USE THIS FILE */
'use strict';

angular.module('filters-client').directive('fc.dateValue', ['fc.operators', '$filter', 'rsEnvironment', '$log', 'fc.utilService', function (operatorTranslations, $filter, rsEnvironment, $log, util) {
	return {
		scope: {
			// timezone used when setting up filters, might be different than
			// current users timezone
			timezone: '='
		},
		require: '^ngModel',
		templateUrl: 'templates/fc-date-value.html',
		link: function link($scope, elem, attr, ngModelCtrl) {
			var configuredTimezone = $scope.timezone;
			var defaultDates = ['recordedDate', 'endDate', 'startDate'];

			if (!ngModelCtrl) {
				return;
			}

			ngModelCtrl.$render = render;
			ngModelCtrl.$formatters.push(formatter);
			ngModelCtrl.$parsers.push(parser);

			angular.extend($scope, {
				operatorTranslations: operatorTranslations,
				getOperatorMenu: getOperatorMenu,
				isSingleDate: isSingleDate,
				isMultipleDate: isMultipleDate,
				updateViewValue: updateViewValue,
				getMinDate: getMinDate,
				getMaxDate: getMaxDate,
				getTimezoneKeyForDatePicker: getTimezoneKeyForDatePicker
			});

			function getTimezoneKeyForDatePicker() {
				return shouldApplyTimezone(ngModelCtrl.$modelValue.field) ? getTimezone() : 'UTC';
			}

			function render() {
				$scope.vm = {};
				angular.extend($scope.vm, ngModelCtrl.$viewValue);
			}

			var DEFAULT_TIMEZONE = 'America/Denver';

			function getTimezone() {
				var user = rsEnvironment.get('user') || {};
				return user.timezone || DEFAULT_TIMEZONE;
			}

			function shouldApplyTimezone(fieldId) {
				return _.includes(defaultDates, fieldId);
			}

			function generateDate(date, timezone, fieldId, invert) {
				var browserTime = moment.tz.guess();
				if (shouldApplyTimezone(fieldId)) {
					if (invert) {
						return moment.tz(moment.tz(date, browserTime).format('YYYY-MM-DD'), timezone).toJSON();
					} else {
						return moment.tz(moment.tz(date, timezone).format('YYYY-MM-DD'), browserTime).toJSON();
					}
				} else {
					date = new Date(date);
					date.setUTCHours(0, 0, 0, 0);
					return date.toISOString();
				}
			}

			function generateDateUpperBound(date, timezone, fieldId) {
				var browserTime = moment.tz.guess();
				if (shouldApplyTimezone(fieldId)) {
					return moment.tz(moment.tz(date, timezone).format('YYYY-MM-DD'), browserTime).toJSON();
				} else {
					date = new Date(date);
					return date.toISOString();
				}
			}

			function formatter(modelValue) {
				if (modelValue.dateRange) {
					return {
						operator: getDateRangeOperator(modelValue)
					};
				}
				var timezone = $scope.timezone || getTimezone();
				if (angular.isArray(modelValue.operand)) {

					// Bootstrap will parse the date in local timezone so get the selected date into to local timezone so it displays corredtly
					// The stored timezone/value is where the filter was set, but display that date according to user timezone rather than local timezone
					var startDate = modelValue.operand[0] ? generateDate(modelValue.operand[0], timezone, modelValue.field, false) : undefined;
					var endDate = modelValue.operand[1] ? generateDateUpperBound(modelValue.operand[1], timezone, modelValue.field) : undefined;

					return {
						operator: 'between',
						dateValue: subtractDate(0, startDate),
						beforeDate: subtractDate(0, endDate)
					};
				}

				var dateOperand = modelValue.operand ? generateDate(modelValue.operand, timezone, modelValue.field, false) : undefined;
				return {
					operator: modelValue.operator,
					dateValue: dateOperand
				};
			}

			function parser(viewValue) {
				// viewValues get set by bootstrap with the system timezone
				// But we want the selected date in the user's account timezone
				// To do this, just parse the date on the selected dateTime and use moment-timezone to get it in the specified timezone
				var timezone = getTimezone();

				if (timezone !== configuredTimezone) {
					$scope.$emit('updateTimezone', timezone);
				}

				if (isSingleDate()) {
					var selectedDate = viewValue.dateValue ? generateDate(viewValue.dateValue, timezone, ngModelCtrl.$modelValue.field, true) : undefined;

					return {
						field: ngModelCtrl.$modelValue.field,
						operator: viewValue.operator,
						operand: viewValue.operator === 'after' && selectedDate ? addDate(1, selectedDate) : selectedDate
					};
				}
				if (isMultipleDate()) {
					var startDate = viewValue.dateValue ? generateDate(viewValue.dateValue, timezone, ngModelCtrl.$modelValue.field, true) : undefined;
					// Before date refers to all responses before a certain date
					var endDate = viewValue.beforeDate ? generateDate(viewValue.beforeDate, timezone, ngModelCtrl.$modelValue.field, true) : undefined;

					return {
						field: ngModelCtrl.$modelValue.field,
						operator: viewValue.operator,
						operand: [startDate, addDate(1, endDate)]
					};
				}
				return {
					field: ngModelCtrl.$modelValue.field,
					dateRange: getModelDateRange(viewValue)
				};
			}

			function getMinDate() {
				return subtractDate(0, $scope.vm.dateValue);
			}

			function getMaxDate() {
				return subtractDate(0, $scope.vm.beforeDate);
			}

			function getModelDateRange(viewValue) {
				var timeZoneOffset = getTimezoneOffset();
				switch (viewValue.operator) {
					case 'today':
						return {
							type: 'relative',
							period: 'day',
							amount: 0,
							timeZoneOffset: timeZoneOffset
						};
					case 'yesterday':
						return {
							type: 'rolling',
							period: 'day',
							amount: 0,
							adjustPeriod: 'day',
							adjustAmount: 1,
							timeZoneOffset: timeZoneOffset
						};
					case 'last7Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 6,
							timeZoneOffset: timeZoneOffset
						};
					case 'last14Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 13,
							timeZoneOffset: timeZoneOffset
						};
					case 'last30Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 29,
							timeZoneOffset: timeZoneOffset
						};
					case 'last60Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 59,
							timeZoneOffset: timeZoneOffset
						};
					case 'last120Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 119,
							timeZoneOffset: timeZoneOffset
						};
					case 'last365Days':
						return {
							type: 'rolling',
							period: 'day',
							amount: 364,
							timeZoneOffset: timeZoneOffset
						};
					case 'thisMonth':
						return {
							type: 'relative',
							period: 'month',
							amount: 0,
							timeZoneOffset: timeZoneOffset
						};
				}
			}

			function getDateRangeOperator(modelValue) {
				if (modelValue.dateRange.period === 'month') {
					return 'thisMonth';
				}
				if (modelValue.dateRange.amount === 6) {
					return 'last7Days';
				}
				if (modelValue.dateRange.amount === 13) {
					return 'last14Days';
				}
				if (modelValue.dateRange.amount === 29) {
					return 'last30Days';
				}
				if (modelValue.dateRange.amount === 59) {
					return 'last60Days';
				}
				if (modelValue.dateRange.amount === 119) {
					return 'last120Days';
				}
				if (modelValue.dateRange.amount === 364) {
					return 'last365Days';
				}
				if (modelValue.dateRange.adjustPeriod === 'day') {
					return 'yesterday';
				}
				if (modelValue.dateRange.amount === 0) {
					return 'today';
				}
				return {};
			}

			function getOperatorMenu() {
				var relatives = _.map(['today', 'yesterday', 'last7Days', 'last14Days', 'last30Days', 'last60Days', 'last120Days', 'last365Days', 'thisMonth'], getOperatorMenuItem);
				var nonRelatives = _.map(['before', 'between', 'after'], getOperatorMenuItem);
				return relatives.concat([{
					divider: true
				}]).concat(nonRelatives);
			}

			function getOperatorMenuItem(operator) {
				return {
					label: $filter('fcTranslate')(operatorTranslations[operator]),
					value: operator
				};
			}

			function isSingleDate() {
				return util.includes(['before', 'after'], $scope.vm.operator);
			}

			function isMultipleDate() {
				return $scope.vm.operator === 'between';
			}

			function updateViewValue() {
				ngModelCtrl.$setViewValue(angular.extend({}, $scope.vm));
			}

			function getTimezoneOffset() {
				var timezone = getTimezone();
				if (timezone) {
					return moment().tz(timezone).format('Z');
				}
				$log.error('no timezone define on the env');
			}

			function subtractDate(days, date) {
				if (date) {
					return moment(new Date(date)).subtract(days, 'd').toJSON();
				}
			}

			function addDate(days, date) {
				if (date) {
					return moment(new Date(date)).add(days, 'd').subtract(1, 'milliseconds').toJSON();
				}
			}
		}
	};
}]);

'use strict';

angular.module('filters-client').directive('fc.enumerableValue', [function () {
	return {
		templateUrl: 'templates/fc-enumerable-value.html',
		controller: 'fc.EnumerableValueController'
	};
}]);
'use strict';

angular.module('filters-client').directive('fc.filter', [function () {
	return {
		scope: {
			displayedFilter: '=',
			permissions: '<',
			timezone: '='
		},
		templateUrl: 'templates/fc-filter.html',
		controller: 'fc.FilterController'
	};
}]);

'use strict';

////////////////
// This directive wraps qstrap.menu to provide
// a new callback for individual element selection.
// This is because, as of qstrap 5.35.x, there is a bug
// with searchable menus where the value passed back in the
// action function does not acurately describe the actual
// selected values. Giving a callback for selections allows
// dependencies to manage their own list of selected values.
angular.module('filters-client').directive('fc.qmenu', ['qstrap.$menu', function (QMenu) {

	return {
		scope: {
			items: '&?',
			action: '&',
			selectMenu: '@?',
			multiSelectMenu: '@?',
			className: '@?',
			updateButton: '@?',
			searchable: '@?',
			filterable: '@?',
			pagination: '=',
			_searchCallback: '&searchCallback',
			localizedText: '=?',
			onOpen: '&?',
			onClose: '&?',
			afterChange: '&?',
			showEvent: '@?',
			onSelection: '&'
		},
		link: function link($scope, element, attrs) {
			if (!attrs.items) {
				delete $scope.items;
			}
			if (attrs.searchCallback) {
				$scope.searchCallback = function (search, limit, offset) {
					return $scope._searchCallback({
						$search: search,
						$limit: limit,
						$offset: offset
					});
				};
			}
			var action = $scope.action;
			$scope.action = function (value, item, evt) {
				var qmenuItem = $(evt.currentTarget).data('q.qmenu.itemInfo').item;
				$scope.onSelection({
					$value: qmenuItem.value,
					selected: qmenuItem.selected
				});
				action({
					$value: value,
					$item: item,
					$event: evt
				});
				$scope.$apply();

				if ($scope.afterChange) {
					$scope.afterChange({
						$value: value,
						$item: item,
						$event: evt
					});
				}
			};

			element.data('q.qmenu', new QMenu(element, $scope));
		}
	};
}]);
/* SEE type-map.js FOR FILTERS THAT USE THIS FILE */
'use strict';

angular.module('filters-client').directive('fc.freeForm', [function () {
	return {
		templateUrl: 'templates/fc-free-form.html',
		controller: 'fc.FreeFormController'
	};
}]);
'use strict';

angular.module('filters-client').directive('ngMin', ['fc.utilService', function (utilService) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function link(scope, elem, attr, ctrl) {
			scope.$watch(attr.ngMin, function () {
				ctrl.$setViewValue(ctrl.$viewValue);
			});
			var minValidator = function minValidator(value) {
				var min = scope.$eval(attr.ngMin) || 0;
				if (!utilService.isEmpty(value) && value < min) {
					ctrl.$setValidity('ngMin', false);
				} else {
					ctrl.$setValidity('ngMin', true);
				}
				return value;
			};

			ctrl.$parsers.push(minValidator);
			ctrl.$formatters.push(minValidator);
		}
	};
}]).directive('ngMax', ['fc.utilService', function (utilService) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function link(scope, elem, attr, ctrl) {
			scope.$watch(attr.ngMax, function () {
				ctrl.$setViewValue(ctrl.$viewValue);
			});
			var maxValidator = function maxValidator(value) {
				var max = scope.$eval(attr.ngMax) || 0;
				if (!utilService.isEmpty(value) && value > max) {
					ctrl.$setValidity('ngMax', false);
				} else {
					ctrl.$setValidity('ngMax', true);
				}
				return value;
			};

			ctrl.$parsers.push(maxValidator);
			ctrl.$formatters.push(maxValidator);
		}
	};
}]);
'use strict';

angular.module('filters-client').directive('fc.nestedFilter', [function () {
	return {
		restrict: 'A',
		scope: {
			timezone: '=',
			filterId: '=',
			parentFilter: '=',
			filter: '=',
			listIndex: '=',
			permissions: '='
		},
		templateUrl: 'templates/fc-nested-filter.html',
		controller: 'fc.NestedFiltersController'
	};
}]);

'use strict';

angular.module('filters-client').directive('fc.numberFormatter', function () {
	return {
		require: 'ngModel',
		link: function link(scope, element, attrs, ngModel) {
			ngModel.$formatters.push(function (value) {
				return _.isArray(value) ? parseFloat(value[0]) : parseFloat(value);
			});

			ngModel.$formatters.unshift(function (value) {
				return parseFloat(value);
			});
		}
	};
});
/* SEE type-map.js FOR FILTERS THAT USE THIS FILE */
'use strict';

angular.module('filters-client').directive('fc.scalarValue', [function () {
	return {
		templateUrl: 'templates/fc-scalar-value.html',
		controller: 'fc.ScalarValueController'
	};
}]);
'use strict';

angular.module('filters-client').filter('fcRemoveHTML', [function () {
	return function (input) {
		var htmlMatch = /<(?:.|\n)*?>/gm;

		return (input || '').toString().replace(htmlMatch, '');
	};
}]);
'use strict';

angular.module('filters-client').filter('fcTranslate', ['fc.messageService', function (msgSvc) {
	return function (key, option) {
		if (typeof key === 'number') {
			return key;
		} else {
			return msgSvc.get(key, option);
		}
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.appliedFilter', ['fc.savedFilters', 'fc.filterValidator', 'fc.filteredResponseCount', '$q', function (savedFilters, filterValidator, filteredResponseCount, $q) {

	var appliedFilterMetadata = {};
	var appliedFilter = void 0; // modify fields within this object without changing reference
	var hostFilterChanged = void 0;

	function applyValidFilterOrSetEmpty(filter) {
		if (filterValidator.isValid(filter)) {
			applyFilter(angular.copy(filter));
		} else {
			setEmptyFilter();
		}
	}

	function init(filterChanged, hostFilter) {
		function setFilterBodyIfNotSuccessful(wasSuccessful) {
			if (!wasSuccessful) {
				delete filterCopy.filterId;

				applyValidFilterOrSetEmpty(filterCopy);
			}
		}

		var filterCopy = void 0;

		hostFilter = hostFilter || {};

		if (hostFilter && hostFilter.children && hostFilter.children.length === 1) {
			hostFilter.filter = hostFilter.children[0].filter;
			hostFilter.type = 'filter';
			delete hostFilter.children;
		}

		appliedFilter = hostFilter;
		hostFilterChanged = filterChanged;
		if (hostFilter && hostFilter.filterId) {
			// so manage filters doesn't flash while waiting for filterName to be retrieved
			filterCopy = angular.copy(appliedFilter);
			setEmptyFilter();
			return applyFilterById(hostFilter.filterId).then(setFilterBodyIfNotSuccessful);
		} else {
			return $q.when(applyValidFilterOrSetEmpty(appliedFilter));
		}
	}

	function applyFilterById(filterId) {

		function applyFilterIfFoundReturnResult(wrappedFilters) {
			var wrappedFilter = _.chain(wrappedFilters).filter(function (savedFilter) {
				return savedFilter.filterId === filterId;
			}).head().value();

			if (_.has(wrappedFilter, 'filter') && filterValidator.isValid(wrappedFilter.filter)) {
				applyFilter(wrappedFilter.filter, wrappedFilter.filterId, wrappedFilter.filterName, wrappedFilter.timezone);

				return true;
			}

			return false;
		}

		return savedFilters.getFilters().then(applyFilterIfFoundReturnResult);
	}

	function applyFilter(filter, filterId, name, timezone) {
		// assumes filter is valid
		var children = angular.copy(filter.children);

		_.extend(appliedFilter, {
			type: filter.type,
			filter: filter.filter,
			children: null // to prevent circular structure
		});

		appliedFilter.children = children;

		_.extend(appliedFilterMetadata, {
			filterId: filterId,
			timezone: timezone,
			name: name
		});

		_.extend(appliedFilter, appliedFilterMetadata);

		filteredResponseCount.updateFilteredResponseCount(appliedFilter);
		hostFilterChanged({ filters: appliedFilter });
	}

	function unapplyFilter() {
		setEmptyFilter();
		filteredResponseCount.removeFilteredResponseCount();
		hostFilterChanged({});
	}

	function setEmptyFilter() {
		_.extend(appliedFilter, {
			type: null,
			filter: null,
			children: null
		});

		_.extend(appliedFilterMetadata, {
			filterId: null,
			name: null,
			timezone: null
		});
	}

	function getAppliedFilter() {
		return appliedFilter;
	}

	function getAppliedFilterMetadata() {
		return appliedFilterMetadata;
	}

	return {
		init: init,
		applyFilterById: applyFilterById,
		applyFilter: applyFilter,
		unapplyFilter: unapplyFilter,
		getAppliedFilter: getAppliedFilter,
		getAppliedFilterMetadata: getAppliedFilterMetadata
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.customFilterService', [function () {
	var service = {};
	function getFunction(funcName, defaultVal) {
		return function () {
			if (_.isFunction((service || {})[funcName])) {
				try {
					return service[funcName].apply(service, arguments);
				} catch (error) {
					console.error('Error calling custom method', error);
					return defaultVal;
				}
			} else {
				return defaultVal;
			}
		};
	}
	return {
		register: function register(methods) {
			if (_.isObject(methods)) {
				_.assign(service, methods);
			} else {
				console.error('Must register with an object. Instead got', methods);
			}
		},
		reset: function reset() {
			service = {};
		},
		getFilters: getFunction('getFilters', []),
		updateFilters: getFunction('updateFilters'),
		isCustomFilter: getFunction('isCustomFilter', false),
		isCustomFilterId: getFunction('isCustomFilterId', false),
		linkDirective: getFunction('linkDirective')
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.displayedFilter', ['fc.filterValidator', 'fc.appliedFilter', 'fc.modalService', function (filterValidator, appliedFilter, modalService) {

	var displayedFilter = {};
	var displayedFilterMetadata = {}; // modify fields within this object without changing reference

	function simpleFilterChanged() {
		if (!modalService.isManagerFilterModalOpen() && filterValidator.isValid(displayedFilter)) {
			appliedFilter.applyFilter(displayedFilter);
		}
	}

	function init() {
		displayedFilter = appliedFilter.getAppliedFilter();
		displayedFilterMetadata = appliedFilter.getAppliedFilterMetadata();
	}

	function applyFilterById(filterId) {
		appliedFilter.applyFilterById(filterId);
		init();
	}

	function applyFilter(filter, filterId, name, timezone) {
		appliedFilter.applyFilter(filter, filterId, name, timezone);
		init();
	}

	function unapplyFilter() {
		appliedFilter.unapplyFilter();
		init();
	}

	function getDisplayedFilter() {
		return displayedFilter;
	}

	function getDisplayedFilterMetadata() {
		return displayedFilterMetadata;
	}

	function hasValidFilterApplied() {
		return !!(displayedFilterMetadata && displayedFilterMetadata.filterId && displayedFilter && displayedFilter.type);
	}

	function buildSimpleFilterWithField(field) {
		displayedFilter.type = 'filter';
		displayedFilter.filter = {
			field: field
		};
	}

	return {
		init: init,
		simpleFilterChanged: simpleFilterChanged,
		applyFilterById: applyFilterById,
		applyFilter: applyFilter,
		unapplyFilter: unapplyFilter,
		getDisplayedFilter: getDisplayedFilter,
		getDisplayedFilterMetadata: getDisplayedFilterMetadata,
		hasValidFilterApplied: hasValidFilterApplied,
		buildSimpleFilterWithField: buildSimpleFilterWithField
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.fieldsetService', ['rsFieldsetsV2', 'rsEnvironment', function (rsFieldsetsV2, env) {
	var fieldset = {};

	var FIELDSET_PROPS = ['fieldSetLabels', 'fieldSetId', 'snapshotId', 'contextMeta'];

	function init(_fieldset) {
		_.forEach(FIELDSET_PROPS, function (prop) {
			if (!_fieldset[prop]) {
				throw new Error('Fieldset missing required properties');
			}
		});

		fieldset = angular.copy(_fieldset);
	}

	function getFieldsetLabels() {
		return fieldset.fieldSetLabels;
	}

	function getFieldsetView() {
		return fieldset.fieldSetView;
	}

	function getFieldsetId() {
		return fieldset.fieldSetId;
	}

	function getSnapshotId() {
		return fieldset.snapshotId;
	}

	function getFieldDomain(fieldId) {
		if (!fieldset.fields[fieldId]) {
			throw new Error('Field "' + fieldId + '" does not exist in the fieldset');
		} else {
			return fieldset.fields[fieldId].domain || [];
		}
	}

	function getSurveyId() {
		return fieldset.contextMeta.sourceSurveyId;
	}

	function getAggregate(metrics, breakouts, filter) {
		var requestOptions = {
			snapshotId: getSnapshotId()
		};

		return rsFieldsetsV2.getAggregate(getFieldsetId(), metrics, breakouts, filter, requestOptions);
	}

	return {
		init: init,
		getFieldsetLabels: getFieldsetLabels,
		getFieldsetId: getFieldsetId,
		getSnapshotId: getSnapshotId,
		getSurveyId: getSurveyId,
		getFieldDomain: getFieldDomain,
		getFieldsetView: getFieldsetView,
		getAggregate: getAggregate
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.fieldsetViewMenu', ['fc.filterMenu', 'fc.fieldsetService', 'fc.permissionsService', function (filterMenu, fieldsetService, permissionsService) {

	function getMenuItems(displayedSavedFilter) {
		var permissions = permissionsService.getUserPermissions();
		var fieldsetView = fieldsetService.getFieldsetView();
		return filterMenu.getMenu(fieldsetView, permissions.viewPersonalData, displayedSavedFilter);
	}

	return {
		getMenuItems: getMenuItems
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.filterData', ['fc.responseValues', '$filter', '$q', 'PAGINATION_LIMIT', 'fc.utilService', 'fc.fieldsetService', function (responseValues, $filter, $q, PAGINATION_LIMIT, util, fieldsetService) {
	var flattenDeepFunc = parseInt(_.VERSION[0]) < 3 ? _.flatten : _.flattenDeep;

	function getField(id) {
		if (!id) {
			return $q.when();
		}

		return $q.when(findById());

		function findById() {
			var fieldsetView = fieldsetService.getFieldsetView();
			var fieldOrChildren = _.map(fieldsetView, getFieldOrChildren);
			var flattened = flattenDeepFunc(fieldOrChildren);

			return _.find(flattened, idMatches);
		}

		function idMatches(field) {
			return field.fieldId === id;
		}
	}

	function extractFieldset(data) {
		return data.definition || data;
	}

	function getAggregateValues(aggregate) {
		return aggregate.values;
	}

	function getFieldOrChildren(fieldView) {
		return fieldView.fields ? _.map(fieldView.fields, getFieldOrChildren) : fieldView;
	}

	function getFieldValueMenuItems(fieldId, useLabels, search, items) {
		var domain = fieldsetService.getFieldDomain(fieldId);
		var getLabelOrValues = domain.length ? $q.when(getDomainOrLabels(domain)) : responseValues.getUniqueValues(fieldsetService.getFieldsetId(), fieldId);

		return getLabelOrValues.then(buildValueMenu);

		function getDomainOrLabels(domain) {
			if (!useLabels) {
				return domain;
			}
			var labels = fieldsetService.getFieldsetLabels();
			if (!labels) {
				return domain;
			}
			var translatedLabels = labels.languages && labels.languages[labels.default] || labels;
			if (!translatedLabels || !translatedLabels[fieldId]) {
				return domain;
			}
			return _.map(domain, getTranslatedLabel);

			function getTranslatedLabel(domainValue) {
				return {
					translatedValue: translatedLabels[fieldId][domainValue],
					domainValue: domainValue
				};
			}
		}

		function menuItemSort(item) {
			if (useLabels) {
				return item.value;
			} else {
				return item.label;
			}
		}

		function buildValueMenu(values) {
			var chain = _.chain(values).without(null).map(getMenuItem).compact();

			if (values.length <= PAGINATION_LIMIT) {
				chain = chain.sortBy(menuItemSort);
			}

			var items = chain.value();

			if (items.length) {
				if (useLabels) {
					return items;
				}
				var header = [{
					header: true,
					label: $filter('fcTranslate')('FSFILTERS.SELECT_ONE_OR_MORE_FIELDS')
				}, {
					divider: true
				}];

				return header.concat(items);
			}
			return [{
				label: $filter('fcTranslate')('FSFILTERS.NO_AVAILABLE_FIELDS'),
				disabled: true
			}];
		}

		function getMenuItem(value) {
			var item;
			if (useLabels) {
				item = {
					label: $filter('fcRemoveHTML')(value.domainValue + ' - ' + value.translatedValue),
					value: value.domainValue
				};
			} else {
				item = {
					label: value,
					value: value
				};
			}
			if (items && util.includes(items, item.value)) {
				item.selected = true;
			}

			if (angular.isString(search)) {
				if (item.label.toLowerCase().indexOf(search.toLowerCase()) === -1) {
					return;
				}
			}
			return item;
		}
	}

	return {
		getFieldValueMenuItems: getFieldValueMenuItems,
		getField: getField
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.filterMenu', ['$filter', 'rsEnvironment', 'fc.savedFilters', 'fc.utilService', function ($filter, env, savedFilters, util) {

	var fieldIdBlackList = ['progress', 'locationLatitude', 'locationLongitude'];
	var personalFields = ['ipAddress', 'recipientLastName', 'recipientFirstName', 'recipientEmail', 'externalDataReference', 'locationLatitude', 'locationLongitude', 'locationAccuracy', 'IpAddress', 'RecipientLastName', 'RecipientFirstName', 'RecipientEmail', 'ExternalDataReference', 'LocationLatitude', 'LocationLongitude', 'LocationAccuracy'];
	var fieldTypeBlackList = ['Geometry'];
	var metaKeys = ['startDate', 'endDate', 'status', 'ipAddress', 'duration', 'finished', 'recordedDate', 'responseSetName', '_cachedDate', '_recordId', 'responseSet', 'userLanguage'];
	var contactKeys = ['distributionChannel', 'externalDataReference', 'recipientLastName', 'recipientFirstName', 'recipientEmail'];
	var getSubMenuTypes = {
		MCNPS: getNPSSubMenu,
		MetaBrowser: getSimpleSubMenu,
		FileUploadFileUpload: getSimpleSubMenu,
		TimingPageTimer: getSimpleSubMenu,
		FileUpload: getSimpleSubMenu,
		Timing: getSimpleSubMenu
	};
	var translate = $filter('fcTranslate');

	function getMenu(fieldsetView, canViewPersonalData, withSavedFilters) {
		var views = canViewPersonalData ? fieldsetView : _.reject(fieldsetView, isPersonalField);

		var metaItems = _.filter(views, isMetaField);
		var contactItems = _.filter(views, isContactField);

		var nonMetaItems = _.reject(views, isMetaField);

		var additionalSubmenus = _.filter(views, isSubmenu);

		var embeddedData = _.chain(nonMetaItems).reject(isContactField).reject(isSubmenu).filter(isEmbedded).value();

		var nonContactItems = _.chain(nonMetaItems).reject(isEmbedded).reject(isSubmenu).reject(isBlackListed).value();

		var subMenus = [];

		if (metaItems.length) {
			subMenus.push({
				label: translate('FSFILTERS.SURVEY_METADATA'),
				submenu: {
					items: getSimpleMenu(metaItems)
				}
			});
		}

		if (contactItems.length) {
			subMenus.push({
				label: translate('FSFILTERS.CONTACT_FIELDS'),
				submenu: {
					items: getSimpleMenu(contactItems)
				}
			});
		}

		if (embeddedData.length) {
			subMenus.push({
				label: translate('FSFILTERS.EMBEDDED_DATA'),
				submenu: {
					items: getSimpleMenu(embeddedData)
				}
			});
		}

		if (additionalSubmenus.length) {
			_.map(additionalSubmenus, function (menu) {
				subMenus.push(getMenuItem(menu));
			});
		}

		if (!subMenus.length && !withSavedFilters) {
			return getSimpleMenu(nonContactItems);
		}

		if (subMenus.length) {
			subMenus.push({
				divider: true
			});
		}

		if (withSavedFilters) {
			return savedFilters.getFilters().then(function (filtersData) {
				//for now until caching happens
				var savedFilterItems = _.chain(filtersData).map(getFilterMenuItem).value();

				var filterItems = [{
					label: translate('FSFILTERS.MANAGE_FILTERS_ELLIPSIS'),
					value: { menuItemType: 'manageFilters' }
				}];

				if (savedFilterItems.length) {
					filterItems = filterItems.concat({ divider: true }, savedFilterItems);
				}

				subMenus.unshift({
					label: translate('FSFILTERS.SAVED_FILTERS'),
					submenu: {
						items: filterItems
					}
				}, {
					divider: true
				});

				return subMenus.concat(getSimpleMenu(nonContactItems));
			});
		}

		return subMenus.concat(getSimpleMenu(nonContactItems));
	}

	function isMetaField(fieldView) {
		return util.includes(metaKeys, fieldView && fieldView.fieldId);
	}

	function isContactField(fieldView) {
		return util.includes(contactKeys, fieldView && fieldView.fieldId);
	}

	function isEmbedded(fieldView) {
		if (fieldView.meta && fieldView.meta.fullType && !isBlackListed(fieldView)) {
			return util.includes(fieldView.meta.fullType, 'ED');
		}
		return false;
	}

	function isPersonalField(fieldView) {
		return util.includes(personalFields, fieldView && fieldView.fieldId);
	}

	function isSubmenu(fieldView) {
		return _.get(fieldView, 'meta.fullType') === 'Submenu';
	}

	function getSimpleMenu(fieldsetView) {

		return _.chain(fieldsetView).compact().reject(isBlackListed).map(getMenuItem).value();
	}

	function isBlackListed(fieldView) {
		return util.includes(fieldIdBlackList, fieldView.fieldId) || util.includes(fieldTypeBlackList, fieldView.type);
	}

	function getMenuItem(fieldView) {
		var label;
		if (!fieldView) {
			throw 'fieldView required to get menu item';
		}
		if (!fieldView.fields) {
			label = fieldView.description !== '' ? fieldView.description : fieldView.name;
			if (!isEmbedded(fieldView) && !isMetaField(fieldView) && fieldView.name && fieldView.meta) {
				label = fieldView.name + ' - ' + label;
			}
			return {
				label: label,
				value: fieldView.fieldId
			};
		}
		var fullType = fieldView.meta && fieldView.meta.fullType;
		//simple sub menu for all non root level field groups
		var getSubMenu = fullType ? getSubMenuTypes[fullType] || defaultGetSubMenu : getSimpleSubMenu;
		label = fieldView.description;
		if (!isEmbedded(fieldView) && !isMetaField(fieldView) && fieldView.name && fieldView.meta) {
			label = fieldView.name + ' - ' + label;
		}
		return {
			label: label,
			submenu: {
				items: getSubMenu(fieldView)
			}
		};
	}

	function defaultGetSubMenu(fieldView) {
		return _.chain(fieldView.fields).compact().groupBy('type').map(function (group, type) {

			var label;
			if (type === 'FreeFormText') {
				label = translate('FSFILTERS.TEXT');
			} else if ((fieldView.meta || {}).fullType === 'TEFORM' && type === 'ScalarValue') {
				label = translate('FSFILTERS.NUMERIC_VALUE');
			} else {
				label = translate('FSFILTERS.CHOICES');
			}

			var exemptFields = ['FreeFormText', 'FieldGroup', 'PersonMetadata'];
			if ((fieldView.meta || {}).fullType !== 'TEFORM' && !_.includes(exemptFields, type) && group.length === 1) {
				return [{
					label: translate('FSFILTERS.SELECTED_CHOICE'),
					value: group[0].fieldId
				}, {
					divider: true
				}];
			}
			return [{
				label: label,
				header: true
			}].concat(getSimpleMenu(group));
		}).flatten().value();
	}

	function getNPSSubMenu(fieldView) {
		return _.chain(fieldView.fields).compact().map(getNPSMenuItem).value();
	}

	function getNPSMenuItem(field) {
		var label = /NPS_GROUP/.test(field.fieldId) ? translate('FSFILTERS.NPS_GROUP') : translate('FSFILTERS.NUMERIC_VALUE');
		return {
			label: label,
			value: field.fieldId
		};
	}

	function getFilterMenuItem(filter) {
		return {
			label: filter.filterName,
			value: {
				menuItemType: 'filter',
				id: filter.filterId,
				name: filter.filterName,
				timezone: filter.timezone
			}
		};
	}

	function getSimpleSubMenu(fieldView) {
		return getSimpleMenu(fieldView.fields);
	}

	return {
		getMenu: getMenu,
		getMenuItem: getMenuItem
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.filterModalChanges', ['fc.savedFilters', '$q', '$filter', 'fc.filterStructure', 'fc.messageService', 'fc.sumoService', 'fc.fieldsetService', 'fc.customFilterService', function (savedFilters, $q, $filter, filterStructure, messageService, sumoService, fieldsetService, customFilterService) {
	var newFilters = [],
	    filtersToRemove = [],
	    filtersToEdit = {};

	function addNewFilter(filterWrapper) {
		newFilters.push(filterWrapper);
	}

	function removeFilter(filterId) {
		var newFilterIndex = findIndexOfFilter(newFilters, filterId);

		if (newFilterIndex !== -1) {
			newFilters.splice(newFilterIndex, 1);
		} else {

			if (filtersToEdit[filterId]) {
				delete filtersToEdit[filterId];
			}

			if (!_.isNumber(filterId)) {
				filtersToRemove.push(filterId);
			}
		}
	}

	function findIndexOfFilter(filters, filterId) {
		return _.findIndex(filters, function (filter) {
			return filter.filterId === filterId;
		});
	}

	function scrubNewFilter(filterWrapper) {
		if (_.get(filterWrapper, 'filter.children', undefined)) {
			filterWrapper.filter.children = _.map(filterWrapper.filter.children, function (childFilter) {
				return _.pick(childFilter, ['filter', 'type', 'children']);
			});
		}
		return _.pick(filterWrapper, ['filterName', 'filter', 'timezone']);
	}

	function ensureFilterNames(filter) {
		filter.filterName = $filter('fcRemoveHTML')(filter.filterName) || messageService.get('FSFILTERS.NEW_FILTER');
	}

	function getChangedFilters() {
		var changedFilters = [];

		_.forOwn(filtersToEdit, function (value) {
			if (!filterStructure.areFiltersEqual(_.omit(value.currentFilter, 'isNotValid'), value.originalFilter)) {
				changedFilters.push({
					filterName: value.currentFilter.filterName,
					filterId: value.currentFilter.filterId,
					filter: value.currentFilter.filter,
					timezone: value.currentFilter.timezone
				});
			}
		});

		return changedFilters;
	}

	function resetFilterLists() {
		newFilters = [];
		filtersToRemove = [];
		filtersToEdit = {};
	}

	function saveFilterEditsOnSaveAndApply(filterWrapper) {
		if (_.isNumber(filterWrapper.filterId)) {
			return;
		}

		var filterId = filterWrapper.filterId;

		if (!filtersToEdit[filterId]) {
			var trackingObj = {
				currentFilter: filterWrapper,
				originalFilter: angular.copy(filterWrapper)
			};

			filtersToEdit[filterId] = trackingObj;
		}
	}

	function logNewFilterCreation(filtersToSave) {
		if (filtersToSave.length) {
			var defaultNameCount = 0;
			var changedNameCount = 0;

			_.each(filtersToSave, function (filter) {
				if (filter.filterName === messageService.get('FSFILTERS.NEW_FILTER')) {
					defaultNameCount += 1;
				} else {
					changedNameCount += 1;
				}
			});

			if (changedNameCount) {
				sumoService.logAction('savedFilterChangedName', changedNameCount);
			}

			if (defaultNameCount) {
				sumoService.logAction('savedFilterNoChangeName', defaultNameCount);
			}
		}
	}

	function handleCustomUpdates() {
		// remove custom filters from newFilters
		var customFilters = _.remove(newFilters, customFilterService.isCustomFilter);
		// remove custom filters from filtersToRemove
		_.remove(filtersToRemove, customFilterService.isCustomFilterId).map(function (removedFilterId) {
			customFilters.push({ deletion: true, filterId: removedFilterId });
		});
		// remove custom filters from filtersToEdit
		_.forEach(filtersToEdit, function (filter, filterId) {
			if (customFilterService.isCustomFilter(filter.currentFilter)) {
				// create/edit custom filter
				if (!customFilterService.isCustomFilterId(filterId)) {
					// convert saved-filter to custom filter
					filtersToRemove.push(filterId);
				}
				customFilters.push(filter.currentFilter);
				delete filtersToEdit[filterId];
			} else if (customFilterService.isCustomFilterId(filterId)) {
				// convert custom filter to saved-filter
				customFilters.push({ deletion: true, filterId: filterId });
				newFilters.push(filter.currentFilter);
				delete filtersToEdit[filterId];
			}
		});
		var fieldsetId = fieldsetService.getFieldsetId();
		customFilterService.updateFilters(fieldsetId, customFilters);
	}

	function saveChangesAndStopTracking(currentFilterId) {

		function maybeSetSelectedFilterId(newFilterIds) {

			if (!currentFilterId) {
				return;
			}

			var index = findIndexOfFilter(newFilters, currentFilterId);

			if (index !== -1) {
				newFilters[index].filterId = newFilterIds[index];
			}
		}
		handleCustomUpdates();

		var newFiltersScrubbed = _.map(newFilters, scrubNewFilter);
		var changedFilters = getChangedFilters();

		_.each(newFiltersScrubbed, ensureFilterNames);
		_.each(changedFilters, ensureFilterNames);

		var updateReq = {
			newFilters: newFiltersScrubbed,
			filtersToDelete: filtersToRemove,
			editedFilters: changedFilters
		};

		logNewFilterCreation(newFiltersScrubbed);

		if (_.isEmpty(newFilters) && _.isEmpty(filtersToRemove) && _.isEmpty(updateReq.editedFilters)) {
			return $q.when([]).finally(resetFilterLists);
		} else {
			return savedFilters.updateFilters(updateReq).then(maybeSetSelectedFilterId).finally(resetFilterLists);
		}
	}

	function haveUnsavedChanges() {
		return !(_.isEmpty(newFilters) && _.isEmpty(filtersToRemove) && _.isEmpty(getChangedFilters()));
	}

	return {
		addNewFilter: addNewFilter,
		removeFilter: removeFilter,
		resetFilterLists: resetFilterLists,
		saveFilterEditsOnSaveAndApply: saveFilterEditsOnSaveAndApply,
		saveChangesAndStopTracking: saveChangesAndStopTracking,
		haveUnsavedChanges: haveUnsavedChanges
	};
}]);

'use strict';

angular.module('filters-client').factory('fc.filterStructure', [function () {
	// todo are all these actually used.
	function isFilter(filter) {
		return filter.type === 'filter';
	}

	function isEmptyFilter(filter) {
		return isFilter(filter) && (!filter.filter || !filter.filter.field);
	}

	function canReduceToSimpleFilter(filter) {
		// takes a valid filter (children[0] is nonempty)
		if (!filter.children) {
			return false;
		} else if (filter.children.length === 1) {
			return true;
		} else {
			for (var i = 1; i < filter.children.length; i++) {
				if (!isEmptyFilter(filter.children[i])) {
					return false;
				}
			}
		}
		return true;
	}

	function areFiltersEqual(filterOne, filterTwo) {
		return angular.toJson(filterOne) === angular.toJson(filterTwo);
	}

	function isSimpleTree(filter) {
		if (isFilter(filter)) {
			return true;
		}
		if (filter.children.length <= 1) {
			return _.reduce(filter.children, function (prev, child) {
				//todo find out why this is necessary
				return prev && isFilter(child);
			}, true);
		}
		return false;
	}

	return {
		canReduceToSimpleFilter: canReduceToSimpleFilter,
		areFiltersEqual: areFiltersEqual,
		isSimpleTree: isSimpleTree
	};
}]);
'use strict';
angular.module('filters-client').factory('fc.filterValidator', [function () {
	function isUndefinedOrNull(thing) {
		return _.isUndefined(thing) || _.isNull(thing);
	}

	return { //todo: make more intelligent. Is legacy function.
		isValid: function isValid(filter) {
			if (filter && filter.type) {
				if (filter.type == 'filter') {
					var valid = !isUndefinedOrNull(filter.filter) && (!isUndefinedOrNull(filter.filter.operator) && !isUndefinedOrNull(filter.filter.operand) && filter.filter.operand !== '' || !isUndefinedOrNull(filter.filter.dateRange));

					if (valid && _.isArray(filter.filter.operand)) {
						if (filter.filter.operator === 'between') {
							valid = _.compact(filter.filter.operand).length === 2;
						} else {
							valid = filter.filter.operand.length;
						}
					}
					return valid;
				}
				return filter.children && filter.children.length > 0 && _.reduce(filter.children, function (prev, child) {
					return isValid(child) && prev;
				}, true);
			}
			return false;
		}
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.filteredResponseCount', ['fc.fieldsetService', 'fc.responseCountService', function (fieldsetService, responseCountService) {
	var responseCountCb = void 0;
	function init(_responseCountCb) {
		responseCountCb = _responseCountCb;
	}

	function updateCount(filter, scope) {
		var responseCountP = _.isFunction(responseCountCb) ? responseCountCb(filter) : fieldsetService.getAggregate([{ field: '_recordId', key: 'bollocks', metric: 'count' }], undefined, filter).then(function (aggregateResponse) {
			return _.get(aggregateResponse, 'data.values[0][0]', NaN);
		});

		responseCountP.then(function (count) {
			if (isNaN(count)) {
				count = 'Unavailable';
			} else if (count > 999999) {
				count = Math.round(count / 100000) / 10 + 'm';
			} else if (count > 999) {
				count = Math.round(count / 100) / 10 + 'k';
			}
			responseCountService.setResponseCount(count);
			if (scope) {
				scope.filteredCountObject = {
					count: count
				};
			}
		});
	}

	function removeCount(scope) {
		if (scope) {
			delete scope.filteredCountObject;
		}
	}

	return {
		init: init,
		updateFilteredResponseCount: updateCount,
		removeFilteredResponseCount: removeCount
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.wrapperService', ['fc.appliedFilter', 'fc.displayedFilter', 'fc.fieldsetService', 'fc.permissionsService', 'fc.modalService', 'fc.fieldsetViewMenu', 'fc.sumoService', 'fc.filteredResponseCount', 'fc.savedFilters', '$filter', 'fc.filterValidator', 'fc.customFilterService', function (appliedFilter, displayedFilter, fieldsetService, permissionsService, modalService, fieldsetViewMenu, sumoService, filteredResponseCount, savedFilters, $filter, filterValidator, customFilterService) {

	var translate = $filter('fcTranslate');

	function init(filter, fieldSet, filterChanged, permissions, responseCountCb) {
		fieldsetService.init(fieldSet);
		permissionsService.init(permissions);
		filteredResponseCount.init(responseCountCb);
		return appliedFilter.init(filterChanged, filter).then(function () {
			displayedFilter.init();
			return getFilterMenu(fieldSet);
		});
	}

	function selectFilterMenuItem(menuItem) {
		if (_.has(menuItem, 'menuItemType')) {
			if (menuItem.menuItemType === 'manageFilters') {
				modalService.showManageFilters(false);
				return;
			} else if (menuItem.menuItemType === 'filter') {
				sumoService.logAction('appliedSavedFilter');
				displayedFilter.applyFilterById(menuItem.id);
			}
		}
	}

	function getFilterMenu(fieldSet) {
		fieldsetService.init(fieldSet);
		return savedFilters.getFilters().then(function (filtersData) {
			var savedFilterItems = _.map(filtersData, getFilterMenuItem);

			var filterItems = [{
				label: translate('FSFILTERS.MANAGE_FILTERS'),
				value: { menuItemType: 'manageFilters' }
			}];

			if (!savedFilterItems.length) {
				return filterItems;
			}

			return filterItems.concat({ divider: true }, savedFilterItems);
		});
	}

	function getFilterMenuItem(filter) {
		return {
			label: filter.filterName,
			value: {
				menuItemType: 'filter',
				id: filter.filterId,
				name: filter.filterName
			}
		};
	}

	function openManageFiltersModal() {
		return modalService.showManageFilters();
	}

	function hasValidFilterApplied() {
		return displayedFilter.hasValidFilterApplied();
	}

	function getFilterMeta() {
		return displayedFilter.getDisplayedFilterMetadata();
	}

	function removeAppliedFilter() {
		return displayedFilter.unapplyFilter();
	}

	function isValidFilter(filter) {
		return filterValidator.isValid(filter);
	}

	function registerCustomFilterService(methods) {
		customFilterService.register(methods);
	}

	function resetCustomFilterService() {
		customFilterService.reset();
	}

	return {
		init: init,
		selectFilterMenuItem: selectFilterMenuItem,
		getFilterMenu: getFilterMenu,
		openManageFiltersModal: openManageFiltersModal,
		hasValidFilterApplied: hasValidFilterApplied,
		getFilterMeta: getFilterMeta,
		removeAppliedFilter: removeAppliedFilter,
		isValidFilter: isValidFilter,
		registerCustomFilterService: registerCustomFilterService,
		resetCustomFilterService: resetCustomFilterService
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.messageService', ['$cacheFactory', '$log', '$interpolate', 'rsEnvironment', function ($cacheFactory, $log, $interpolate, env) {
	var self = {};
	var lang = 'en';

	var cache;

	var allMessages = void 0;
	var engMessages = void 0;
	var messages = void 0;
	var languageMap = void 0;

	self.initCache = function () {
		cache = $cacheFactory.get('filters-client-translations');
		allMessages = cache.get('messages');
		languageMap = cache.get('language-map');
		engMessages = _.get(allMessages, 'en');
		messages = engMessages;
	};

	self.initCache();

	self.setLang = function (language) {
		if (!language) {
			$log.error('Language not provided. Fallback to EN');
			language = 'EN';
		}
		lang = _.get(languageMap, language.toUpperCase());
		messages = _.get(allMessages, lang);
		if (!messages) {
			$log.error('Preferred language file ' + language + ' does not exist. Fallback to EN');
			messages = engMessages;
		}
	};

	self.get = function (key, option) {
		var value = key && key.split('.');

		if (!value || value[0] !== 'FSFILTERS' || env.get('user', 'language') === 'DEV') {
			// << we can do this because it only translates filter's messages
			return '{{' + key + '}}';
		} else {

			var language = env.get('userLanguage') || env.get('user', 'language') || 'EN';
			lang = _.get(languageMap, language.toUpperCase());
			messages = _.get(allMessages, lang);

			var translated = _.get(messages, value[1], undefined) || _.get(engMessages, value[1], undefined);

			if (translated === undefined) {
				$log.error('FieldSet Filters missing translation for: ' + key);
				return key;
			}
			translated = $interpolate(translated)(option);
			return translated;
		}
	};

	return self;
}]);
'use strict';

angular.module('filters-client').factory('fc.modalService', ['qstrap.modal', '$rootScope', 'fc.filterModalChanges', 'fc.permissionsService', function ($modal, $rootScope, filterModalChanges, permissionsService) {

	var manageFiltersModal = void 0,
	    confirmDeleteModal = void 0,
	    confirmCancelWithoutSaveModal = void 0,
	    manageFilterModalOpen = void 0;

	function showManageFilters(addChild, displayedFilter) {
		if (!manageFilterModalOpen) {
			manageFilterModalOpen = true;
			var newScope = $rootScope.$new();

			newScope.addChild = addChild || false;
			newScope.permissions = permissionsService.getUserPermissions();

			manageFiltersModal = $modal({
				scope: newScope,
				templateUrl: 'templates/fc-filters-modal.html',
				controller: 'fc.FiltersModalController'
			});

			manageFiltersModal.show();
		}
	}

	function showWarningModal(title, message, cancel) {
		var newScope = $rootScope.$new();

		newScope.title = title;
		newScope.message = message;
		newScope.cancel = cancel;

		$modal({
			scope: newScope,
			templateUrl: 'templates/fc-warning-modal.tpl.html',
			destroyScopeOnClose: true
		}).show();
	}

	function closeManageFilters() {
		manageFilterModalOpen = false;
		if (manageFiltersModal) {
			filterModalChanges.resetFilterLists();
			manageFiltersModal.close();
		}
	}

	function showConfirmDelete(deleteFilter, filterMeta) {
		var newScope = $rootScope.$new();
		newScope.deleteFilter = deleteFilter;
		newScope.filterMetadata = filterMeta;

		confirmDeleteModal = $modal({
			scope: newScope,
			templateUrl: 'templates/fc-delete-modal.html'
		});

		confirmDeleteModal.show();
	}

	function closeConfirmDelete() {
		if (confirmDeleteModal) {
			confirmDeleteModal.close();
		}
	}

	function closeConfirmCancelWithoutSave() {
		if (confirmCancelWithoutSaveModal) {
			confirmCancelWithoutSaveModal.close();
		}
	}

	function showConfirmCancelWithoutSave() {
		var newScope = $rootScope.$new();
		newScope.closeFiltersModal = function () {
			closeManageFilters();
			closeConfirmCancelWithoutSave();
		};

		newScope.closeConfirmCancelWithoutSave = closeConfirmCancelWithoutSave;

		confirmCancelWithoutSaveModal = $modal({
			scope: newScope,
			templateUrl: 'templates/fc-cancel-without-save-modal.html'
		});

		confirmCancelWithoutSaveModal.show();
	}

	function isManagerFilterModalOpen() {
		return manageFilterModalOpen;
	}

	return {
		showWarningModal: showWarningModal,
		showManageFilters: showManageFilters,
		closeManageFilters: closeManageFilters,
		showConfirmDelete: showConfirmDelete,
		closeConfirmDelete: closeConfirmDelete,
		showConfirmCancelWithoutSave: showConfirmCancelWithoutSave,
		isManagerFilterModalOpen: isManagerFilterModalOpen
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.permissionsService', [function () {
	var permissions = {};

	function init(_permissions) {
		// should error when needed props are not present
		// view, snapshotId, labels, survey
		permissions = angular.copy(_permissions);
	}

	function getUserPermissions() {
		return permissions;
	}

	return {
		init: init,
		getUserPermissions: getUserPermissions
	};
}]);
'use strict';

angular.module('filters-client').service('fc.qualtricsService', ['$window', function ($window) {
	return $window.Qualtrics || {};
}]);
'use strict';

angular.module('filters-client').factory('fc.responseCountService', [function () {
	var responseCount = {
		count: ''
	};

	function setResponseCount(count) {
		responseCount.count = count;
	}

	return {
		responseCount: responseCount,
		setResponseCount: setResponseCount
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.responseValues', ['rsEnvironment', 'rsFieldsetProgress', 'rsFieldsetsV2.internal.aggregates', '$q', '$cacheFactory', '$http', 'fc.modalService', 'fc.messageService', '$timeout', function (env, progressService, aggregateAPI, $q, $cacheFactory, $http, modalService, messageService, $timeout) {
	var baseUrl = (env.get('ripsawBaseUrl') || '') + '/v2/fieldsets';
	var cache = $cacheFactory.get('FILTERS_UNIQUE_VALUES_CACHE') || $cacheFactory('FILTERS_UNIQUE_VALUES_CACHE');
	var displayWarningModal = true;

	function isSampledData(response) {
		return response && response.meta && response.meta.sample;
	}

	function extractResponseData(response) {
		return response && response.data || {};
	}

	function getRawAggregate(fieldsetId, metrics, breakouts, useCache) {
		if (!fieldsetId) {
			return $q.reject(new Error('Required parameter "fieldsetId" is undefined'));
		}

		var aggregateUrl = baseUrl + '/' + fieldsetId + '/aggregate';

		var body = {
			metrics: metrics,
			breakouts: breakouts
		};
		var cacheParam = angular.isDefined(useCache) ? useCache : true;

		return makeCacheRawAggregateRequest(aggregateUrl, body, cacheParam);
	}

	function makeCacheRawAggregateRequest(url, body, useCache) {
		var cacheKey = url + JSON.stringify(body);
		var cachedResult = cache.get(cacheKey);
		if (useCache && cachedResult) {
			return cachedResult;
		} else {
			var res = void 0;
			var useRipsawBaseUrl = !!env.get('ripsawBaseUrl');
			if (useRipsawBaseUrl) {
				res = $http.post(url, body, {
					json: true
				});
			} else {
				var fieldsetId = url.split('/')[3];
				res = aggregateAPI.getAggregate(fieldsetId, body.metrics, body.breakouts);
			}
			res.catch(function () {
				cache.remove(cacheKey);
			});
			cache.put(cacheKey, res);
			return res;
		}
	}

	function getAggregate(fieldSetId, metrics, breakouts, useCache) {

		function getUncachedAggregate() {
			return getAggregate(fieldSetId, metrics, breakouts, false);
		}

		function waitForFullData(data) {

			if (isSampledData(data)) {

				return progressService.waitForCompletion(data.meta.progress).then(getUncachedAggregate);
			}

			return data;
		}

		return getRawAggregate(fieldSetId, metrics, breakouts, useCache).then(extractResponseData).then(waitForFullData);
	}

	function getUniqueValues(fieldSetId, fieldId) {

		var metrics = [{
			field: fieldId,
			key: fieldId + '.count',
			metric: 'count'
		}];

		var breakouts = [fieldId];

		function returnError(reason) {
			return $q.reject(reason);
		}

		function maybeDisplayWarning(aggregateResult) {
			// dont display the warning modal if we showed it to them recently
			function startWarningTimeout() {
				function showAgain() {
					displayWarningModal = true;
				}
				displayWarningModal = false;
				$timeout(showAgain, 30000);
			}

			if (aggregateResult.length >= 5000 && displayWarningModal) {
				modalService.showWarningModal(messageService.get('FSFILTERS.BREAKOUT_WARNING'), messageService.get('FSFILTERS.BREAKOUT_MESSAGE'), messageService.get('FSFILTERS.CLOSE'));
				startWarningTimeout();
			}
			return aggregateResult;
		}

		function extractFieldValues(response) {
			// Extract field values from aggregate response
			if (!response.data || !response.data.keys || !response.data.values) {
				return $q.reject(new Error('getUniqueValues: Expected response to contain "data" property with "keys" and "values" properties'));
			}

			var valueIndex = _.indexOf(response.data.keys, fieldId);
			var uniqueResponseValues = _.map(response.data.values, valueIndex);

			return uniqueResponseValues;
		}

		return getAggregate(fieldSetId, metrics, breakouts, true).then(extractFieldValues, returnError).then(maybeDisplayWarning);
	}

	return {
		getUniqueValues: getUniqueValues
	};
}]);

'use strict';

angular.module('filters-client').factory('fc.savedFilters', ['fc.fieldsetService', '$http', '$cacheFactory', 'fc.customFilterService', function (fieldsetService, $http, $cacheFactory, customFilterService) {
	var $cache = $cacheFactory('saved-filters'),
	    baseUrl = '/filters-service/v1/fieldsets/';

	function getSurveyId(data) {
		var fieldset = data.definition || data;
		return fieldset.contextMeta.sourceSurveyId;
	}

	function getFiltersUrl(surveyId) {
		return '' + baseUrl + fieldsetService.getFieldsetId() + '/filters?surveyId=' + surveyId;
	}

	function getFilterUrl(filterId, surveyId) {
		return '' + baseUrl + fieldsetService.getFieldsetId() + '/filters/' + filterId + '?surveyId=' + surveyId;
	}

	function getUpdateFiltersUrl(surveyId) {
		return '' + baseUrl + fieldsetService.getFieldsetId() + '/filters?surveyId=' + surveyId;
	}

	function clearCacheAndGetFilterId(res) {
		$cache.removeAll();
		return res.data.filterId;
	}

	function clearCacheAndGetFilterIds(res) {
		$cache.removeAll();
		return res.data.newFilterIds;
	}

	function fetchFilters(surveyId) {
		return $http.get(getFiltersUrl(surveyId), { cache: $cache });
	}

	function reverseSort(res) {

		function changeToDate(item) {
			item.lastModified = new Date(item.lastModified);
			return item;
		}

		return _.chain(res.data.filters).map(changeToDate).sortBy('lastModified').value().reverse();
	}

	function appendCustomFilters(fieldsetId, savedFilters) {
		return customFilterService.getFilters(fieldsetId).concat(savedFilters);
	}

	function getFilters() {
		return fetchFilters(fieldsetService.getSurveyId()).then(reverseSort).then(appendCustomFilters.bind(null, fieldsetService.getFieldsetId()));
	}

	function createFilter(filter) {
		var surveyId = fieldsetService.getSurveyId();
		return $http.post(getFiltersUrl(surveyId), filter).then(clearCacheAndGetFilterId);
	}

	function updateFilter(filter, filterId) {
		var surveyId = fieldsetService.getSurveyId();
		return $http.put(getFilterUrl(filterId, surveyId), filter).then(clearCacheAndGetFilterId);
	}

	function updateFilters(filterChanges) {
		var surveyId = fieldsetService.getSurveyId();
		return $http.put(getUpdateFiltersUrl(surveyId), filterChanges).then(clearCacheAndGetFilterIds);
	}

	function deleteFilter(filterId) {
		var surveyId = fieldsetService.getSurveyId();
		return $http.delete(getFilterUrl(filterId, surveyId)).then(clearCacheAndGetFilterId);
	}

	return {
		getFilters: getFilters,
		createFilter: createFilter,
		updateFilter: updateFilter,
		updateFilters: updateFilters,
		deleteFilter: deleteFilter
	};
}]);

'use strict';

angular.module('filters-client').factory('fc.sumoService', ['rsEnvironment', 'fc.qualtricsService', '$location', '$http', function (env, Qualtrics, $location, $http) {

	var RESPONSES_SECTION = 'ResponsesSection';
	var RESULTS_SECTION = 'ResultsSection';
	var FILTERS_UNKNOWN_SECTION = 'FiltersClientUnknownSection';
	var LOG_URL = '/rum/genesis-dev-client-logging?';
	var BETA_ENV = 'b1-prv';
	var actions = {
		savedFilterChangedName: 'saved filter changed name',
		savedFilterNoChangeName: 'saved filter default name',
		appliedSavedFilter: 'applied saved filter'
	};

	function getSection() {
		if (/responses/.test($location.absUrl())) {
			return RESPONSES_SECTION;
		} else if (/results/.test($location.absUrl())) {
			return RESULTS_SECTION;
		}

		return FILTERS_UNKNOWN_SECTION;
	}

	function notInBeta() {
		// Dataprocessing
		if (Qualtrics && Qualtrics.System) {
			return Qualtrics.System.subHostEnv !== BETA_ENV;
		}

		// Results
		if (env.get('dc')) {
			return env.get('dc') !== BETA_ENV;
		}

		return true;
	}

	function logToSumo(logObject, logUrl) {

		var user = env.get('user');
		if (user) {
			logObject.brandId = user.brandId;
			logObject.userId = user.userId;
			logObject.email = user.email;
		}

		logObject.host = $location.host();

		var logString = JSON.stringify(logObject);

		if (notInBeta()) {
			$http.get('' + LOG_URL + logString);
		}
	}

	function logAction(action, additionalInfo) {
		var actionDone = actions[action];
		if (actionDone) {
			logToSumo({
				action: actionDone,
				additionalInfo: additionalInfo,
				section: getSection()
			});
		}
	}

	return {
		logAction: logAction
	};
}]);
'use strict';

angular.module('filters-client').factory('fc.utilService', [function () {
	function isEmpty(value) {
		return angular.isUndefined(value) || value === '' || value === null || value !== value;
	}

	function includes(list, value) {
		if (Object.prototype.toString.call(list) === '[object Array]' || Object.prototype.toString.call(list) === '[object String]') {

			return list.indexOf(value) !== -1;
		}

		return false;
	}

	return {
		isEmpty: isEmpty,
		includes: includes
	};
}]);
'use strict';
angular.module('filters-client').value('fc.datePeriodLabels', {
	year: 'FSFILTERS.YEAR',
	quarter: 'FSFILTERS.QUARTER',
	month: 'FSFILTERS.MONTH',
	week: 'FSFILTERS.WEEK'
});

'use strict';
angular.module('filters-client').value('fc.dateRanges', {
	'_all_': 'FSFILTERS.ALL_TIME',
	'relative-week-0': 'FSFILTERS.THIS_WEEK',
	'relative-month-0': 'FSFILTERS.THIS_MONTH',
	'relative-quarter-0': 'FSFILTERS.THIS_QUARTER',
	'relative-year-0': 'FSFILTERS.THIS_YEAR',
	'rolling-day-7': 'FSFILTERS.LAST_7_DAYS',
	'rolling-day-14': 'FSFILTERS.LAST_14_DAYS',
	'rolling-day-30': 'FSFILTERS.LAST_30_DAYS',
	'rolling-day-90': 'FSFILTERS.LAST_90_DAYS',
	'range': 'FSFILTERS.CUSTOM_DATE_RANGE'
});

'use strict';
/**
 * A simple mapping of Field types to menu headers
 */
angular.module('filters-client').value('fc.headerTypeMap', {
	FreeFormText: 'Text',
	GenericValue: 'Text',
	Id: 'Text',
	ScalarValue: 'Number',
	EnumerableScalarValue: 'Number',
	EnumerableValue: 'Text',
	EnumerableValueSet: 'Text',
	DateTime: 'Date'
});
'use strict';
angular.module('filters-client').value('fc.operators', {
	'equals': 'FSFILTERS.EQUAL_TO',
	'notEquals': 'FSFILTERS.NOT_EQUAL_TO',
	'lessThan': 'FSFILTERS.LESS_THAN',
	'greaterThan': 'FSFILTERS.GREATER_THAN',
	'lessThanOrEqualTo': 'FSFILTERS.LT_OR_EQUAL_TO',
	'greaterThanOrEqualTo': 'FSFILTERS.GT_OR_EQUAL_TO',
	'before': 'FSFILTERS.BEFORE',
	'after': 'FSFILTERS.AFTER',
	'between': 'FSFILTERS.BETWEEN',
	'in': 'FSFILTERS.IN',
	'notIn': 'FSFILTERS.NOT_IN',
	'is': 'FSFILTERS.IS',
	'isNot': 'FSFILTERS.IS_NOT',
	'contains': 'FSFILTERS.CONTAINS',
	'notContains': 'FSFILTERS.NOT_CONTAINS',
	'includesAny': 'FSFILTERS.INCLUDES_ANY',
	'lacksAll': 'FSFILTERS.LACKS_ALL',
	'isEmpty': 'FSFILTERS.IS_EMPTY',
	'isNotEmpty': 'FSFILTERS.IS_NOT_EMPTY',
	'today': 'FSFILTERS.TODAY',
	'yesterday': 'FSFILTERS.YESTERDAY',
	'thisMonth': 'FSFILTERS.THIS_MONTH',
	'last7Days': 'FSFILTERS.LAST_7_DAYS',
	'last14Days': 'FSFILTERS.LAST_14_DAYS',
	'last30Days': 'FSFILTERS.LAST_30_DAYS',
	'last60Days': 'FSFILTERS.LAST_60_DAYS',
	'last120Days': 'FSFILTERS.LAST_120_DAYS',
	'last365Days': 'FSFILTERS.LAST_365_DAYS'
});

angular.module('filters-client').run(['$cacheFactory', function ($cacheFactory) {
	var $cache = $cacheFactory('filters-client-translations');
	'use strict';

	$cache.put('language-map', {
		"SQI": "sq",
		"AR": "ar",
		"HYE": "hy",
		"ASM": "as",
		"AZ-AZ": "az",
		"ID": "id",
		"MS": "ms",
		"BEL": "be",
		"BN": "bn",
		"BS": "bs",
		"BG": "bg",
		"CA": "ca",
		"CEB": "ceb",
		"ZH-S": "zh-Hans",
		"ZH-T": "zh-Hant",
		"HR": "hr",
		"CS": "cs",
		"DA": "da",
		"NL": "nl",
		"EN": "en",
		"EN-GB": "en-GB",
		"EO": "eo",
		"ET": "et",
		"FI": "fi",
		"FR": "fr",
		"FR-CA": "fr-CA",
		"KAT": "ka",
		"DE": "de",
		"DEV": "dev",
		"EL": "el",
		"GU": "gu",
		"HE": "he",
		"HI": "hi",
		"HU": "hu",
		"ISL": "is",
		"HIL": "hil",
		"IT": "it",
		"JA": "ja",
		"KAN": "kn",
		"KAZ": "kk",
		"KM": "km",
		"KO": "ko",
		"LV": "lv",
		"LT": "lt",
		"MK": "mk",
		"MAL": "ml",
		"MAR": "mr",
		"MN": "mn",
		"SR-ME": "cnr",
		"MY": "my",
		"NO": "no",
		"ORI": "or",
		"FA": "fa",
		"PL": "pl",
		"PT": "pt",
		"PT-BR": "pt-BR",
		"PB": "pb",
		"PA-IN": "pa",
		"RI-GI": "ri-GI",
		"RO": "ro",
		"RU": "ru",
		"SR": "sr",
		"SIN": "si",
		"SK": "sk",
		"SL": "sl",
		"ES-ES": "es",
		"ES": "es-419",
		"SW": "sw",
		"SV": "sv",
		"TGL": "tl",
		"TA": "ta",
		"TEL": "te",
		"TH": "th",
		"TR": "tr",
		"UK": "uk",
		"UR": "ur",
		"VI": "vi",
		"CY": "cy"
	});

	$cache.put('messages', { "da": { "ADD_CONDITION": "Tilføj betingelse", "ADD_FILTER": "Tilføj filter", "AFTER": "Efter", "ALL": "Alle", "ALL_FILTERS": "Alle", "ALL_TIME": "Alle tidspunkter", "AND": "og", "ANY_FILTERS": "Enhver", "APPLY": "Anvend", "BEFORE": "Før", "BETWEEN": "Mellem", "BREAKOUT_MESSAGE": "Dit felt har mere end 5000 entydige værdier. Vi viser kun 5000 af dem. Ændr din felttype til tekst i undersøgelseseditor for at aktivere søgning efter nøjagtige værdier.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Dine filtre kunne ikke gemmes eller anvendes. Kontakt Qualtrics-support for at få flere oplysninger.", "BREAKOUT_WARNING": "Advarsel!", "BY": "af", "CANCEL": "Annuller", "CANCEL_WITHOUT_SAVING": "Annuller uden at gemme", "CHOICES": "Valg", "CLOSE": "Luk", "CONFIRM_CANCEL_WITHOUT_SAVING": "Du har ændringer, der ikke er gemt. Er du sikker på, at du vil annullere uden at gemme?", "CONFIRM_DELETE": "Er du sikker på, at du vil slette filtret \"{{name}}\"?", "CONTACT_FIELDS": "Kontaktfelter", "CONTAINS": "Indeholder", "COPY": "Kopiér", "CREATE_A_FILTER": "Opret et filter", "CREATE_NEW": "Opret nyt", "CUSTOM_DATE_RANGE": "Brugerdefineret datointerval", "DATE": "Dato", "DELETE": "Slet", "DELETE_FILTER": "Slet filter", "EMBEDDED_DATA": "Integrerede data", "EQUAL_TO": "Lig med", "EVALUATIONS_OTHER": "Andre evalueringer (undtagen emners)", "EVALUATIONS_SUBJECT": "Emners evalueringer", "EXCLUDES": "Udelukker", "FILTERED_RESPONSES": "Filtrerede svar", "FILTERING_BY": "Filtrering efter:", "FILTER_ID_COLON": "Filter-id", "FILTER_NAME_COPY": "{{name}} kopi", "GREATER_THAN": "Større end", "GT_OR_EQUAL_TO": "Større end eller lig med", "IN": "Inkluderer", "INCLUDES": "Inkluderer", "INCLUDES_ANY": "Inkluderer alle", "INSERT_NEW_CONDITION": "Indsæt ny betingelse", "INSERT_NEW_CONDITION_SET": "Indsæt nyt betingelsessæt", "IS": "Er", "IS_EMPTY": "Er tom", "IS_NOT": "Er ikke", "IS_NOT_EMPTY": "Er ikke tom", "LACKS_ALL": "Udelukker alle", "LAST_120_DAYS": "Seneste 120 dage", "LAST_14_DAYS": "Seneste 14 dage", "LAST_30_DAYS": "Seneste 30 dage", "LAST_365_DAYS": "Seneste 365 dage", "LAST_60_DAYS": "Seneste 60 dage", "LAST_7_DAYS": "Seneste 7 dage", "LAST_90_DAYS": "Seneste 90 dage", "LESS_THAN": "Mindre end", "LT_OR_EQUAL_TO": "Mindre end eller lig med", "MANAGE_FILTERS": "Administrer filtre", "MANAGE_FILTERS_ELLIPSIS": "Administrer filtre...", "MONTH": "måned", "MONTHS": "måneder", "NEW_FILTER": "Nyt filter", "NO": "Nej", "NONE": "Ingen", "NOT_CONTAINS": "Indeholder ikke", "NOT_EQUAL_TO": "Ikke lig med", "NOT_IN": "Inkluderer ikke", "NO_AVAILABLE_FIELDS": "Ingen tilgængelige felter...", "NO_FILTERS_MSG": "Du har ikke nogen filtre endnu.", "NPS_GROUP": "NPS®-gruppe", "NUMBER": "Nummer", "NUMERIC_VALUE": "Numerisk værdi", "OFFSET": "Forskudt", "OF_THE_FOLLOWING_ARE_TRUE": "af følgende informationer er sande", "QUARTER": "kvartal", "QUARTERS": "kvartaler", "READ_ONLY": "Skrivebeskyttet", "REMOVE_CONDITION": "Fjern betingelse", "RESPONSE_COUNT": "{{count}} svar", "SAME_AS_SUBJECT": "Samme som emne", "SAVE": "Gem", "SAVED_FILTERS": "Gemte filtre", "SAVE_AND_APPLY": "Gem og anvend", "SEARCH": "Søg", "SELECTED": "Valgt", "SELECTED_CHOICE": "Valgte valg", "SELECT_FIELD": "Vælg felt", "SELECT_ONE_OR_MORE_FIELDS": "Vælg en eller flere felter...", "SELECT_OPERAND": "Vælg operand", "SELECT_OPERATOR": "Vælg operator", "SHOW_ONLY_RESP": "Vis kun svar:", "SHOW_ONLY_WHERE_COLON": "Vis kun svar, hvor:", "SURVEY_METADATA": "Undersøgelsesmetadata", "TEXT": "Tekst", "THIS_MONTH": "Denne måned", "THIS_QUARTER": "Dette kvartal", "THIS_WEEK": "Denne uge", "THIS_YEAR": "Dette år", "TODAY": "I dag", "WEEK": "uge", "WEEKS": "uger", "YEAR": "år", "YEARS": "år", "YES": "Ja", "YESTERDAY": "I går" }, "de": { "ADD_CONDITION": "Bedingung hinzufügen", "ADD_FILTER": "Filter hinzufügen", "AFTER": "Nach", "ALL": "Alle", "ALL_FILTERS": "Alle", "ALL_TIME": "Immer", "AND": "und", "ANY_FILTERS": "Beliebig", "APPLY": "Übernehmen", "BEFORE": "Vor", "BETWEEN": "Zwischen", "BREAKOUT_MESSAGE": "Ihr Feld enthält mehr als 5000 eindeutige Werte. Nur 5000 dieser Werte werden angezeigt! Ändern Sie den Feldtyp im Umfragen-Editor zu Text, um nach exakten Werten zu suchen.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Ihre Filter konnten nicht gespeichert oder angewendet werden. Wenden Sie sich für weitere Informationen an den Qualtrics-Support.", "BREAKOUT_WARNING": "Warnung!", "BY": "von", "CANCEL": "Abbrechen", "CANCEL_WITHOUT_SAVING": "Abbrechen, ohne zu speichern", "CHOICES": "Antwortmöglichkeiten", "CLOSE": "Schließen", "CONFIRM_CANCEL_WITHOUT_SAVING": "Es sind nicht gespeicherte Änderungen vorhanden. Möchten Sie den Vorgang wirklich abbrechen, ohne zu speichern?", "CONFIRM_DELETE": "Möchten Sie den Filter '{{name}}' wirklich löschen?", "CONTACT_FIELDS": "Kontaktfelder", "CONTAINS": "Enthält", "COPY": "Kopie", "CREATE_A_FILTER": "Filter erstellen", "CREATE_NEW": "Neue erstellen", "CUSTOM_DATE_RANGE": "Benutzerdefinierter Datumsbereich", "DATE": "Datum", "DELETE": "Löschen", "DELETE_FILTER": "Filter löschen", "EMBEDDED_DATA": "Eingebettete Daten", "EQUAL_TO": "Gleich", "EVALUATIONS_OTHER": "Sonstige Beurteilungen (ohne Feedbacknehmer)", "EVALUATIONS_SUBJECT": "Beurteilungen des Feedbacknehmers", "EXCLUDES": "Ausschließlich", "FILTERED_RESPONSES": "Gefilterte Antworten", "FILTERING_BY": "Filterung nach", "FILTER_ID_COLON": "Filter-ID:", "FILTER_NAME_COPY": "{{name}} Kopie", "GREATER_THAN": "Größer als", "GT_OR_EQUAL_TO": "Größer oder gleich", "IN": "Einschließlich", "INCLUDES": "Einschließlich", "INCLUDES_ANY": "Einschließlich aller", "INSERT_NEW_CONDITION": "Neue Bedingung einfügen", "INSERT_NEW_CONDITION_SET": "Neuen Bedingungssatz einfügen", "IS": "Ist", "IS_EMPTY": "Ist leer", "IS_NOT": "Ist nicht", "IS_NOT_EMPTY": "Ist nicht leer", "LACKS_ALL": "Ausschließlich aller", "LAST_120_DAYS": "Letzten 120 Tage", "LAST_14_DAYS": "Letzten 14 Tage", "LAST_30_DAYS": "Letzten 30 Tage", "LAST_365_DAYS": "Letzte 365 Tage", "LAST_60_DAYS": "Letzten 60 Tage", "LAST_7_DAYS": "Letzten 7 Tage", "LAST_90_DAYS": "Letzten 90 Tage", "LESS_THAN": "Kleiner als", "LT_OR_EQUAL_TO": "Kleiner oder gleich", "MANAGE_FILTERS": "Filter verwalten", "MANAGE_FILTERS_ELLIPSIS": "Filter verwalten...", "MONTH": "Monat", "MONTHS": "Monate", "NEW_FILTER": "Neuer Filter", "NO": "Nein", "NONE": "Ohne", "NOT_CONTAINS": "Enthält nicht", "NOT_EQUAL_TO": "Ungleich", "NOT_IN": "Enthält nicht", "NO_AVAILABLE_FIELDS": "Keine verfügbaren Felder...", "NO_FILTERS_MSG": "Sie haben noch keine Filter.", "NPS_GROUP": "NPS®-Gruppe", "NUMBER": "Zahl", "NUMERIC_VALUE": "Numerischer Wert", "OFFSET": "Älter als", "OF_THE_FOLLOWING_ARE_TRUE": "der folgenden Bedingungen wahr sind", "QUARTER": "Quartal", "QUARTERS": "Quartale", "READ_ONLY": "Schreibgeschützt", "REMOVE_CONDITION": "Bedingung entfernen", "RESPONSE_COUNT": "{{count}} Antworten", "SAME_AS_SUBJECT": "Gleich dem Feedbacknehmer", "SAVE": "Speichern", "SAVED_FILTERS": "Gespeicherte Filter", "SAVE_AND_APPLY": "Speichern und anwenden", "SEARCH": "Suchen", "SELECTED": "Hat gewählt", "SELECTED_CHOICE": "Ausgewählte Antwortmöglichkeit", "SELECT_FIELD": "Feld auswählen", "SELECT_ONE_OR_MORE_FIELDS": "Wählen Sie mindestens ein Feld aus...", "SELECT_OPERAND": "Operand auswählen", "SELECT_OPERATOR": "Operator auswählen", "SHOW_ONLY_RESP": "Nur Antworten anzeigen:", "SHOW_ONLY_WHERE_COLON": "Nur Antworten anzeigen, für die:", "SURVEY_METADATA": "Metadaten der Umfrage", "TEXT": "Text", "THIS_MONTH": "Dieser Monat", "THIS_QUARTER": "Dieses Quartal", "THIS_WEEK": "Diese Woche", "THIS_YEAR": "Dieses Jahr", "TODAY": "Heute", "WEEK": "Woche", "WEEKS": "Wochen", "YEAR": "Jahr", "YEARS": "Jahre", "YES": "Ja", "YESTERDAY": "Gestern" }, "en": { "ADD_CONDITION": "Add Condition", "ADD_FILTER": "Add Filter", "AFTER": "After", "ALL": "All", "ALL_FILTERS": "All", "ALL_TIME": "All Time", "AND": "and", "ANY_FILTERS": "Any", "APPLY": "Apply", "BEFORE": "Before", "BETWEEN": "Between", "BREAKOUT_MESSAGE": "Your field has more than 5000 unique values, we will only display 5000 of them! Change your field type to Text in the Survey Editor to enable searching for exact values.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Your filters could not be saved or applied. Please contact Qualtrics Support for more information.", "BREAKOUT_WARNING": "Warning!", "BY": "by", "CANCEL": "Cancel", "CANCEL_WITHOUT_SAVING": "Cancel Without Saving", "CHOICES": "Choices", "CLOSE": "Close", "CONFIRM_CANCEL_WITHOUT_SAVING": "You have unsaved changes. Are you sure you want to cancel without saving?", "CONFIRM_DELETE": "Are you sure you want to delete the filter '{{name}}'?", "CONTACT_FIELDS": "Contact Fields", "CONTAINS": "Contains", "COPY": "Copy", "CREATE_A_FILTER": "Create a Filter", "CREATE_NEW": "Create New", "CUSTOM_DATE_RANGE": "Custom date range", "DATE": "Date", "DELETE": "Delete", "DELETE_FILTER": "Delete Filter", "EMBEDDED_DATA": "Embedded Data", "EQUAL_TO": "Equal to", "EVALUATIONS_OTHER": "Other Evaluations (Excluding Subject's)", "EVALUATIONS_SUBJECT": "Subject's Evaluations", "EXCLUDES": "Excludes", "FILTERED_RESPONSES": "Filtered Responses", "FILTERING_BY": "Filtering by", "FILTER_ID_COLON": "Filter ID:", "FILTER_NAME_COPY": "{{name}} Copy", "GREATER_THAN": "Greater than", "GT_OR_EQUAL_TO": "Greater than or Equal to", "IN": "Includes", "INCLUDES": "Includes", "INCLUDES_ANY": "Includes any", "INSERT_NEW_CONDITION": "Insert New Condition", "INSERT_NEW_CONDITION_SET": "Insert New Condition Set", "IS": "Is", "IS_EMPTY": "Is empty", "IS_NOT": "Is not", "IS_NOT_EMPTY": "Is not empty", "LACKS_ALL": "Excludes all", "LAST_120_DAYS": "Last 120 days", "LAST_14_DAYS": "Last 14 days", "LAST_30_DAYS": "Last 30 days", "LAST_365_DAYS": "Last 365 days", "LAST_60_DAYS": "Last 60 days", "LAST_7_DAYS": "Last 7 days", "LAST_90_DAYS": "Last 90 days", "LESS_THAN": "Less than", "LT_OR_EQUAL_TO": "Less than or Equal to", "MANAGE_FILTERS": "Manage Filters", "MANAGE_FILTERS_ELLIPSIS": "Manage Filters...", "MONTH": "month", "MONTHS": "months", "NEW_FILTER": "New Filter", "NO": "No", "NONE": "None", "NOT_CONTAINS": "Does not contain", "NOT_EQUAL_TO": "Not equal to", "NOT_IN": "Does not include", "NO_AVAILABLE_FIELDS": "No available fields...", "NO_FILTERS_MSG": "You do not yet have any filters.", "NPS_GROUP": "NPS® group", "NUMBER": "Number", "NUMERIC_VALUE": "Numeric value", "OFFSET": "Offset", "OF_THE_FOLLOWING_ARE_TRUE": "of the following are true", "QUARTER": "quarter", "QUARTERS": "quarters", "READ_ONLY": "Read only", "REMOVE_CONDITION": "Remove Condition", "RESPONSE_COUNT": "{{count}} Responses", "SAME_AS_SUBJECT": "Same as Subject", "SAVE": "Save", "SAVED_FILTERS": "Saved Filters", "SAVE_AND_APPLY": "Save and Apply", "SEARCH": "Search", "SELECTED": "Selected", "SELECTED_CHOICE": "Selected choice", "SELECT_FIELD": "Select Field", "SELECT_ONE_OR_MORE_FIELDS": "Select one or more fields...", "SELECT_OPERAND": "Select Operand", "SELECT_OPERATOR": "Select Operator", "SHOW_ONLY_RESP": "Show only responses:", "SHOW_ONLY_WHERE_COLON": "Show only responses where:", "SURVEY_METADATA": "Survey Metadata", "TEXT": "Text", "THIS_MONTH": "This month", "THIS_QUARTER": "This quarter", "THIS_WEEK": "This week", "THIS_YEAR": "This year", "TODAY": "Today", "WEEK": "week", "WEEKS": "weeks", "YEAR": "year", "YEARS": "years", "YES": "Yes", "YESTERDAY": "Yesterday" }, "en-GB": { "ADD_CONDITION": "Add Condition", "ADD_FILTER": "Add Filter", "AFTER": "After", "ALL": "All", "ALL_FILTERS": "All", "ALL_TIME": "All Time", "AND": "and", "ANY_FILTERS": "Any", "APPLY": "Apply", "BEFORE": "Before", "BETWEEN": "Between", "BREAKOUT_MESSAGE": "Your field has more than 5,000 unique values, we will only display 5,000 of them! Change your field type to Text in the Survey Editor to enable searching for exact values.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Your filters could not be saved or applied. Please contact Qualtrics Support for more information.", "BREAKOUT_WARNING": "Warning!", "BY": "by", "CANCEL": "Cancel", "CANCEL_WITHOUT_SAVING": "Cancel Without Saving", "CHOICES": "Choices", "CLOSE": "Close", "CONFIRM_CANCEL_WITHOUT_SAVING": "You have unsaved changes. Are you sure you want to cancel without saving?", "CONFIRM_DELETE": "Are you sure you want to delete the filter '{{name}}'?", "CONTACT_FIELDS": "Contact Fields", "CONTAINS": "Contains", "COPY": "Copy", "CREATE_A_FILTER": "Create a Filter", "CREATE_NEW": "Create New", "CUSTOM_DATE_RANGE": "Custom date range", "DATE": "Date", "DELETE": "Delete", "DELETE_FILTER": "Delete Filter", "EMBEDDED_DATA": "Embedded Data", "EQUAL_TO": "Equal to", "EVALUATIONS_OTHER": "Other Evaluations (Excluding Subject's)", "EVALUATIONS_SUBJECT": "Subject's Evaluations", "EXCLUDES": "Excludes", "FILTERED_RESPONSES": "Filtered Responses", "FILTERING_BY": "Filtering by", "FILTER_ID_COLON": "Filter ID:", "FILTER_NAME_COPY": "{{name}} Copy", "GREATER_THAN": "Greater than", "GT_OR_EQUAL_TO": "Greater than or Equal to", "IN": "Includes", "INCLUDES": "Includes", "INCLUDES_ANY": "Includes any", "INSERT_NEW_CONDITION": "Insert New Condition", "INSERT_NEW_CONDITION_SET": "Insert New Condition Set", "IS": "Is", "IS_EMPTY": "Is empty", "IS_NOT": "Is not", "IS_NOT_EMPTY": "Is not empty", "LACKS_ALL": "Excludes all", "LAST_120_DAYS": "Last 120 days", "LAST_14_DAYS": "Last 14 days", "LAST_30_DAYS": "Last 30 days", "LAST_365_DAYS": "Last 365 days", "LAST_60_DAYS": "Last 60 days", "LAST_7_DAYS": "Last 7 days", "LAST_90_DAYS": "Last 90 days", "LESS_THAN": "Less than", "LT_OR_EQUAL_TO": "Less than or Equal to", "MANAGE_FILTERS": "Manage Filters", "MANAGE_FILTERS_ELLIPSIS": "Manage Filters...", "MONTH": "month", "MONTHS": "months", "NEW_FILTER": "New Filter", "NO": "No", "NONE": "None", "NOT_CONTAINS": "Does not contain", "NOT_EQUAL_TO": "Not equal to", "NOT_IN": "Does not include", "NO_AVAILABLE_FIELDS": "No available fields...", "NO_FILTERS_MSG": "You do not yet have any filters.", "NPS_GROUP": "NPS® group", "NUMBER": "Number", "NUMERIC_VALUE": "Numeric value", "OFFSET": "Offset", "OF_THE_FOLLOWING_ARE_TRUE": "of the following are true", "QUARTER": "quarter", "QUARTERS": "quarters", "READ_ONLY": "Read only", "REMOVE_CONDITION": "Remove Condition", "RESPONSE_COUNT": "{{count}} Responses", "SAME_AS_SUBJECT": "Same as Subject", "SAVE": "Save", "SAVED_FILTERS": "Saved Filters", "SAVE_AND_APPLY": "Save and Apply", "SEARCH": "Search", "SELECTED": "Selected", "SELECTED_CHOICE": "Selected choice", "SELECT_FIELD": "Select Field", "SELECT_ONE_OR_MORE_FIELDS": "Select one or more fields...", "SELECT_OPERAND": "Select Operand", "SELECT_OPERATOR": "Select Operator", "SHOW_ONLY_RESP": "Show only responses:", "SHOW_ONLY_WHERE_COLON": "Show only responses where:", "SURVEY_METADATA": "Survey Metadata", "TEXT": "Text", "THIS_MONTH": "This month", "THIS_QUARTER": "This quarter", "THIS_WEEK": "This week", "THIS_YEAR": "This year", "TODAY": "Today", "WEEK": "week", "WEEKS": "weeks", "YEAR": "year", "YEARS": "years", "YES": "Yes", "YESTERDAY": "Yesterday" }, "es": { "ADD_CONDITION": "Añadir condición", "ADD_FILTER": "Agregar filtro", "AFTER": "Después", "ALL": "Todas", "ALL_FILTERS": "Todo", "ALL_TIME": "Todo el tiempo", "AND": "y", "ANY_FILTERS": "Cualquiera", "APPLY": "Utilizar", "BEFORE": "Antes de", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "Su campo tiene más de 5000 valores exclusivos; solo mostramos 5000. Cambie el tipo de campo a Texto en el Editor de encuestas para activar la búsqueda de valores exactos.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Sus filtros no se han podido grabar o aplicar. Contacte con el soporte técnico de Qualtrics para más información.", "BREAKOUT_WARNING": "Advertencia:", "BY": "por", "CANCEL": "Cancelar", "CANCEL_WITHOUT_SAVING": "Cancelar sin guardar", "CHOICES": "Opciones", "CLOSE": "Cerrar", "CONFIRM_CANCEL_WITHOUT_SAVING": "Hay cambios sin guardar. ¿Seguro que desea cancelar sin guardar?", "CONFIRM_DELETE": "¿Seguro que desea eliminar el filtro \"{{name}}\"?", "CONTACT_FIELDS": "Campos de contacto", "CONTAINS": "Contiene", "COPY": "Copiar", "CREATE_A_FILTER": "Crear un filtro", "CREATE_NEW": "Crear nuevo", "CUSTOM_DATE_RANGE": "Rango de fechas personalizado", "DATE": "Fecha", "DELETE": "Eliminar", "DELETE_FILTER": "Eliminar filtro", "EMBEDDED_DATA": "Datos embebidos", "EQUAL_TO": "Igual a", "EVALUATIONS_OTHER": "Otras evaluaciones (excluyendo la del evaluado)", "EVALUATIONS_SUBJECT": "Evaluaciones del evaluado", "EXCLUDES": "Excluye", "FILTERED_RESPONSES": "Respuestas filtradas", "FILTERING_BY": "Filtrando por", "FILTER_ID_COLON": "ID del filtro:", "FILTER_NAME_COPY": "Copia {{name}}", "GREATER_THAN": "Mayor que", "GT_OR_EQUAL_TO": "Mayor o igual que", "IN": "Incluye", "INCLUDES": "Incluye", "INCLUDES_ANY": "Incluye cualquier/a", "INSERT_NEW_CONDITION": "Insertar nueva condición", "INSERT_NEW_CONDITION_SET": "Insertar nuevo conjunto de condiciones", "IS": "Es", "IS_EMPTY": "Está vacío", "IS_NOT": "No es", "IS_NOT_EMPTY": "No está vacío", "LACKS_ALL": "Excluye todo", "LAST_120_DAYS": "Últimos 120 días", "LAST_14_DAYS": "Últimos 14 días", "LAST_30_DAYS": "Últimos 30 días", "LAST_365_DAYS": "Últimos 365 días", "LAST_60_DAYS": "Últimos 60 días", "LAST_7_DAYS": "Últimos 7 días", "LAST_90_DAYS": "Últimos 90 días", "LESS_THAN": "Menor que", "LT_OR_EQUAL_TO": "Menor o igual que", "MANAGE_FILTERS": "Administrar filtros", "MANAGE_FILTERS_ELLIPSIS": "Gestionar filtros...", "MONTH": "mes", "MONTHS": "meses", "NEW_FILTER": "Nuevo filtro", "NO": "No", "NONE": "Ninguno", "NOT_CONTAINS": "No contiene", "NOT_EQUAL_TO": "No es igual a", "NOT_IN": "No incluye", "NO_AVAILABLE_FIELDS": "No hay campos disponibles...", "NO_FILTERS_MSG": "Todavía no tiene ningún filtro.", "NPS_GROUP": "Grupo NPS®", "NUMBER": "Número", "NUMERIC_VALUE": "Valor numérico", "OFFSET": "Antedatar", "OF_THE_FOLLOWING_ARE_TRUE": "de las siguientes se cumplen", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Solo lectura", "REMOVE_CONDITION": "Borrar condición", "RESPONSE_COUNT": "{{count}} respuestas", "SAME_AS_SUBJECT": "Mismo que el evaluado", "SAVE": "Guardar", "SAVED_FILTERS": "Filtros guardados", "SAVE_AND_APPLY": "Guardar y aplicar", "SEARCH": "Buscar", "SELECTED": "Seleccionó(aron)", "SELECTED_CHOICE": "Opción seleccionada", "SELECT_FIELD": "Elegir campo", "SELECT_ONE_OR_MORE_FIELDS": "Seleccione uno o más campos...", "SELECT_OPERAND": "Seleccionar operando", "SELECT_OPERATOR": "Seleccionar operador", "SHOW_ONLY_RESP": "Mostrar solo las respuestas:", "SHOW_ONLY_WHERE_COLON": "Mostrar sólo respuestas donde:", "SURVEY_METADATA": "Metadatos de la encuesta", "TEXT": "Texto", "THIS_MONTH": "Este mes", "THIS_QUARTER": "Este trimestre", "THIS_WEEK": "Esta semana", "THIS_YEAR": "Este año", "TODAY": "Hoy", "WEEK": "semana", "WEEKS": "semanas", "YEAR": "año", "YEARS": "años", "YES": "Sí", "YESTERDAY": "Ayer" }, "es-419": { "ADD_CONDITION": "Agregar condición", "ADD_FILTER": "Añadir filtro", "AFTER": "Después", "ALL": "Todo", "ALL_FILTERS": "Todo", "ALL_TIME": "Todo el tiempo", "AND": "y", "ANY_FILTERS": "Cualquier", "APPLY": "Aplicar", "BEFORE": "Antes", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "Su campo tiene más de 5000 valores únicos. Solo mostraremos 5000. Cambie su tipo de campo a Texto en el Editor de encuestas para permitir la búsqueda de valores exactos.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "No se han podido grabar o aplicar sus filtros. Contacte con el soporte técnico de Qualtrics para obtener más información.", "BREAKOUT_WARNING": "¡Advertencia!", "BY": "por", "CANCEL": "Cancelar", "CANCEL_WITHOUT_SAVING": "Cancelar sin guardar", "CHOICES": "Opciones", "CLOSE": "Cerrar", "CONFIRM_CANCEL_WITHOUT_SAVING": "Hay cambios sin guardar. ¿Seguro que desea cancelar sin guardar?", "CONFIRM_DELETE": "¿Seguro que desea eliminar el filtro \"{{name}}\"?", "CONTACT_FIELDS": "Campos de contacto", "CONTAINS": "Contiene", "COPY": "Copiar", "CREATE_A_FILTER": "Crear un filtro", "CREATE_NEW": "Crear nuevo", "CUSTOM_DATE_RANGE": "Rango de fechas personalizado", "DATE": "Fecha", "DELETE": "Eliminar", "DELETE_FILTER": "Eliminar filtro", "EMBEDDED_DATA": "Datos embebidos", "EQUAL_TO": "Igual a", "EVALUATIONS_OTHER": "Otras evaluaciones (sin incluir las del sujeto)", "EVALUATIONS_SUBJECT": "Evaluaciones del sujeto", "EXCLUDES": "Excluye", "FILTERED_RESPONSES": "Respuestas filtradas", "FILTERING_BY": "Filtrando por", "FILTER_ID_COLON": "ID de filtro:", "FILTER_NAME_COPY": "{{name}} copia", "GREATER_THAN": "Mayor que", "GT_OR_EQUAL_TO": "Mayor que o igual a", "IN": "Incluye", "INCLUDES": "Incluye", "INCLUDES_ANY": "Incluye cualquier/a", "INSERT_NEW_CONDITION": "Insertar nueva condición", "INSERT_NEW_CONDITION_SET": "Insertar nuevo conjunto de condiciones", "IS": "Es", "IS_EMPTY": "Está vacío", "IS_NOT": "No es", "IS_NOT_EMPTY": "No está vacío", "LACKS_ALL": "Excluye todo", "LAST_120_DAYS": "Últimos 120 días", "LAST_14_DAYS": "Últimos 14 días", "LAST_30_DAYS": "Últimos 30 días", "LAST_365_DAYS": "Últimos 365 días", "LAST_60_DAYS": "Últimos 60 días", "LAST_7_DAYS": "Últimos 7 días", "LAST_90_DAYS": "Últimos 90 días", "LESS_THAN": "Menor que", "LT_OR_EQUAL_TO": "Menor que o igual a", "MANAGE_FILTERS": "Gestión de filtros", "MANAGE_FILTERS_ELLIPSIS": "Administrar filtros...", "MONTH": "mes", "MONTHS": "meses", "NEW_FILTER": "Nuevo filtro", "NO": "No", "NONE": "Ninguno", "NOT_CONTAINS": "No contiene", "NOT_EQUAL_TO": "No es igual a", "NOT_IN": "No incluye", "NO_AVAILABLE_FIELDS": "No hay campos disponibles...", "NO_FILTERS_MSG": "No tiene ningún filtro aún.", "NPS_GROUP": "Grupo NPS®", "NUMBER": "Número", "NUMERIC_VALUE": "Valor numérico", "OFFSET": "Datos anteriores a", "OF_THE_FOLLOWING_ARE_TRUE": "de las siguientes son verdaderas", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Solo lectura", "REMOVE_CONDITION": "Eliminar condición", "RESPONSE_COUNT": "{{count}} respuestas", "SAME_AS_SUBJECT": "Igual que el asunto", "SAVE": "Guardar", "SAVED_FILTERS": "Filtros guardados", "SAVE_AND_APPLY": "Guardar y aplicar", "SEARCH": "Buscar", "SELECTED": "Seleccionaron", "SELECTED_CHOICE": "Opción seleccionada", "SELECT_FIELD": "Elegir campo", "SELECT_ONE_OR_MORE_FIELDS": "Seleccione uno o más campos...", "SELECT_OPERAND": "Seleccionar operando", "SELECT_OPERATOR": "Seleccionar operador", "SHOW_ONLY_RESP": "Mostrar las respuestas solamente:", "SHOW_ONLY_WHERE_COLON": "Mostrar las respuestas solamente que:", "SURVEY_METADATA": "Metadatos de la encuesta", "TEXT": "Texto", "THIS_MONTH": "Este mes", "THIS_QUARTER": "Este trimestre", "THIS_WEEK": "Esta semana", "THIS_YEAR": "Este año", "TODAY": "Hoy", "WEEK": "semana", "WEEKS": "semanas", "YEAR": "año", "YEARS": "años", "YES": "Sí", "YESTERDAY": "Ayer" }, "fi": { "ADD_CONDITION": "Lisää ehto", "ADD_FILTER": "Lisää suodatin", "AFTER": "Jälkeen", "ALL": "Kaikki", "ALL_FILTERS": "Kaikki", "ALL_TIME": "Kaikki aika", "AND": "ja", "ANY_FILTERS": "Mikään", "APPLY": "Käytä", "BEFORE": "Ennen", "BETWEEN": "Välillä", "BREAKOUT_MESSAGE": "Kentässä on yli 5 000 yksilöllistä arvoa, ja niistä voidaan näyttää vain 5 000. Mahdollista tarkkojen arvojen haku muuttamalla kyselyn muokkaajassa kenttätyypiksi Teksti.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Suodattimiasi ei voitu tallentaa tai käyttää. Saat lisätietoja ottamalla yhteyttä Qualtrics-tukeen.", "BREAKOUT_WARNING": "Varoitus!", "BY": "tekijä", "CANCEL": "Peruuta", "CANCEL_WITHOUT_SAVING": "Peru tallentamatta", "CHOICES": "Valinnat", "CLOSE": "Sulje", "CONFIRM_CANCEL_WITHOUT_SAVING": "Sinulla on tallentamattomia muutoksia. Haluatko varmasti perua tallentamatta?", "CONFIRM_DELETE": "Haluatko varmasti poistaa suodattimen {{name}}?", "CONTACT_FIELDS": "Yhteystietokentät", "CONTAINS": "Sisältää", "COPY": "Kopioi", "CREATE_A_FILTER": "Luo suodatin", "CREATE_NEW": "Luo uusi", "CUSTOM_DATE_RANGE": "Mukautettu aikaväli", "DATE": "Päivämäärä", "DELETE": "Poista", "DELETE_FILTER": "Poista suodatin", "EMBEDDED_DATA": "Taustatiedot", "EQUAL_TO": "Sama kuin", "EVALUATIONS_OTHER": "Muut arvioinnit (pois lukien kohde)", "EVALUATIONS_SUBJECT": "Kohteen arvioinnit", "EXCLUDES": "Ei sisällä", "FILTERED_RESPONSES": "Suodatetut vastaukset", "FILTERING_BY": "Suodatusperuste", "FILTER_ID_COLON": "Suodattimen tunnus:", "FILTER_NAME_COPY": "{{name}}: kopio", "GREATER_THAN": "Suurempi kuin", "GT_OR_EQUAL_TO": "Suurempi tai sama kuin", "IN": "Sisältyä", "INCLUDES": "Sisältyä", "INCLUDES_ANY": "Sisältyä jonkin", "INSERT_NEW_CONDITION": "Lisää uusi ehto", "INSERT_NEW_CONDITION_SET": "Lisää uusi ehtosarja", "IS": "On", "IS_EMPTY": "On tyhjä", "IS_NOT": "Ei ole", "IS_NOT_EMPTY": "Ei ole tyhjä", "LACKS_ALL": "Ei sisällä kaikkia", "LAST_120_DAYS": "Viimeiset 120 päivää", "LAST_14_DAYS": "Viimeiset 14 päivää", "LAST_30_DAYS": "Viimeiset 30 päivää", "LAST_365_DAYS": "Viimeiset 365 päivää", "LAST_60_DAYS": "Viimeiset 60 päivää", "LAST_7_DAYS": "Viimeiset 7 päivää", "LAST_90_DAYS": "Viimeiset 90 päivää", "LESS_THAN": "Pienempi kuin", "LT_OR_EQUAL_TO": "Pienempi tai sama kuin", "MANAGE_FILTERS": "Hallitse suodattimia", "MANAGE_FILTERS_ELLIPSIS": "Hallitse suodattimia...", "MONTH": "kuukausi", "MONTHS": "kuukautta", "NEW_FILTER": "Uusi suodatin", "NO": "Ei", "NONE": "Ei mitään", "NOT_CONTAINS": "Ei sisällä", "NOT_EQUAL_TO": "Eri kuin", "NOT_IN": "Ei sisällä", "NO_AVAILABLE_FIELDS": "Ei käytettäviä kenttiä...", "NO_FILTERS_MSG": "Sinulla ei ole vielä suodattimia.", "NPS_GROUP": "NPS®-ryhmä", "NUMBER": "Numero", "NUMERIC_VALUE": "Numeerinen arvo", "OFFSET": "Siirtymä", "OF_THE_FOLLOWING_ARE_TRUE": "seuraavista on totta", "QUARTER": "vuosineljännes", "QUARTERS": "vuosineljännestä", "READ_ONLY": "Vain luku", "REMOVE_CONDITION": "Poista ehto", "RESPONSE_COUNT": "{{count}} vastausta", "SAME_AS_SUBJECT": "Sama kuin kohde", "SAVE": "Tallenna", "SAVED_FILTERS": "Tallennetut suodattimet", "SAVE_AND_APPLY": "Tallenna ja käytä", "SEARCH": "Haku", "SELECTED": "Valittu", "SELECTED_CHOICE": "Valittu valinta", "SELECT_FIELD": "Valitse kenttä", "SELECT_ONE_OR_MORE_FIELDS": "Valitse vähintään yksi kenttä...", "SELECT_OPERAND": "Valitse kohdemuuttuja", "SELECT_OPERATOR": "Valitse operaattori", "SHOW_ONLY_RESP": "Näytä vain vastaukset:", "SHOW_ONLY_WHERE_COLON": "Näytä vain vastaukset, joissa:", "SURVEY_METADATA": "Kyselyn metatiedot", "TEXT": "Teksti", "THIS_MONTH": "Tämä kuukausi", "THIS_QUARTER": "Tämä vuosineljännes", "THIS_WEEK": "Tämä viikko", "THIS_YEAR": "Tämä vuosi", "TODAY": "Tänään", "WEEK": "viikko", "WEEKS": "viikkoa", "YEAR": "vuosi", "YEARS": "vuotta", "YES": "Kyllä", "YESTERDAY": "Eilen" }, "fr": { "ADD_CONDITION": "Ajouter une condition", "ADD_FILTER": "Ajouter un filtre", "AFTER": "Après", "ALL": "Tous", "ALL_FILTERS": "Tous", "ALL_TIME": "Tout le temps", "AND": "et", "ANY_FILTERS": "N'importe", "APPLY": "Appliquer", "BEFORE": "Avant", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "Votre champ contient plus de 5 000 valeurs uniques. Nous n'en afficherons que 5 000. Veuillez modifier le type de champ en Texte dans l'éditeur d'enquête pour activer la recherche de valeurs exactes.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Impossible d'enregistrer ou appliquer vos filtres. Pour en savoir plus, veuillez contacter le support de Qualtrics.", "BREAKOUT_WARNING": "Avertissement !", "BY": "par", "CANCEL": "Annuler", "CANCEL_WITHOUT_SAVING": "Annuler sans sauvegarde", "CHOICES": "Choix", "CLOSE": "Clôturer", "CONFIRM_CANCEL_WITHOUT_SAVING": "Des modifications n’ont pas été enregistrées. Êtes-vous sûr de vouloir annuler sans sauvegarder ?", "CONFIRM_DELETE": "Êtes-vous sûr de vouloir supprimer le filtre '{{name}}' ?", "CONTACT_FIELDS": "Champs de contact", "CONTAINS": "Contient", "COPY": "Copier", "CREATE_A_FILTER": "Créer un filtre", "CREATE_NEW": "Créer un membre", "CUSTOM_DATE_RANGE": "Plage de dates personnalisée", "DATE": "Date", "DELETE": "Supprimer", "DELETE_FILTER": "Supprimer un filtre", "EMBEDDED_DATA": "Données intégrées", "EQUAL_TO": "Égal à", "EVALUATIONS_OTHER": "Autres évaluations (à l'exception de la personne évaluée)", "EVALUATIONS_SUBJECT": "Évaluations de la personne évaluée", "EXCLUDES": "Exclut", "FILTERED_RESPONSES": "Réponses filtrées", "FILTERING_BY": "Filtré par", "FILTER_ID_COLON": "ID du filtre :", "FILTER_NAME_COPY": "Copie {{name}}", "GREATER_THAN": "Supérieur à", "GT_OR_EQUAL_TO": "Supérieur ou égal à", "IN": "Inclut", "INCLUDES": "Inclut", "INCLUDES_ANY": "Inclut chaque", "INSERT_NEW_CONDITION": "Insérer une nouvelle condition", "INSERT_NEW_CONDITION_SET": "Insérer un nouvel ensemble de conditions", "IS": "Est", "IS_EMPTY": "Est vide", "IS_NOT": "N'est pas", "IS_NOT_EMPTY": "N'est pas vide", "LACKS_ALL": "Exclut tout", "LAST_120_DAYS": "120 derniers jours", "LAST_14_DAYS": "14 derniers jours", "LAST_30_DAYS": "30 derniers jours", "LAST_365_DAYS": "365 derniers jours", "LAST_60_DAYS": "60 derniers jours", "LAST_7_DAYS": "7 derniers jours", "LAST_90_DAYS": "90 derniers jours", "LESS_THAN": "Inférieur à", "LT_OR_EQUAL_TO": "Inférieur ou égal à", "MANAGE_FILTERS": "Gérer les filtres", "MANAGE_FILTERS_ELLIPSIS": "Gérer les filtres...", "MONTH": "mois", "MONTHS": "mois", "NEW_FILTER": "Nouveau filtre", "NO": "Non", "NONE": "Aucun", "NOT_CONTAINS": "Ne contient pas", "NOT_EQUAL_TO": "N'est pas égal à", "NOT_IN": "N'inclut pas", "NO_AVAILABLE_FIELDS": "Aucun champ disponible...", "NO_FILTERS_MSG": "Vous n’avez pas encore de filtres.", "NPS_GROUP": "Groupe NPS®", "NUMBER": "Nombre", "NUMERIC_VALUE": "Valeur numérique", "OFFSET": "Antériorité", "OF_THE_FOLLOWING_ARE_TRUE": "des éléments suivants sont vrais", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Lecture seule", "REMOVE_CONDITION": "Supprimer la condition", "RESPONSE_COUNT": "{{count}} réponses", "SAME_AS_SUBJECT": "Identique à la personne évaluée", "SAVE": "Enregistrer", "SAVED_FILTERS": "Filtres enregistrés", "SAVE_AND_APPLY": "Sauvegarder et appliquer", "SEARCH": "Recherche", "SELECTED": "A sélectionné", "SELECTED_CHOICE": "Choix sélectionné", "SELECT_FIELD": "Sélectionnez un champ", "SELECT_ONE_OR_MORE_FIELDS": "Sélectionner un champ ou plus...", "SELECT_OPERAND": "Sélectionnez une opérande", "SELECT_OPERATOR": "Sélectionnez un opérateur", "SHOW_ONLY_RESP": "Afficher uniquement les réponses :", "SHOW_ONLY_WHERE_COLON": "Afficher uniquement les réponses où :", "SURVEY_METADATA": "Métadonnées de l'enquête", "TEXT": "Texte", "THIS_MONTH": "Ce mois-ci", "THIS_QUARTER": "Ce trimestre-ci", "THIS_WEEK": "Cette semaine", "THIS_YEAR": "Cette année", "TODAY": "Aujourd'hui", "WEEK": "semaine", "WEEKS": "semaines", "YEAR": "année", "YEARS": "années", "YES": "Oui", "YESTERDAY": "Hier" }, "fr-CA": { "ADD_CONDITION": "Ajouter une condition", "ADD_FILTER": "Ajouter un filtre", "AFTER": "Après", "ALL": "Tous", "ALL_FILTERS": "Tous", "ALL_TIME": "Tout le temps", "AND": "et", "ANY_FILTERS": "N'importe", "APPLY": "Appliquer", "BEFORE": "Avant", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "Votre champ contient plus de 5 000 valeurs uniques. Nous n'en afficherons que 5 000. Veuillez modifier le type de champ en Texte dans l'éditeur d'enquête pour activer la recherche de valeurs exactes.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Impossible d'enregistrer ou appliquer vos filtres. Pour en savoir plus, veuillez contacter le soutien de Qualtrics.", "BREAKOUT_WARNING": "Avertissement!", "BY": "par", "CANCEL": "Annuler", "CANCEL_WITHOUT_SAVING": "Annuler sans sauvegarde", "CHOICES": "Choix", "CLOSE": "Clôturer", "CONFIRM_CANCEL_WITHOUT_SAVING": "Des modifications n’ont pas été enregistrées. Voulez-vous vraiment annuler sans sauvegarder?", "CONFIRM_DELETE": "Voulez-vous vraiment supprimer le filtre '{{name}}'?", "CONTACT_FIELDS": "Champs de contact", "CONTAINS": "Contient", "COPY": "Copier", "CREATE_A_FILTER": "Créer un filtre", "CREATE_NEW": "Créer un membre", "CUSTOM_DATE_RANGE": "Plage de dates personnalisée", "DATE": "Date", "DELETE": "Supprimer", "DELETE_FILTER": "Supprimer un filtre", "EMBEDDED_DATA": "Données intégrées", "EQUAL_TO": "Égal à", "EVALUATIONS_OTHER": "Autres évaluations (à l'exception de la personne évaluée)", "EVALUATIONS_SUBJECT": "Évaluations de la personne évaluée", "EXCLUDES": "Exclut", "FILTERED_RESPONSES": "Réponses filtrées", "FILTERING_BY": "Filtré par", "FILTER_ID_COLON": "ID du filtre :", "FILTER_NAME_COPY": "Copie {{name}}", "GREATER_THAN": "Supérieur à", "GT_OR_EQUAL_TO": "Supérieur ou égal à", "IN": "Inclut", "INCLUDES": "Inclut", "INCLUDES_ANY": "Inclut chaque", "INSERT_NEW_CONDITION": "Insérer une nouvelle condition", "INSERT_NEW_CONDITION_SET": "Insérer un nouvel ensemble de conditions", "IS": "Est", "IS_EMPTY": "Est vide", "IS_NOT": "N'est pas", "IS_NOT_EMPTY": "N'est pas vide", "LACKS_ALL": "Exclut tout", "LAST_120_DAYS": "120 derniers jours", "LAST_14_DAYS": "14 derniers jours", "LAST_30_DAYS": "30 derniers jours", "LAST_365_DAYS": "365 derniers jours", "LAST_60_DAYS": "60 derniers jours", "LAST_7_DAYS": "7 derniers jours", "LAST_90_DAYS": "90 derniers jours", "LESS_THAN": "Inférieur à", "LT_OR_EQUAL_TO": "Inférieur ou égal à", "MANAGE_FILTERS": "Gérer les filtres", "MANAGE_FILTERS_ELLIPSIS": "Gérer les filtres…", "MONTH": "mois", "MONTHS": "mois", "NEW_FILTER": "Nouveau filtre", "NO": "Non", "NONE": "Aucun", "NOT_CONTAINS": "Ne contient pas", "NOT_EQUAL_TO": "N'est pas égal à", "NOT_IN": "N'inclut pas", "NO_AVAILABLE_FIELDS": "Aucun champ disponible…", "NO_FILTERS_MSG": "Vous n’avez pas encore de filtres.", "NPS_GROUP": "Groupe NPS®", "NUMBER": "Nombre", "NUMERIC_VALUE": "Valeur numérique", "OFFSET": "Antériorité", "OF_THE_FOLLOWING_ARE_TRUE": "des éléments suivants sont vrais", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Lecture seule", "REMOVE_CONDITION": "Supprimer la condition", "RESPONSE_COUNT": "{{count}} réponses", "SAME_AS_SUBJECT": "Identique à la personne évaluée", "SAVE": "Enregistrer", "SAVED_FILTERS": "Filtres enregistrés", "SAVE_AND_APPLY": "Sauvegarder et appliquer", "SEARCH": "Recherche…", "SELECTED": "A sélectionné", "SELECTED_CHOICE": "Choix sélectionné", "SELECT_FIELD": "Sélectionnez un champ", "SELECT_ONE_OR_MORE_FIELDS": "Sélectionner un champ ou plus…", "SELECT_OPERAND": "Sélectionnez une opérande", "SELECT_OPERATOR": "Sélectionnez un opérateur", "SHOW_ONLY_RESP": "Afficher uniquement les réponses :", "SHOW_ONLY_WHERE_COLON": "Afficher uniquement les réponses où :", "SURVEY_METADATA": "Métadonnées de l'enquête", "TEXT": "Texte", "THIS_MONTH": "Ce mois-ci", "THIS_QUARTER": "Ce trimestre-ci", "THIS_WEEK": "Cette semaine", "THIS_YEAR": "Cette année", "TODAY": "Aujourd'hui", "WEEK": "semaine", "WEEKS": "semaines", "YEAR": "année", "YEARS": "années", "YES": "Oui", "YESTERDAY": "Hier" }, "id": { "ADD_CONDITION": "Tambahkan Kondisi", "ADD_FILTER": "Tambahkan Filter", "AFTER": "Setelah", "ALL": "Semua", "ALL_FILTERS": "Semua", "ALL_TIME": "Semua Waktu", "AND": "dan", "ANY_FILTERS": "Setiap", "APPLY": "Terapkan", "BEFORE": "Sebelum", "BETWEEN": "Antara", "BREAKOUT_MESSAGE": "Bidang Anda memiliki lebih dari 5000 nilai unik, kami hanya akan menampilkan 5000 di antaranya! Ubah tipe bidang Anda ke Teks dalam Editor Survei untuk mengaktifkan pencarian untuk nilai yang tepat.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Filter Anda tidak dapat disimpan atau diterapkan. Silakan hubungi Dukungan Qualtrics untuk informasi selengkapnya.", "BREAKOUT_WARNING": "Peringatan!", "BY": "oleh", "CANCEL": "Batalkan", "CANCEL_WITHOUT_SAVING": "Batalkan Tanpa Menyimpan", "CHOICES": "Pilihan", "CLOSE": "Tutup", "CONFIRM_CANCEL_WITHOUT_SAVING": "Anda memiliki perubahan yang belum disimpan. Anda yakin ingin membatalkan tanpa menyimpan?", "CONFIRM_DELETE": "Anda yakin ingin menghapus filter '{{name}}'?", "CONTACT_FIELDS": "Bidang Kontak", "CONTAINS": "Berisi", "COPY": "Salin", "CREATE_A_FILTER": "Buat Filter", "CREATE_NEW": "Buat Baru", "CUSTOM_DATE_RANGE": "Rentang tanggal kustom", "DATE": "Tanggal", "DELETE": "Hapus", "DELETE_FILTER": "Hapus Filter", "EMBEDDED_DATA": "Data Tersemat", "EQUAL_TO": "Sama dengan", "EVALUATIONS_OTHER": "Evaluasi Lain (Tidak Termasuk Milik Subjek)", "EVALUATIONS_SUBJECT": "Evaluasi Subjek", "EXCLUDES": "Kecualikan", "FILTERED_RESPONSES": "Respons yang Difilter", "FILTERING_BY": "Pemfilteran berdasarkan", "FILTER_ID_COLON": "ID Filter:", "FILTER_NAME_COPY": "{{name}} Salin", "GREATER_THAN": "Lebih dari", "GT_OR_EQUAL_TO": "Lebih dari atau Sama dengan", "IN": "Mencakup", "INCLUDES": "Mencakup", "INCLUDES_ANY": "Sertakan setiap", "INSERT_NEW_CONDITION": "Masukkan Kondisi Baru", "INSERT_NEW_CONDITION_SET": "Masukkan Himpunan Kondisi Baru", "IS": "Yaitu", "IS_EMPTY": "Kosong", "IS_NOT": "Tidak", "IS_NOT_EMPTY": "Tidak kosong", "LACKS_ALL": "Kecualikan semua", "LAST_120_DAYS": "120 hari terakhir", "LAST_14_DAYS": "14 hari terakhir", "LAST_30_DAYS": "30 hari terakhir", "LAST_365_DAYS": "365 hari terakhir", "LAST_60_DAYS": "60 hari terakhir", "LAST_7_DAYS": "7 hari terakhir", "LAST_90_DAYS": "90 hari terakhir", "LESS_THAN": "Kurang dari", "LT_OR_EQUAL_TO": "Kurang dari atau Sama dengan", "MANAGE_FILTERS": "Kelola Filter", "MANAGE_FILTERS_ELLIPSIS": "Kelola Filter...", "MONTH": "bulan", "MONTHS": "bulan", "NEW_FILTER": "Filter Baru", "NO": "Tidak", "NONE": "Tidak Ada", "NOT_CONTAINS": "Tidak berisi", "NOT_EQUAL_TO": "Tidak sama dengan", "NOT_IN": "Tidak mencakup", "NO_AVAILABLE_FIELDS": "Tidak tersedia bidang...", "NO_FILTERS_MSG": "Anda tidak memiliki filter apa pun.", "NPS_GROUP": "NPS® group", "NUMBER": "Angka", "NUMERIC_VALUE": "Nilai numerik", "OFFSET": "Offset", "OF_THE_FOLLOWING_ARE_TRUE": "dari hal berikut ini adalah benar", "QUARTER": "triwulan", "QUARTERS": "triwulan", "READ_ONLY": "Hanya baca", "REMOVE_CONDITION": "Hapus Kondisi", "RESPONSE_COUNT": "{{count}} Respons", "SAME_AS_SUBJECT": "Sama dengan Subjek", "SAVE": "Simpan", "SAVED_FILTERS": "Filter yang Disimpan", "SAVE_AND_APPLY": "Simpan dan Terapkan", "SEARCH": "Cari", "SELECTED": "Dipilih", "SELECTED_CHOICE": "Pilihan yang dipilih", "SELECT_FIELD": "Pilih Bidang", "SELECT_ONE_OR_MORE_FIELDS": "Pilih satu bidang atau lebih...", "SELECT_OPERAND": "Pilih Operan", "SELECT_OPERATOR": "Pilih Operator", "SHOW_ONLY_RESP": "Hanya tampilkan respons:", "SHOW_ONLY_WHERE_COLON": "Tampilkan hanya respons di mana:", "SURVEY_METADATA": "Metadata Survei", "TEXT": "Teks", "THIS_MONTH": "Bulan ini", "THIS_QUARTER": "Triwulan ini", "THIS_WEEK": "Minggu ini", "THIS_YEAR": "Tahun ini", "TODAY": "Hari Ini", "WEEK": "minggu", "WEEKS": "minggu", "YEAR": "tahun", "YEARS": "tahun", "YES": "Ya", "YESTERDAY": "Kemarin" }, "it": { "ADD_CONDITION": "Aggiungi condizione", "ADD_FILTER": "Aggiungi filtro", "AFTER": "Prima", "ALL": "Tutto", "ALL_FILTERS": "Tutto", "ALL_TIME": "Sempre", "AND": "e", "ANY_FILTERS": "Qualsiasi", "APPLY": "Applicare", "BEFORE": "Prima", "BETWEEN": "Tra", "BREAKOUT_MESSAGE": "Il campo contiene più di 5000 valori univoci, ne saranno visualizzati solo 5000! Modifica il tipo di campo in Testo nell'editor del sondaggio per consentire la ricerca di valori esatti.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Non è possibile salvare o applicare i tuoi filtri. Per ulteriori informazioni contattare il supporto Qualtrics", "BREAKOUT_WARNING": "Avviso!", "BY": "di", "CANCEL": "Annullare", "CANCEL_WITHOUT_SAVING": "Annulla senza salvare", "CHOICES": "Scelte", "CLOSE": "Chiudi", "CONFIRM_CANCEL_WITHOUT_SAVING": "Ci sono modifiche non salvate. Annullare senza salvare?", "CONFIRM_DELETE": "Eliminare questo filtro?{{name}}", "CONTACT_FIELDS": "Campi contatto", "CONTAINS": "Contiene", "COPY": "Copia", "CREATE_A_FILTER": "Crea un filtro", "CREATE_NEW": "Crea nuovo", "CUSTOM_DATE_RANGE": "Intervallo date personalizzato", "DATE": "Data", "DELETE": "Elimina", "DELETE_FILTER": "Elimina filtro", "EMBEDDED_DATA": "Dati incorporati", "EQUAL_TO": "Uguale a", "EVALUATIONS_OTHER": "Altre valutazioni (escluse quelle del soggetto valutazione)", "EVALUATIONS_SUBJECT": "Valutazioni del soggetto valutazione", "EXCLUDES": "Esclude", "FILTERED_RESPONSES": "Risposte filtrate", "FILTERING_BY": "Filtro per", "FILTER_ID_COLON": "ID filtro:", "FILTER_NAME_COPY": "{{name}} copia", "GREATER_THAN": "Maggiore di", "GT_OR_EQUAL_TO": "Maggiore di o uguale a", "IN": "Include", "INCLUDES": "Include", "INCLUDES_ANY": "Include ogni", "INSERT_NEW_CONDITION": "Inserisci nuova condizione", "INSERT_NEW_CONDITION_SET": "Inserisci nuova serie di condizioni", "IS": "È", "IS_EMPTY": "È vuoto", "IS_NOT": "Non è", "IS_NOT_EMPTY": "Non è vuoto", "LACKS_ALL": "Esclude tutto", "LAST_120_DAYS": "Ultimi 120 giorni", "LAST_14_DAYS": "Ultimi 14 giorni", "LAST_30_DAYS": "Ultimi 30 giorni", "LAST_365_DAYS": "Ultimi 365 giorni", "LAST_60_DAYS": "Ultimi 60 giorni", "LAST_7_DAYS": "Ultimi 7 giorni", "LAST_90_DAYS": "Ultimi 90 giorni", "LESS_THAN": "Minore di", "LT_OR_EQUAL_TO": "Minore di o uguale a", "MANAGE_FILTERS": "Gestisci filtri", "MANAGE_FILTERS_ELLIPSIS": "Gestisci filtri...", "MONTH": "mese", "MONTHS": "mesi", "NEW_FILTER": "Nuovo filtro", "NO": "No", "NONE": "Nessuno", "NOT_CONTAINS": "Non contiene", "NOT_EQUAL_TO": "Non uguale a", "NOT_IN": "Non include", "NO_AVAILABLE_FIELDS": "Nessun campo disponibile...", "NO_FILTERS_MSG": "Non hai ancora nessun filtro.", "NPS_GROUP": "Gruppo NPS®", "NUMBER": "Numero", "NUMERIC_VALUE": "Valore numerico", "OFFSET": "Anticipo", "OF_THE_FOLLOWING_ARE_TRUE": "delle seguenti sono vere", "QUARTER": "trimestre", "QUARTERS": "trimestri", "READ_ONLY": "Sola lettura", "REMOVE_CONDITION": "Rimuovi condizione", "RESPONSE_COUNT": "{{count}} risposte", "SAME_AS_SUBJECT": "Uguale al soggetto valutazione", "SAVE": "Salva", "SAVED_FILTERS": "Filtri salvati", "SAVE_AND_APPLY": "Salva e applica", "SEARCH": "Cerca", "SELECTED": "Ha selezionato", "SELECTED_CHOICE": "Scelta selezionata", "SELECT_FIELD": "Seleziona campo", "SELECT_ONE_OR_MORE_FIELDS": "Seleziona uno o più campi...", "SELECT_OPERAND": "Seleziona operando", "SELECT_OPERATOR": "Seleziona operatore", "SHOW_ONLY_RESP": "Mostra solo risposte:", "SHOW_ONLY_WHERE_COLON": "Mostra solo le risposte dove:", "SURVEY_METADATA": "Metadati del sondaggio", "TEXT": "Testo", "THIS_MONTH": "Questo mese", "THIS_QUARTER": "Questo trimestre", "THIS_WEEK": "Questa settimana", "THIS_YEAR": "Questo anno", "TODAY": "Oggi", "WEEK": "settimana", "WEEKS": "settimane", "YEAR": "anno", "YEARS": "anni", "YES": "Sì", "YESTERDAY": "Ieri" }, "ja": { "ADD_CONDITION": "条件を追加", "ADD_FILTER": "フィルタを追加", "AFTER": "次より後", "ALL": "すべて", "ALL_FILTERS": "すべて", "ALL_TIME": "すべての時間", "AND": "および", "ANY_FILTERS": "いずれか", "APPLY": "適用", "BEFORE": "次より前", "BETWEEN": "次の範囲", "BREAKOUT_MESSAGE": "フィールドに5000を超える一意の値が入力されています。そのうちの5000までしか表示されません。アンケートエディターでフィールドタイプをテキストに変更し、正確な値を検索できるようにしてください。", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "フィルタを保存または適用できませんでした。詳細は、クアルトリクスサポートにお問い合わせください。", "BREAKOUT_WARNING": "警告！", "BY": "基準：", "CANCEL": "キャンセル", "CANCEL_WITHOUT_SAVING": "合計の閲覧ページ数", "CHOICES": "選択肢", "CLOSE": "閉じる", "CONFIRM_CANCEL_WITHOUT_SAVING": "保存されていない変更があります。保存せずにキャンセルしてよろしいですか？", "CONFIRM_DELETE": "「{{name}}」フィルタを削除してもよろしいですか？", "CONTACT_FIELDS": "連絡先フィールド", "CONTAINS": "次を含む", "COPY": "コピー", "CREATE_A_FILTER": "フィルタを作成", "CREATE_NEW": "新規作成", "CUSTOM_DATE_RANGE": "カスタム設定の日付範囲", "DATE": "日付", "DELETE": "削除", "DELETE_FILTER": "フィルタを削除", "EMBEDDED_DATA": "埋め込みデータ", "EQUAL_TO": "次と等しい", "EVALUATIONS_OTHER": "その他の評価（対象者の評価を除く）", "EVALUATIONS_SUBJECT": "対象者の評価", "EXCLUDES": "除く", "FILTERED_RESPONSES": "フィルタリングした回答", "FILTERING_BY": "フィルタリング基準", "FILTER_ID_COLON": "フィルタID：", "FILTER_NAME_COPY": "{{name}}コピー", "GREATER_THAN": "次の数より大きい", "GT_OR_EQUAL_TO": "次の数以上", "IN": "次を含める", "INCLUDES": "次を含める", "INCLUDES_ANY": "次のすべてを含める", "INSERT_NEW_CONDITION": "新しい条件を挿入", "INSERT_NEW_CONDITION_SET": "新しい条件セットを挿入", "IS": "が", "IS_EMPTY": "空白である", "IS_NOT": "でない", "IS_NOT_EMPTY": "空白でない", "LACKS_ALL": "すべてを除く", "LAST_120_DAYS": "過去120日間", "LAST_14_DAYS": "過去14日間", "LAST_30_DAYS": "過去30日間", "LAST_365_DAYS": "過去365日間", "LAST_60_DAYS": "過去60日間", "LAST_7_DAYS": "過去7日間", "LAST_90_DAYS": "過去90日間", "LESS_THAN": "次の数より小さい", "LT_OR_EQUAL_TO": "次の数以下", "MANAGE_FILTERS": "フィルタを管理", "MANAGE_FILTERS_ELLIPSIS": "フィルタを管理…", "MONTH": "月", "MONTHS": "か月", "NEW_FILTER": "新しいフィルタ", "NO": "いいえ", "NONE": "なし", "NOT_CONTAINS": "含まない", "NOT_EQUAL_TO": "次と等しくない", "NOT_IN": "次を含まない", "NO_AVAILABLE_FIELDS": "利用できるフィールドなし...", "NO_FILTERS_MSG": "フィルタが設定されていません。", "NPS_GROUP": "NPS®グループ", "NUMBER": "数字", "NUMERIC_VALUE": "数値", "OFFSET": "オフセット", "OF_THE_FOLLOWING_ARE_TRUE": "次のうち正しい数", "QUARTER": "四半期", "QUARTERS": "四半期", "READ_ONLY": "読み取り専用", "REMOVE_CONDITION": "条件を削除", "RESPONSE_COUNT": "{{count}}件の回答", "SAME_AS_SUBJECT": "被評価者と同じ", "SAVE": "保存", "SAVED_FILTERS": "保存済みのフィルタ", "SAVE_AND_APPLY": "保存して適用", "SEARCH": "検索", "SELECTED": "選択済み", "SELECTED_CHOICE": "選択された選択肢", "SELECT_FIELD": "フィールドを選択", "SELECT_ONE_OR_MORE_FIELDS": "1つ以上のフィールドを選択...", "SELECT_OPERAND": "オペランドを選択", "SELECT_OPERATOR": "演算子を選択", "SHOW_ONLY_RESP": "回答のみ表示：", "SHOW_ONLY_WHERE_COLON": "次の条件に当てはまる回答のみ表示：", "SURVEY_METADATA": "アンケートのメタデータ", "TEXT": "テキスト", "THIS_MONTH": "今月", "THIS_QUARTER": "今四半期", "THIS_WEEK": "今週", "THIS_YEAR": "今年", "TODAY": "今日", "WEEK": "週", "WEEKS": "週", "YEAR": "年", "YEARS": "年", "YES": "はい", "YESTERDAY": "昨日" }, "ko": { "ADD_CONDITION": "조건 추가", "ADD_FILTER": "필터 추가", "AFTER": "이후", "ALL": "모두", "ALL_FILTERS": "모든", "ALL_TIME": "모든 시간", "AND": "및", "ANY_FILTERS": "하나라도", "APPLY": "적용", "BEFORE": "이전", "BETWEEN": "다음 범위 내", "BREAKOUT_MESSAGE": "필드 고유값이 5,000개만 표시되는 데 5,000개를 넘었습니다. 정확한 값을 검색할 수 있도록 설문조사 편집기에서 필드 유형을 텍스트로 변경하십시오.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "필터를 저장하거나 적용할 수 없습니다. 자세한 내용은 Qualtrics 지원 서비스에 문의하십시오.", "BREAKOUT_WARNING": "경고!", "BY": "작성자", "CANCEL": "취소", "CANCEL_WITHOUT_SAVING": "저장하지 않고 취소", "CHOICES": "선택 항목", "CLOSE": "닫기", "CONFIRM_CANCEL_WITHOUT_SAVING": "저장하지 않은 변경 사항이 있습니다. 저장하지 않고 취소하시겠습니까?", "CONFIRM_DELETE": "이 '{{name}}’ 필터를 삭제하시겠습니까?", "CONTACT_FIELDS": "연락처 필드", "CONTAINS": "다음을 포함함", "COPY": "복사", "CREATE_A_FILTER": "필터 생성", "CREATE_NEW": "새 패널 생성", "CUSTOM_DATE_RANGE": "사용자 정의 날짜 범위", "DATE": "날짜", "DELETE": "삭제", "DELETE_FILTER": "필터 삭제", "EMBEDDED_DATA": "임베드된 데이터", "EQUAL_TO": "다음 값과 같음", "EVALUATIONS_OTHER": "기타 평가(대상의 평가 제외)", "EVALUATIONS_SUBJECT": "대상의 평가", "EXCLUDES": "제외", "FILTERED_RESPONSES": "필터링된 응답", "FILTERING_BY": "필터링 기준", "FILTER_ID_COLON": "필터 ID:", "FILTER_NAME_COPY": "{{name}} 복사", "GREATER_THAN": "다음 값보다 큼", "GT_OR_EQUAL_TO": "다음 값보다 크거나 같음", "IN": "다음 포함", "INCLUDES": "다음 포함", "INCLUDES_ANY": "다음 중 하나라도 포함", "INSERT_NEW_CONDITION": "새 조건 삽입", "INSERT_NEW_CONDITION_SET": "새 조건 세트 삽입", "IS": "다음과 같음", "IS_EMPTY": "비어 있음", "IS_NOT": "다음이 아님", "IS_NOT_EMPTY": "비어 있지 않음", "LACKS_ALL": "모두 제외", "LAST_120_DAYS": "지난 120일", "LAST_14_DAYS": "지난 14일", "LAST_30_DAYS": "지난 30일", "LAST_365_DAYS": "지난 365일", "LAST_60_DAYS": "지난 60일", "LAST_7_DAYS": "지난 7일", "LAST_90_DAYS": "지난 90일", "LESS_THAN": "다음 값보다 작음", "LT_OR_EQUAL_TO": "다음 값보다 작거나 같음", "MANAGE_FILTERS": "필터 관리", "MANAGE_FILTERS_ELLIPSIS": "필터 관리...", "MONTH": "개월", "MONTHS": "개월", "NEW_FILTER": "새 필터", "NO": "아니요", "NONE": "없음", "NOT_CONTAINS": "다음을 포함하지 않음", "NOT_EQUAL_TO": "다음과 같지 않음", "NOT_IN": "포함 안 함", "NO_AVAILABLE_FIELDS": "사용 가능한 필드 없음...", "NO_FILTERS_MSG": "필터가 없습니다.", "NPS_GROUP": "NPS® 그룹", "NUMBER": "숫자", "NUMERIC_VALUE": "숫자 값", "OFFSET": "오프셋", "OF_THE_FOLLOWING_ARE_TRUE": "다음 중 참인 개수", "QUARTER": "분기", "QUARTERS": "분기", "READ_ONLY": "읽기 전용", "REMOVE_CONDITION": "조건 제거", "RESPONSE_COUNT": "{{count}} 응답", "SAME_AS_SUBJECT": "대상과 같음", "SAVE": "저장", "SAVED_FILTERS": "저장된 필터", "SAVE_AND_APPLY": "저장 후 적용", "SEARCH": "검색", "SELECTED": "선택함", "SELECTED_CHOICE": "선택한 항목", "SELECT_FIELD": "필드 선택", "SELECT_ONE_OR_MORE_FIELDS": "하나 이상의 필드 선택...", "SELECT_OPERAND": "피연산자 선택", "SELECT_OPERATOR": "연산자 선택", "SHOW_ONLY_RESP": "응답만 표시:", "SHOW_ONLY_WHERE_COLON": "다음 조건의 응답만 표시:", "SURVEY_METADATA": "설문조사 메타데이터", "TEXT": "텍스트", "THIS_MONTH": "이번 달", "THIS_QUARTER": "이번 분기", "THIS_WEEK": "이번 주", "THIS_YEAR": "이번 해", "TODAY": "오늘", "WEEK": "주", "WEEKS": "주", "YEAR": "년", "YEARS": "년", "YES": "예", "YESTERDAY": "어제" }, "ms": { "ADD_CONDITION": "Tambah Syarat", "ADD_FILTER": "Tambah Penapis", "AFTER": "Selepas", "ALL": "Semua", "ALL_FILTERS": "Semua", "ALL_TIME": "Sepanjang Masa", "AND": "dan", "ANY_FILTERS": "Apa-apa", "APPLY": "Guna", "BEFORE": "Sebelum", "BETWEEN": "Antara", "BREAKOUT_MESSAGE": "Medan anda mempunyai lebih dari 5000 nilai unik, kami hanya akan memaparkan 5000 daripadanya! Ubah jenis medan anda ke Teks dalam Editor Kaji Selidik untuk membolehkan mencari nilai yang tepat.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Penapis anda tidak dapat disimpan atau digunakan. Sila hubungi Sokongan Qualtrics untuk maklumat selanjutnya.", "BREAKOUT_WARNING": "Amaran!", "BY": "mengikut", "CANCEL": "Batal", "CANCEL_WITHOUT_SAVING": "Batalkan Tanpa Penyimpanan", "CHOICES": "Pilihan", "CLOSE": "Tutup", "CONFIRM_CANCEL_WITHOUT_SAVING": "Anda mempunyai perubahan tidak disimpan. Adakah anda pasti ingin membatalkan tanpa penyimpanan?", "CONFIRM_DELETE": "Adakah anda pasti ingin memadam penapis '{{name}}'?", "CONTACT_FIELDS": "Medan Kenalan", "CONTAINS": "Mengandungi", "COPY": "Salin", "CREATE_A_FILTER": "Cipta Penapis", "CREATE_NEW": "Cipta Baharu", "CUSTOM_DATE_RANGE": "Julat tarikh tersuai", "DATE": "Tarikh", "DELETE": "Padam", "DELETE_FILTER": "Padam Penapis", "EMBEDDED_DATA": "Data Terbenam", "EQUAL_TO": "Sama dengan", "EVALUATIONS_OTHER": "Penilaian Lain (Kecuali Subjek)", "EVALUATIONS_SUBJECT": "Penilaian Subjek", "EXCLUDES": "Kecuali", "FILTERED_RESPONSES": "Maklum Balas Ditapis", "FILTERING_BY": "Ditapis mengikut", "FILTER_ID_COLON": "ID Penapis:", "FILTER_NAME_COPY": "{{name}} Salin", "GREATER_THAN": "Lebih besar daripada", "GT_OR_EQUAL_TO": "Lebih Besar daripada atau Sama dengan", "IN": "Termasuk", "INCLUDES": "Termasuk", "INCLUDES_ANY": "Termasuk apa-apa", "INSERT_NEW_CONDITION": "Masukkan Syarat Baharu", "INSERT_NEW_CONDITION_SET": "Masukkan Set Syarat Baharu", "IS": "Adalah", "IS_EMPTY": "Adalah kosong", "IS_NOT": "Adalah bukan", "IS_NOT_EMPTY": "Adalah tidak kosong", "LACKS_ALL": "Kecualikan semua", "LAST_120_DAYS": "120 hari lepas", "LAST_14_DAYS": "14 hari lepas", "LAST_30_DAYS": "30 hari lepas", "LAST_365_DAYS": "365 hari lepas", "LAST_60_DAYS": "60 hari lepas", "LAST_7_DAYS": "7 hari lepas", "LAST_90_DAYS": "90 hari lepas", "LESS_THAN": "Kurang daripada", "LT_OR_EQUAL_TO": "Kurang daripada atau Sama dengan", "MANAGE_FILTERS": "Uruskan Penapis", "MANAGE_FILTERS_ELLIPSIS": "Uruskan Penapis...", "MONTH": "bulan", "MONTHS": "bulan", "NEW_FILTER": "Penapis Baharu", "NO": "Tidak", "NONE": "Tiada", "NOT_CONTAINS": "Tidak mengandungi", "NOT_EQUAL_TO": "Tidak sama dengan", "NOT_IN": "Tidak termasuk", "NO_AVAILABLE_FIELDS": "Tiada medan tersedia...", "NO_FILTERS_MSG": "Anda belum mempunyai mana-mana penapis.", "NPS_GROUP": "Kumpulan NPS®", "NUMBER": "Nombor", "NUMERIC_VALUE": "Nilai berangka", "OFFSET": "Ofset", "OF_THE_FOLLOWING_ARE_TRUE": "semua yang berikut adalah benar", "QUARTER": "suku", "QUARTERS": "suku", "READ_ONLY": "Baca sahaja", "REMOVE_CONDITION": "Keluarkan Syarat", "RESPONSE_COUNT": "{{count}} Maklum balas", "SAME_AS_SUBJECT": "Sama dengan Subjek", "SAVE": "Simpan", "SAVED_FILTERS": "Penapis Disimpan", "SAVE_AND_APPLY": "Simpan dan Gunakan", "SEARCH": "Cari", "SELECTED": "Dipilih", "SELECTED_CHOICE": "Pilihan Dipilih", "SELECT_FIELD": "Pilih Medan", "SELECT_ONE_OR_MORE_FIELDS": "Pilih satu atau beberapa medan...", "SELECT_OPERAND": "Pilih Pengendali", "SELECT_OPERATOR": "Pilih Pengendali", "SHOW_ONLY_RESP": "Tunjukkan maklum balas sahaja:", "SHOW_ONLY_WHERE_COLON": "Tunjukkan maklum balas sahaja yang:", "SURVEY_METADATA": "Metadata Kaji Selidik", "TEXT": "Teks", "THIS_MONTH": "Bulan ini", "THIS_QUARTER": "Suku ini", "THIS_WEEK": "Minggu ini", "THIS_YEAR": "Tahun ini", "TODAY": "Hari Ini", "WEEK": "minggu", "WEEKS": "minggu", "YEAR": "tahun", "YEARS": "tahun", "YES": "Ya", "YESTERDAY": "Semalam" }, "nl": { "ADD_CONDITION": "Voorwaarde toevoegen", "ADD_FILTER": "Filter toevoegen", "AFTER": "Na", "ALL": "Alle", "ALL_FILTERS": "Alle", "ALL_TIME": "Alle perioden", "AND": "en", "ANY_FILTERS": "Eén", "APPLY": "Toepassen", "BEFORE": "Voor", "BETWEEN": "Tussen", "BREAKOUT_MESSAGE": "Het veld heeft meer dan 5000 unieke waarden, er worden maar 5000 ervan weergegeven. Wijzig het veldtype in Tekst in de Enquête-editor om het zoeken naar exacte waarden in te schakelen.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Uw filters konden niet worden opgeslagen of toegepast. Neem contact op met Qualtrics-support voor meer informatie.", "BREAKOUT_WARNING": "Waarschuwing!", "BY": "van", "CANCEL": "Annuleren", "CANCEL_WITHOUT_SAVING": "Annuleren zonder opslaan", "CHOICES": "Keuzes", "CLOSE": "Sluiten", "CONFIRM_CANCEL_WITHOUT_SAVING": "Er zijn niet-opgeslagen wijzigingen. Weet u zeker dat u wilt annuleren zonder op te slaan?", "CONFIRM_DELETE": "Weet u zeker dat u de filter '{{name}}' wilt verwijderen?", "CONTACT_FIELDS": "Contactvelden", "CONTAINS": "Bevat", "COPY": "Kopiëren", "CREATE_A_FILTER": "Een filter aanmaken", "CREATE_NEW": "Nieuw(e) aanmaken", "CUSTOM_DATE_RANGE": "Aangepast datumbereik", "DATE": "Datum", "DELETE": "Verwijderen", "DELETE_FILTER": "Filter verwijderen", "EMBEDDED_DATA": "Ingesloten gegevens", "EQUAL_TO": "Gelijk aan", "EVALUATIONS_OTHER": "Andere evaluaties (uitgezonderd die van beoordeelde)", "EVALUATIONS_SUBJECT": "Evaluaties van beoordeelde", "EXCLUDES": "Uitgezonderd", "FILTERED_RESPONSES": "Gefilterde antwoorden", "FILTERING_BY": "Filteren volgens", "FILTER_ID_COLON": "Filter-ID:", "FILTER_NAME_COPY": "{{name}} kopie", "GREATER_THAN": "Groter dan", "GT_OR_EQUAL_TO": "Groter dan of gelijk aan", "IN": "Omvat", "INCLUDES": "Omvat", "INCLUDES_ANY": "Omvat alle", "INSERT_NEW_CONDITION": "Nieuwe voorwaarde invoegen", "INSERT_NEW_CONDITION_SET": "Nieuwe reeks voorwaarden invoegen", "IS": "Is", "IS_EMPTY": "Is leeg", "IS_NOT": "Is niet", "IS_NOT_EMPTY": "Is niet leeg", "LACKS_ALL": "Uitgezonderd alle", "LAST_120_DAYS": "Laatste 120 dagen", "LAST_14_DAYS": "Laatste 14 dagen", "LAST_30_DAYS": "Laatste 30 dagen", "LAST_365_DAYS": "Laatste 365 dagen", "LAST_60_DAYS": "Laatste 60 dagen", "LAST_7_DAYS": "Laatste 7 dagen", "LAST_90_DAYS": "Laatste 90 dagen", "LESS_THAN": "Kleiner dan", "LT_OR_EQUAL_TO": "Kleiner dan of gelijk aan", "MANAGE_FILTERS": "Filters beheren", "MANAGE_FILTERS_ELLIPSIS": "Filters beheren…", "MONTH": "maand", "MONTHS": "maanden", "NEW_FILTER": "Nieuwe filter", "NO": "Nee", "NONE": "Geen", "NOT_CONTAINS": "Bevat geen", "NOT_EQUAL_TO": "Niet gelijk aan", "NOT_IN": "Omvat geen", "NO_AVAILABLE_FIELDS": "Geen beschikbare velden...", "NO_FILTERS_MSG": "U heeft nog geen filters.", "NPS_GROUP": "NPS®-groep", "NUMBER": "Getal", "NUMERIC_VALUE": "Numerieke waarde", "OFFSET": "Antidateren", "OF_THE_FOLLOWING_ARE_TRUE": "van de volgende zijn waar", "QUARTER": "kwartaal", "QUARTERS": "kwartalen", "READ_ONLY": "Alleen lezen", "REMOVE_CONDITION": "Voorwaarde verwijderen", "RESPONSE_COUNT": "{{count}} antwoorden", "SAME_AS_SUBJECT": "Zelfde als beoordeelde", "SAVE": "Opslaan", "SAVED_FILTERS": "Opgeslagen filters", "SAVE_AND_APPLY": "Opslaan en toepassen", "SEARCH": "Zoeken", "SELECTED": "Selecteerden", "SELECTED_CHOICE": "Geselecteerde keuze", "SELECT_FIELD": "Veld selecteren", "SELECT_ONE_OR_MORE_FIELDS": "Selecteer een of meer velden...", "SELECT_OPERAND": "Operand selecteren", "SELECT_OPERATOR": "Operator selecteren", "SHOW_ONLY_RESP": "Alleen antwoorden weergeven:", "SHOW_ONLY_WHERE_COLON": "Alleen antwoorden weergeven waarvoor:", "SURVEY_METADATA": "Metagegevens enquête", "TEXT": "Tekst", "THIS_MONTH": "Deze maand", "THIS_QUARTER": "Dit kwartaal", "THIS_WEEK": "Deze week", "THIS_YEAR": "Dit jaar", "TODAY": "Vandaag", "WEEK": "week", "WEEKS": "weken", "YEAR": "jaar", "YEARS": "jaren", "YES": "Ja", "YESTERDAY": "Gisteren" }, "pb": { "ADD_CONDITION": "⟦용용용 Àďď Čóпďίťįöņ 歴歴歴⟧", "ADD_FILTER": "⟦용용용 Āďď ₣íļťęѓ 歴歴歴⟧", "AFTER": "⟦용 Åƒťèг 歴⟧", "ALL": "⟦용 Ăļĺ 歴⟧", "ALL_FILTERS": "⟦용 Ăļĺ 歴⟧", "ALL_TIME": "⟦용용용 Ãľľ Ţìmе 歴歴歴⟧", "AND": "⟦용 αňď 歴⟧", "ANY_FILTERS": "⟦용 Ăņў 歴⟧", "APPLY": "⟦용 Àρρľў 歴⟧", "BEFORE": "⟦용용 βėƒôѓε 歴歴⟧", "BETWEEN": "⟦용용 Беŧẁĕėń 歴歴⟧", "BREAKOUT_MESSAGE": "⟦용용용용용용용용 Ỳőųŗ ƒιёľď ĥąś môŗè ŧħǻп 5000 цηĭqµέ νāļμèѕ, ẁè ẁĩľĺ ôňľγ ďīşρĺâў 5000 оƒ τħеm! Çнăŉĝē γõũř ƒĩëľď ŧỳρë το Τė×ţ īи ŧнĕ Ѕúгνėў Ëďìτòř τо ëňåвļе ѕēãгĉнιηĝ ƒòř έхά¢τ νãļùέş. 歴歴歴歴歴歴歴歴⟧", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "⟦용용용용 Ỳōúґ ƒίľŧęгŝ ¢ôûļď ήοτ ьĕ şãνêď öґ ăρρļїêď. Ρĺėåşē čõήţåĉτ Qúàĺτŕιċѕ Ѕũρρóŗť ƒòѓ möŗė ϊиƒοґmãŧϊŏŉ. 歴歴歴歴⟧", "BREAKOUT_WARNING": "⟦용용용 Шάřήїлğ! 歴歴歴⟧", "BY": "⟦용 ьý 歴⟧", "CANCEL": "⟦용용 Çãйсęĺ 歴歴⟧", "CANCEL_WITHOUT_SAVING": "⟦용용용용 Čáņčêĺ Щĩťħóųŧ Şăνïňġ 歴歴歴歴⟧", "CHOICES": "⟦용용 Çĥоì¢éś 歴歴⟧", "CLOSE": "⟦용 Ĉľøѕĕ 歴⟧", "CONFIRM_CANCEL_WITHOUT_SAVING": "⟦용용용 Ýοù ħανě ůŉşάνëď ćнàηğèş. Ǻгê ỳоŭ ѕцŕē γóų щâиţ ţȭ сâπćёľ ωĭτĥŏμţ śāνїиĝ? 歴歴歴⟧", "CONFIRM_DELETE": "⟦용용 Āгέ ỳóμ śцяě ýõû щāŋţ ţö ďéĺēťē ťнê ƒίĺţеґ '{{name}}'? 歴歴⟧", "CONTACT_FIELDS": "⟦용용용용 Ćοйťά¢ŧ ₣íěľďś 歴歴歴歴⟧", "CONTAINS": "⟦용용용 Ċоиţǻĭпś 歴歴歴⟧", "COPY": "⟦용 Çορý 歴⟧", "CREATE_A_FILTER": "⟦용용용용 Ĉřέάτє à ₣іļŧеŕ 歴歴歴歴⟧", "CREATE_NEW": "⟦용용용 Ĉяёāŧё Ñęщ 歴歴歴⟧", "CUSTOM_DATE_RANGE": "⟦용용용용용 Çúśťôm ďãţè ŕąŋĝε 歴歴歴歴歴⟧", "DATE": "⟦용 Ďäŧë 歴⟧", "DELETE": "⟦용용 Ðєļèťé 歴歴⟧", "DELETE_FILTER": "⟦용용용 Ðéĺêťе ₣ïľŧēя 歴歴歴⟧", "EMBEDDED_DATA": "⟦용용용 Έmвėďďêď Ðāŧà 歴歴歴⟧", "EQUAL_TO": "⟦용용용 Ëqμάľ ťō 歴歴歴⟧", "EVALUATIONS_OTHER": "⟦용용용 Òŧнёŕ Èνąļųâťīойś (Èхċľцďįйğ Śüвĵěĉţ'ş) 歴歴歴⟧", "EVALUATIONS_SUBJECT": "⟦용용용용 Şµвĵèсŧ'ѕ Ęνáľûåţįőйś 歴歴歴歴⟧", "EXCLUDES": "⟦용용용 Êхćļūďĕś 歴歴歴⟧", "FILTERED_RESPONSES": "⟦용용용용용 ₣ìľţêгęď Ŗέŝρöηşёѕ 歴歴歴歴歴⟧", "FILTERING_BY": "⟦용용용 ₣ĭĺŧєѓîňĝ ьỳ 歴歴歴⟧", "FILTER_ID_COLON": "⟦용용용 ₣íļţėг ΪĎ: 歴歴歴⟧", "FILTER_NAME_COPY": "⟦용용용 {{name}} Ĉôρý 歴歴歴⟧", "GREATER_THAN": "⟦용용용 Ĝŕέāŧęг ţħàπ 歴歴歴⟧", "GT_OR_EQUAL_TO": "⟦용용용용 Ġřёăťĕř τħăή όґ Εqűäľ ŧó 歴歴歴歴⟧", "IN": "⟦용용용 Ĩń¢ļüďеѕ 歴歴歴⟧", "INCLUDES": "⟦용용용 Ĩń¢ļüďеѕ 歴歴歴⟧", "INCLUDES_ANY": "⟦용용용 Іиčļūďĕѕ ăлỳ 歴歴歴⟧", "INSERT_NEW_CONDITION": "⟦용용용용용 Ĩηśêґţ Ñέώ Ċопďíţíόп 歴歴歴歴歴⟧", "INSERT_NEW_CONDITION_SET": "⟦용용용용 Ĩņѕėřτ Йєώ Ćøηďĭŧīσй Ŝєŧ 歴歴歴歴⟧", "IS": "⟦용 Іѕ 歴⟧", "IS_EMPTY": "⟦용용용 Įŝ ęmρŧУ 歴歴歴⟧", "IS_NOT": "⟦용용 Ίś ŋòτ 歴歴⟧", "IS_NOT_EMPTY": "⟦용용용 Íѕ ŉőŧ εmρτγ 歴歴歴⟧", "LACKS_ALL": "⟦용용용 Ėхčĺцďеş áĺľ 歴歴歴⟧", "LAST_120_DAYS": "⟦용용용 Ľâŝŧ 120 ďàўś 歴歴歴⟧", "LAST_14_DAYS": "⟦용용용 Ĺαşţ 14 ďąỳŝ 歴歴歴⟧", "LAST_30_DAYS": "⟦용용용 Ĺāѕτ 30 ďąўś 歴歴歴⟧", "LAST_365_DAYS": "⟦용용용 Ĺăşτ 365 ďàγś 歴歴歴⟧", "LAST_60_DAYS": "⟦용용용 Ĺąѕţ 60 ďàУş 歴歴歴⟧", "LAST_7_DAYS": "⟦용용용 Ľåŝţ 7 ďāÿŝ 歴歴歴⟧", "LAST_90_DAYS": "⟦용용용 Ĺáŝτ 90 ďąўś 歴歴歴⟧", "LESS_THAN": "⟦용용용 Ŀēŝş τħàп 歴歴歴⟧", "LT_OR_EQUAL_TO": "⟦용용용용 Ļęşş ţĥαп ог Έqμāļ ţõ 歴歴歴歴⟧", "MANAGE_FILTERS": "⟦용용용용 Μăлàġё ₣іĺŧēяş 歴歴歴歴⟧", "MANAGE_FILTERS_ELLIPSIS": "⟦용용용용용 Μâлάġë ₣íĺţέŗś... 歴歴歴歴歴⟧", "MONTH": "⟦용 mοлťн 歴⟧", "MONTHS": "⟦용용 möпτнŝ 歴歴⟧", "NEW_FILTER": "⟦용용용 Νεŵ ₣ιļτėŗ 歴歴歴⟧", "NO": "⟦용 Йő 歴⟧", "NONE": "⟦용 Ňòле 歴⟧", "NOT_CONTAINS": "⟦용용용용 Ďȭèŝ ŉȭτ ćôпţåĩл 歴歴歴歴⟧", "NOT_EQUAL_TO": "⟦용용용 Иŏŧ єqůãĺ ţο 歴歴歴⟧", "NOT_IN": "⟦용용용용 Ðŏєѕ ŉσť ιňсļũďė 歴歴歴歴⟧", "NO_AVAILABLE_FIELDS": "⟦용용용용 Ňő άνάįľãвĺε ƒîĕĺďѕ... 歴歴歴歴⟧", "NO_FILTERS_MSG": "⟦용용용 Ϋôů ďõ ńóŧ γеτ ĥăνє äпý ƒϊľţěяŝ. 歴歴歴⟧", "NPS_GROUP": "⟦용용용 ŃΡŞ® ġřόцρ 歴歴歴⟧", "NUMBER": "⟦용용 Ňûmьєŗ 歴歴⟧", "NUMERIC_VALUE": "⟦용용용 Ņűměґíč νàļųè 歴歴歴⟧", "OFFSET": "⟦용용 Óƒƒѕёŧ 歴歴⟧", "OF_THE_FOLLOWING_ARE_TRUE": "⟦용용용용 οƒ ťнê ƒôľļȭшїŋğ âŗё ţŗúē 歴歴歴歴⟧", "QUARTER": "⟦용용 qµäŕţęг 歴歴⟧", "QUARTERS": "⟦용용용 qŭãґŧěѓş 歴歴歴⟧", "READ_ONLY": "⟦용용용 Ŕěαď õлĺỳ 歴歴歴⟧", "REMOVE_CONDITION": "⟦용용용용 Γēmōνĕ Ćöлďϊťĭŏπ 歴歴歴歴⟧", "RESPONSE_COUNT": "⟦용용용용용 {{count}} Ŕėŝρōńşεŝ 歴歴歴歴歴⟧", "SAME_AS_SUBJECT": "⟦용용용용 Ѕåmέ âŝ Ŝŭьĵěçτ 歴歴歴歴⟧", "SAVE": "⟦용 Şάνе 歴⟧", "SAVED_FILTERS": "⟦용용용 Śãνêď ₣ϊĺŧėґś 歴歴歴⟧", "SAVE_AND_APPLY": "⟦용용용용 Ŝåνė ąηď Ąρρļў 歴歴歴歴⟧", "SEARCH": "⟦용용 Ѕêāґčĥ 歴歴⟧", "SELECTED": "⟦용용용 Ѕęĺēčťєď 歴歴歴⟧", "SELECTED_CHOICE": "⟦용용용용 Ѕëļëсτęď сĥôîĉє 歴歴歴歴⟧", "SELECT_FIELD": "⟦용용용 Śεľēсť ₣іèľď 歴歴歴⟧", "SELECT_ONE_OR_MORE_FIELDS": "⟦용용용용용 Şëĺėçť ôňė õг mŏѓė ƒĩέĺďѕ... 歴歴歴歴歴⟧", "SELECT_OPERAND": "⟦용용용용 Ѕёļєçτ Ορëŗáňď 歴歴歴歴⟧", "SELECT_OPERATOR": "⟦용용용용 Ŝèľêсť Ōρèґāŧоя 歴歴歴歴⟧", "SHOW_ONLY_RESP": "⟦용용용용용 Ѕноŵ опĺý ѓеѕρóηśëş: 歴歴歴歴歴⟧", "SHOW_ONLY_WHERE_COLON": "⟦용용용용용 Śħóώ öŋļý ѓėşρолśěś щħеѓë: 歴歴歴歴歴⟧", "SURVEY_METADATA": "⟦용용용용 Ѕųґνεγ Мéταďαťâ 歴歴歴歴⟧", "TEXT": "⟦용 Τè×τ 歴⟧", "THIS_MONTH": "⟦용용용 Ţĥϊś mȭηŧħ 歴歴歴⟧", "THIS_QUARTER": "⟦용용용 Ţħĭŝ qùαяτεґ 歴歴歴⟧", "THIS_WEEK": "⟦용용용 Τнїѕ ẁĕéκ 歴歴歴⟧", "THIS_YEAR": "⟦용용용 Ŧĥіş γēâŕ 歴歴歴⟧", "TODAY": "⟦용 Τõďäỳ 歴⟧", "WEEK": "⟦용 шéêķ 歴⟧", "WEEKS": "⟦용 ωеéкŝ 歴⟧", "YEAR": "⟦용 ýĕάř 歴⟧", "YEARS": "⟦용 ÿéαѓś 歴⟧", "YES": "⟦용 Υεş 歴⟧", "YESTERDAY": "⟦용용용 Ϋёşţеřďαŷ 歴歴歴⟧" }, "pt": { "ADD_CONDITION": "Adicionar condição", "ADD_FILTER": "Adicionar filtro", "AFTER": "Depois", "ALL": "Todos", "ALL_FILTERS": "Todos", "ALL_TIME": "Todo o tempo", "AND": "e", "ANY_FILTERS": "Qualquer", "APPLY": "Aplicar", "BEFORE": "Antes", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "O seu campo tem mais de 5000 valores únicos, pelo que só vamos apresentar 5000! Altere o tipo de campo para Texto no Editor do Inquérito para permitir a procura de valores exatos.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Não foi possível guardar ou aplicar os seus filtros. Para mais informações, entre em contacto com o apoio ao cliente da Qualtrics.", "BREAKOUT_WARNING": "Aviso!", "BY": "por", "CANCEL": "Cancelar", "CANCEL_WITHOUT_SAVING": "Cancelar sem guardar", "CHOICES": "Opções", "CLOSE": "Fechar", "CONFIRM_CANCEL_WITHOUT_SAVING": "Existem alterações não guardadas. Tem a certeza de que pretende cancelar sem guardar?", "CONFIRM_DELETE": "Tem a certeza de que pretende eliminar o filtro '{{name}}'?", "CONTACT_FIELDS": "Campos de contactos", "CONTAINS": "Contém", "COPY": "Copiar", "CREATE_A_FILTER": "Criar um filtro", "CREATE_NEW": "Criar novo", "CUSTOM_DATE_RANGE": "Intervalo de data personalizado", "DATE": "Data", "DELETE": "Eliminar", "DELETE_FILTER": "Eliminar filtro", "EMBEDDED_DATA": "Dados incorporados", "EQUAL_TO": "Igual a", "EVALUATIONS_OTHER": "Outras avaliações (excluindo a do participante)", "EVALUATIONS_SUBJECT": "Avaliações do participante", "EXCLUDES": "Exclui", "FILTERED_RESPONSES": "Respostas filtradas", "FILTERING_BY": "A filtrar por", "FILTER_ID_COLON": "ID do filtro:", "FILTER_NAME_COPY": "{{name}} Copiar", "GREATER_THAN": "Superior a", "GT_OR_EQUAL_TO": "Superior ou igual a", "IN": "Inclui", "INCLUDES": "Inclui", "INCLUDES_ANY": "Inclui qualquer", "INSERT_NEW_CONDITION": "Introduzir nova condição", "INSERT_NEW_CONDITION_SET": "Introduzir novo conjunto de condições", "IS": "É", "IS_EMPTY": "Está vazio", "IS_NOT": "Não é", "IS_NOT_EMPTY": "Não está vazio", "LACKS_ALL": "Exclui todos", "LAST_120_DAYS": "Últimos 120 dias", "LAST_14_DAYS": "Últimos 14 dias", "LAST_30_DAYS": "Últimos 30 dias", "LAST_365_DAYS": "Últimos 365 dias", "LAST_60_DAYS": "Últimos 60 dias", "LAST_7_DAYS": "Últimos 7 dias", "LAST_90_DAYS": "Últimos 90 dias", "LESS_THAN": "Inferior a", "LT_OR_EQUAL_TO": "Inferior ou igual a", "MANAGE_FILTERS": "Gerir filtros", "MANAGE_FILTERS_ELLIPSIS": "Gerir filtros...", "MONTH": "mês", "MONTHS": "meses", "NEW_FILTER": "Novo filtro", "NO": "Não", "NONE": "Nenhum", "NOT_CONTAINS": "Não contém", "NOT_EQUAL_TO": "Diferente de", "NOT_IN": "Não inclui", "NO_AVAILABLE_FIELDS": "Não existem campos disponíveis...", "NO_FILTERS_MSG": "Ainda não tem qualquer filtro.", "NPS_GROUP": "Grupo NPS®", "NUMBER": "Número", "NUMERIC_VALUE": "Valor numérico", "OFFSET": "Limitar data", "OF_THE_FOLLOWING_ARE_TRUE": "das seguintes são verdadeiras", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Apenas leitura", "REMOVE_CONDITION": "Remover condição", "RESPONSE_COUNT": "{{count}} respostas", "SAME_AS_SUBJECT": "Igual ao participante", "SAVE": "Guardar", "SAVED_FILTERS": "Filtros guardados", "SAVE_AND_APPLY": "Guardar e aplicar", "SEARCH": "Pesquisa", "SELECTED": "Selecionou", "SELECTED_CHOICE": "Opção selecionada", "SELECT_FIELD": "Selecionar campo", "SELECT_ONE_OR_MORE_FIELDS": "Selecione um ou mais campos...", "SELECT_OPERAND": "Selecionar operando", "SELECT_OPERATOR": "Selecionar operador", "SHOW_ONLY_RESP": "Mostrar apenas respostas:", "SHOW_ONLY_WHERE_COLON": "Mostrar apenas respostas em que:", "SURVEY_METADATA": "Metadados do inquérito", "TEXT": "Texto", "THIS_MONTH": "Estes mês", "THIS_QUARTER": "Este trimestre", "THIS_WEEK": "Esta semana", "THIS_YEAR": "Este ano", "TODAY": "Hoje", "WEEK": "semana", "WEEKS": "semanas", "YEAR": "ano", "YEARS": "anos", "YES": "Sim", "YESTERDAY": "Ontem" }, "pt-BR": { "ADD_CONDITION": "Adicionar condição", "ADD_FILTER": "Adicionar filtro", "AFTER": "Após", "ALL": "Todos", "ALL_FILTERS": "Todos", "ALL_TIME": "O tempo todo", "AND": "e", "ANY_FILTERS": "Algum", "APPLY": "Aplicar", "BEFORE": "Antes", "BETWEEN": "Entre", "BREAKOUT_MESSAGE": "Seu campo tem mais de 5.000 valores únicos e nós só exibiremos 5.000 deles! Altere o tipo do seu campo para Texto no Editor da Pesquisa para permitir a busca de valores exatos.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Não foi possível salvar ou aplicar os seus filtros. Entre em contato com o suporte da Qualtrics para obter mais informações.", "BREAKOUT_WARNING": "Aviso!", "BY": "por", "CANCEL": "Cancelar", "CANCEL_WITHOUT_SAVING": "Cancelar sem salvar", "CHOICES": "Opções de resposta", "CLOSE": "Fechar", "CONFIRM_CANCEL_WITHOUT_SAVING": "Você possui alterações não salvas. Tem certeza de que deseja sair sem salvar?", "CONFIRM_DELETE": "Tem certeza de que deseja excluir este filtro \"{{name}}\"?", "CONTACT_FIELDS": "Campos do contato", "CONTAINS": "Contém", "COPY": "Copiar", "CREATE_A_FILTER": "Criar um filtro", "CREATE_NEW": "Criar novo", "CUSTOM_DATE_RANGE": "Intervalo personalizado de data", "DATE": "Data", "DELETE": "Excluir", "DELETE_FILTER": "Excluir filtro", "EMBEDDED_DATA": "Dados integrados", "EQUAL_TO": "Igual a", "EVALUATIONS_OTHER": "Outras avaliações (exceto do respondente)", "EVALUATIONS_SUBJECT": "Avaliações do usuário", "EXCLUDES": "Excluir", "FILTERED_RESPONSES": "Respostas filtradas", "FILTERING_BY": "Filtrando por", "FILTER_ID_COLON": "ID do filtro:", "FILTER_NAME_COPY": "{{name}} Copiar", "GREATER_THAN": "Maior que", "GT_OR_EQUAL_TO": "Maior que ou igual a", "IN": "Incluir", "INCLUDES": "Incluir", "INCLUDES_ANY": "Incluir qualquer", "INSERT_NEW_CONDITION": "Inserir nova condição", "INSERT_NEW_CONDITION_SET": "Inserir novo conjunto de condições", "IS": "É", "IS_EMPTY": "Vazio", "IS_NOT": "Não é", "IS_NOT_EMPTY": "Não vazio", "LACKS_ALL": "Excluir todos", "LAST_120_DAYS": "Últimos 120 dias", "LAST_14_DAYS": "Últimos 14 dias", "LAST_30_DAYS": "Últimos 30 dias", "LAST_365_DAYS": "Últimos 365 dias", "LAST_60_DAYS": "Últimos 60 dias", "LAST_7_DAYS": "Últimos 7 dias", "LAST_90_DAYS": "Últimos 90 dias", "LESS_THAN": "Menor que", "LT_OR_EQUAL_TO": "Menor que ou igual a", "MANAGE_FILTERS": "Gerenciar filtros", "MANAGE_FILTERS_ELLIPSIS": "Gerenciar filtros...", "MONTH": "mês", "MONTHS": "meses", "NEW_FILTER": "Novo filtro", "NO": "Não", "NONE": "Nenhuma", "NOT_CONTAINS": "Não contém", "NOT_EQUAL_TO": "Diferente de", "NOT_IN": "Não inclui", "NO_AVAILABLE_FIELDS": "Não há campos disponíveis...", "NO_FILTERS_MSG": "Você ainda não possui filtros.", "NPS_GROUP": "Grupo NPS®", "NUMBER": "Número", "NUMERIC_VALUE": "Valor numérico", "OFFSET": "Pré-datar", "OF_THE_FOLLOWING_ARE_TRUE": "do seguinte é verdadeiro", "QUARTER": "trimestre", "QUARTERS": "trimestres", "READ_ONLY": "Somente leitura", "REMOVE_CONDITION": "Remover condição", "RESPONSE_COUNT": "{{count}} respostas", "SAME_AS_SUBJECT": "Mesmo que o indivíduo", "SAVE": "Salvar", "SAVED_FILTERS": "Filtros salvos", "SAVE_AND_APPLY": "Salvar e aplicar", "SEARCH": "Pesquisar", "SELECTED": "Selecionou", "SELECTED_CHOICE": "Opção de resposta selecionada", "SELECT_FIELD": "Selecionar campo", "SELECT_ONE_OR_MORE_FIELDS": "Selecionar um ou mais campos...", "SELECT_OPERAND": "Selecionar operando", "SELECT_OPERATOR": "Selecionar operador", "SHOW_ONLY_RESP": "Mostrar apenas respostas:", "SHOW_ONLY_WHERE_COLON": "Mostrar apenas respostas que:", "SURVEY_METADATA": "Metadados da pesquisa", "TEXT": "Texto", "THIS_MONTH": "Este mês", "THIS_QUARTER": "Este trimestre", "THIS_WEEK": "Esta semana", "THIS_YEAR": "Este ano", "TODAY": "Hoje", "WEEK": "semana", "WEEKS": "semanas", "YEAR": "ano", "YEARS": "anos", "YES": "Sim", "YESTERDAY": "Ontem" }, "ri-GI": { "ADD_CONDITION": "⁪⁪⁪‌​‍​​‌‌‍‌​‍‌‍‍​‍​​‌‌‌‌​‌‍‌‍‍‌​​‌‌​​‌‍‍‍‌​⁪Add Condition⁪⁪", "ADD_FILTER": "⁪⁪⁪‍​‌‌‍‌​‌‍‌‍‌‌‌‍‍​‌​‍‌​​‌​​‌​‍‌‍‌‌​​​‍​​‌⁪Add Filter⁪⁪", "AFTER": "⁪⁪⁪‌‍​​​​​‌‍‍‌‍‌​​‌‌​​‌‍​​‌​​‍​‌​​‍​‍​‌​‌‌‍⁪After⁪⁪", "ALL": "⁪⁪⁪‍‍‌​​‍​‌​‌‍‌‍‌‌‍‍​‌​‍‍‌‍‍‍‌‌​‌​‍‍​‍‍‌​‍​⁪All⁪⁪", "ALL_FILTERS": "⁪⁪⁪‍‌‌​‌‍‍‍​‍​‌​‌‌​‍‌​​‍‍‍‍‍‌​​‍‍​‌‌​​​‍‍‌‍⁪All⁪⁪", "ALL_TIME": "⁪⁪⁪‌‌‌‍​​​‍‍‌‌‌​‌​​‌​‍‍​​‍​​​‍‌‌‌​​‌‍‌​‍​⁪All Time⁪⁪", "AND": "⁪⁪⁪‌‌‌‍‌‌​‍‌‍​​‍‍‌​‍‌​‌‌​‍‌‍​‍​​​​​​‍​​​​‌​⁪and⁪⁪", "ANY_FILTERS": "⁪⁪⁪‌‌​‌‌‌‌‍​​‍​​‍‍​‍‍‌‍​‍‍​‍‌‌‌​​‍‍​‍​‌​‌‌‍​⁪Any⁪⁪", "APPLY": "⁪⁪⁪‌​‍‌‌‍‌‌​​​‌‍​‌‌‍​‌‌‍‌‌​‌‌​‌​‌‌‍‍‍‍​​​‍​‌⁪Apply⁪⁪", "BEFORE": "⁪⁪⁪‌​‌‌​‍​​‌​​​‍‍​‍‌‌‌‌‍‌​​‌​‌‌‍‍‍‌‌‍‌​‌‌‌​​⁪Before⁪⁪", "BETWEEN": "⁪⁪⁪‌​​​​​​‌‍‍​‌‌​‌‍‌‍‌​‌‍‍‌‌‍​​‍​​‍​‌​‍‌‌‌‌‍⁪Between⁪⁪", "BREAKOUT_MESSAGE": "⁪⁪⁪‌​‌​‌‌​‌‌‌‍‍‌​‍‌​‌​​‍‌​‍‍‌‌‌‌‍‌​‌​‌​‌‍‌​‌⁪Your field has more than 5000 unique values, we will only display 5000 of them! Change your field type to Text in the Survey Editor to enable searching for exact values.⁪⁪", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "⁪⁪⁪‌‍‌​​‍‍‍‌​‌​‌​​​‌‍​​‍‍​‍​​‌​‍‌‍​‌​‌‍​‌‍‍⁪Your filters could not be saved or applied. Please contact Qualtrics Support for more information.⁪⁪", "BREAKOUT_WARNING": "⁪⁪⁪‌‍​‍​​‍‌‌​‌‍‌​‌‌‍‌​‌​‍‌‍‌‍‌‌‍‍​​‌‍‍​‌​‍​⁪Warning!⁪⁪", "BY": "⁪⁪⁪‌‌​‌‍​‌‌‌​‍​​‌‍‌‌‌‍​​‍‌​​‌​‌‌‌‌‌‍​​​‍‌‍​​⁪by⁪⁪", "CANCEL": "⁪⁪⁪‌​‌‍​‌‍‍​‍‍‌‍‌‌​‌​​‌‌‌​​​​​​‍‍‌‌​​​‌‌‌‍​‌⁪Cancel⁪⁪", "CANCEL_WITHOUT_SAVING": "⁪⁪⁪‍‌​‌​‌​​‍‌‍‌‌​​​‌​‍‍‌​‌‌‌‌‌​​‌​‍​‌‌‌‍‍‌⁪Cancel Without Saving⁪⁪", "CHOICES": "⁪⁪⁪‌‌‌​‌​‍‍​‍‌‍‍‌​‍‍​​‍‌‌‍‍‌‍‍​‍‌​​‍‌​​‌‌‍‍​⁪Choices⁪⁪", "CLOSE": "⁪⁪⁪‍​‌‍‍‌​​​​‍​‌​‍‍‍​‌‌​​‍​​‍‌​‍‍​‌​‌‍‍‍​​​⁪Close⁪⁪", "CONFIRM_CANCEL_WITHOUT_SAVING": "⁪⁪⁪‌‌‌‌​​‍‌‌‍‌​‍‍‌​‍‌‌‍​​‌‍‌​‍‌​‍‌‍‍‍‌‌‍​‌‌‍⁪You have unsaved changes. Are you sure you want to cancel without saving?⁪⁪", "CONFIRM_DELETE": "⁪⁪⁪‌​‌​​​‌‌‍‌‌‌‍‍‍‍​​​‌​‌​​‌​​‌‌​‍‍‍‌​‌‌‌​‌​⁪Are you sure you want to delete the filter ​​​{{name}}‌‌‌?⁪⁪", "CONTACT_FIELDS": "⁪⁪⁪‌​‍‍​‍​​‌‌​‍‍‌‍​‌‍‌‍‍‍‌​‌​‍​​‍‍‍‍‌​​‍‌‍​‌⁪Contact Fields⁪⁪", "CONTAINS": "⁪⁪⁪‍​‍‍​​‌‌‍​‌​‍‍‌‍‌‌‍​‌‌‌‌​​‌‌‌​‍‍‌​‌‌‍⁪Contains⁪⁪", "COPY": "⁪⁪⁪‍‌‌‌‍‌‍‌‌​​​‍‍‌​‌​​‍​​‌‍​‍​‍‍‍‌​‍‍‌‍‌​​‍⁪Copy⁪⁪", "CREATE_A_FILTER": "⁪⁪⁪‌‍‌‌‌‍‌‍‌​‌‍‍‌​​‍​‌‌​‌‌‍​‍​​​​‌​‍‍​‍​‌⁪Create a Filter⁪⁪", "CREATE_NEW": "⁪⁪⁪‌‍‍‌​​‍​​​​‍‌​​‌‍‌‍‍‌​‍‍‌​‍​​‍‍‌​​​‍‍‌​​⁪Create New⁪⁪", "CUSTOM_DATE_RANGE": "⁪⁪⁪‍‌‍‍​‌‍‍‌‌‌‍‍‍‌‍‌​​‍​​​‍‍​‌‍‍‌‍‌‍‍​‌‌‍‌‌⁪Custom date range⁪⁪", "DATE": "⁪⁪⁪‍​‌​​‌​​​‍‍‍​‍​‍​​‍‍‌‌‍‌​‌​‌‍‍‍​​‌​​‌​​‌⁪Date⁪⁪", "DELETE": "⁪⁪⁪‍‍‌​​‍‌​​‍‌‍‍​​‍​​​‍‌‌​​‍‍​‍​‍‍​‍‌​​‌‌‍⁪Delete⁪⁪", "DELETE_FILTER": "⁪⁪⁪‌​‍‌‌‌‌‍​​​​​​​‌‌‌‍‌‌‌​‌​‌​​​‌‌‍‌‍‌‌‌‌‌‌‌⁪Delete Filter⁪⁪", "EMBEDDED_DATA": "⁪⁪⁪‌‌​​‌‌​‍​‍‌‌‌‍​‍​‍‍​‍‌​‍‍​​‍‌​​‌‌​‍​​‌​‌‍⁪Embedded Data⁪⁪", "EQUAL_TO": "⁪⁪⁪‌​​‌​‍‌‌‌‌‍​‍‍‌‍​​​‍‍​‌‍​​​‍‍‍‌​‍‍​​‌‍​​‌⁪Equal to⁪⁪", "EVALUATIONS_OTHER": "⁪⁪⁪‌‌‌​‍​​​‍‌​‌‍​‍‌‌​​‌​​‍‍​​​‍​‍‍​‍‌‍‍‍‌​‍‍⁪Other Evaluations (Excluding Subjects)⁪⁪", "EVALUATIONS_SUBJECT": "⁪⁪⁪‌​‍‌​‌‌‌‍‍‌​‌‌‍‌​​​‌‌​​‍‌‍‌‌‌‌‍‍​‌‍‌‌‌‌​‍⁪Subjects Evaluations⁪⁪", "EXCLUDES": "⁪⁪⁪‌‍‍‍‍‌‌​‌​​‍‌‍‍‍‍‍‍‍‌​‌​​​‍​​‌‌‍‍​‍‍‌‍​‍⁪Excludes⁪⁪", "FILTERED_RESPONSES": "⁪⁪⁪‌​‌‍‍​​‌‍‍‌‌‍​‌​‍​‌​‍‌‌‌​‌‍​‍‍‌‌‌‍‌​‍‍‌‍‌⁪Filtered Responses⁪⁪", "FILTERING_BY": "⁪⁪⁪‌‌‍‍‌‌‌‍​‌‌‍​‌‍​‍‌​‍‍‍​​​​‌‍‌‍‍​‍‌​​​​‍‍⁪Filtering by⁪⁪", "FILTER_ID_COLON": "⁪⁪⁪‌​‌​​‍‍‍‌​‌‍‍‌​​​‍​‍‌‌​​‌​‌‍‍​‍‌‍‌‍​‌‍‌‍‌⁪Filter ID:⁪⁪", "FILTER_NAME_COPY": "⁪⁪⁪‌​‍‍‌‍‍​​‍‍‍‌‌‌‍‍​‌‍‌‌‌​‍​‍​‌‌‍‌‍‌‌‌​‌‌​‍⁪​​​{{name}}‌‌‌ Copy⁪⁪", "GREATER_THAN": "⁪⁪⁪‍​‍​‌‍​‌‍‍​​‍​‌‌‍‌​‍‍​​‌‍​‌‌‍‌‍​​​​‌‍​‍​⁪Greater than⁪⁪", "GT_OR_EQUAL_TO": "⁪⁪⁪‌‍‌‌​‍‌‌​​‌‌‌‍‌‌‌‌‍‍‍​‍​‌‌‍‍​​​‍‌‍‌‌‌​​⁪Greater than or Equal to⁪⁪", "IN": "⁪⁪⁪‌​‌‌‍‌​​‌​‌​​​‍‍‍‌​​‌‍‍‍‌‌​‌‍​‌​​‍​‌‍‌‍​⁪Includes⁪⁪", "INCLUDES": "⁪⁪⁪‌‍​​‍‍‌​‌‍‍​​‌​​‌‌‍‍​​‍‌‍​‌‌‌​​​‌‌​​‌​‍​⁪Includes⁪⁪", "INCLUDES_ANY": "⁪⁪⁪‌​‍‌​​‌‌‌‍‌​‌‍​‌‌‌​‌‍‌‍​‌​‍​‍‌‍‌‌‌‍‍​​‌​‌⁪Includes any⁪⁪", "INSERT_NEW_CONDITION": "⁪⁪⁪‌​‌‍‌‌‌​‍‍​​​‍‌​‌​‍‍​​‌‌‌‍‌‌​‍‍‌​‌‌‌​‍​​​⁪Insert New Condition⁪⁪", "INSERT_NEW_CONDITION_SET": "⁪⁪⁪‌​‍​‌​‍‍​‌‌‌​​‍‌‌‌‍‌​​‌​‌​‍​‍‌‍‍‍‌‌​‌‌​⁪Insert New Condition Set⁪⁪", "IS": "⁪⁪⁪‌‌‌​‍‌​‌​​​‌​‌​‍‌​‍‍​​​‌‌​​‌​‍‌‍​‌‌‍‌‌‌⁪Is⁪⁪", "IS_EMPTY": "⁪⁪⁪‍‍​‌​‌‍‌‌‍‌‌‍‌​‍​‍‌‌​‌‍​‍​​‌‌‍​‌​‌‌‌‌​‌‍⁪Is empty⁪⁪", "IS_NOT": "⁪⁪⁪‌‌​‌‍‌‌​‌‌‍‍​​‍‌​‍‌​‌‌‍​‌‍‍‌‍‌​‍​‌​‌​‌‌⁪Is not⁪⁪", "IS_NOT_EMPTY": "⁪⁪⁪‍​​‍‍‍‍‌‍​‍‍‍‌​​‌‌‌‍‌​​‍‌‍​​‌‍‌‍‍​‍​‍‌‍‌⁪Is not empty⁪⁪", "LACKS_ALL": "⁪⁪⁪‌​‌‌​​‍‌‍​‍​‌​​‍‌‍‍‌‌​‌‌‌‌‍‍‌​​‌‍‍‍‌‌​‍​​⁪Excludes all⁪⁪", "LAST_120_DAYS": "⁪⁪⁪‍‌​​‍​‌​‌​‍​‌‍​‌‍​​​​‌​‍‍​​‍​‌‌‍​‍‍​‌​​​⁪Last 120 days⁪⁪", "LAST_14_DAYS": "⁪⁪⁪‌‍​​‍‍‌‍‌‌‌‍‌‌‌​​​‌‌​​​‍‌‌‌‌‌‍‌​‌​‌‌‍‌‌⁪Last 14 days⁪⁪", "LAST_30_DAYS": "⁪⁪⁪‌​‍​​‌‌‌​‌‍‌​‍​‍​‌‍‍​‌‌‌​‍‍‍‌‌‌‌​‌‍​‌‍​‌‌⁪Last 30 days⁪⁪", "LAST_365_DAYS": "⁪⁪⁪‌​‌​​‌‌‌​‌‍​​​‌​​‌‌​​‌‌‌‍‌‌‍​​‌​​‍‌​‌‌‌⁪Last 365 days⁪⁪", "LAST_60_DAYS": "⁪⁪⁪‍‍​​‌‌‍​‍‌‌‌‍‍​‌​‍‍‌​‌‍‌‍​‌​‌‍‌‌‌‍​​​‍‌‍⁪Last 60 days⁪⁪", "LAST_7_DAYS": "⁪⁪⁪‌‌​‌​‌‍‌​‌‌‍‍‍‍​​​​‍‍‍​‍‌‍‍‌‍‌​​‍‌‍‌​‍‌⁪Last 7 days⁪⁪", "LAST_90_DAYS": "⁪⁪⁪‌​​‍​​‍‌‌​​​‌‍‌​‌​‌​​​‌‍​‌‌‍​‍​​​‍​​‍​‍‍⁪Last 90 days⁪⁪", "LESS_THAN": "⁪⁪⁪‍​‌‌‍‌​​‍‌‌‌‍‌‌‌‍‍​​‍​​‍‌‌​‌‍‍​‍​‍‍‌​‍‍⁪Less than⁪⁪", "LT_OR_EQUAL_TO": "⁪⁪⁪‍‍​‌‍​‌‍‌‍​‍‌​‍‌​‌‌‍‌‍‍‌​‌‍‍‌‌‌‍‌‌‌​‍‍​⁪Less than or Equal to⁪⁪", "MANAGE_FILTERS": "⁪⁪⁪‍‌​​‍‌‍‍‍‌‌‍​‍‍‌‍​‌​‍‌‌‍​​‍‍‌‍​​‌‍‌‍‌‍‌‌⁪Manage Filters⁪⁪", "MANAGE_FILTERS_ELLIPSIS": "⁪⁪⁪‍​‌​‌​‍‌‌‌​​​‌‍‌‌​‌‌‌​‍‍‍‌​‌‍​​‍‌​‌​‌​‍‌⁪Manage Filters...⁪⁪", "MONTH": "⁪⁪⁪‌‌‌‌​​‍​​​‌​‌‍‌‌‍​‌‌‍​‍‌‌‍‍‍‌‌‍‍​​​‌‌‍​‌‌⁪month⁪⁪", "MONTHS": "⁪⁪⁪‌‌​‌‌​‍‌‍​‌‍‌‌​‌​‌​‍‌‍​‌‍‍‍​‍‍‍‍‌​‍​​​‌​‍⁪months⁪⁪", "NEW_FILTER": "⁪⁪⁪‌‌‌‌​‍​‌‌​‍​‍‌‍‌‍​​​‌‍‌​‌​​‍‍‌‍‌‍‍​‍​‍‍‍⁪New Filter⁪⁪", "NO": "⁪⁪⁪‌‌‌​‌‌‌​​‌​‍‌​​‍​‌‌‍‍​‌‌‍‍‌​‍​‌‌​​‍‍‌​​​‌⁪No⁪⁪", "NONE": "⁪⁪⁪‌‌‌‍‌​​‌​‌‌‌​‍‌‍‍‌‍‌‌‌‍​​‌‌‌​‍​​‌‍​‌‍‌⁪None⁪⁪", "NOT_CONTAINS": "⁪⁪⁪‌‍‌‍‍‌‌​‍‍​​‌‍‍‌​‌‍‍‌‌‌‌‌‍‌​​‍‌‍​​​‍‍‌‍‌⁪Does not contain⁪⁪", "NOT_EQUAL_TO": "⁪⁪⁪‌​‌‌‍​​‌‌‌‍‌‌‍‌‌‌‍‍‌‌‍​‍‍‌‌​‌‌‌​‌‍‍​​​‍‌‌⁪Not equal to⁪⁪", "NOT_IN": "⁪⁪⁪‌​‍​‍‍‌​‍‍‌‌‍​‍​‍‍‍‌​​‍​​‍‌‌‌‌‌‍‍‌‌‍​​​‍‌⁪Does not include⁪⁪", "NO_AVAILABLE_FIELDS": "⁪⁪⁪‌​​‍‍‌​‍‌​‍‌‍‌‍‌​‌‌‌‌​‌​‌​‍‌‍​‍​​‍‌‍​‌‌‍⁪No available fields...⁪⁪", "NO_FILTERS_MSG": "⁪⁪⁪‌​‍‌​‌​‍‍​‌‍​​‍‍​​‌​​‍​​‌‌‌‍​‍‌‍‍‍‍‍‍‍‌‌‌⁪You do not yet have any filters.⁪⁪", "NPS_GROUP": "⁪⁪⁪‌‌​‌‍‍‌​​‍​‌‌​‌‌‌​‍​‍​‌​‌‌‍​‍​‍​​‍‌‍‌​‌​‍⁪NPS® group⁪⁪", "NUMBER": "⁪⁪⁪‍‌‍‍‍‌‍‍‌‍​‌‍‍‌​​‍​‍‌​‌​​‌​‍‌‍‍​‌‌‌‍‍⁪Number⁪⁪", "NUMERIC_VALUE": "⁪⁪⁪‍​‍‌‌‌​‍‍‌‍‌​​​​‍‌‌‌​‌‌​‌‍‍​‍‌​‌‌‌‌⁪Numeric value⁪⁪", "OFFSET": "⁪⁪⁪‌‌​‌‍​‍‌‌‍‍‌‍​‍​​‌‍​​‍​‍​‌‍​‍​‍‌‍‌‌‌‍‌‍‍​⁪Offset⁪⁪", "OF_THE_FOLLOWING_ARE_TRUE": "⁪⁪⁪‍​​‍​‌‌‍‌​​‍​‍‍​‍​‍​‍‍​‌​‍​‍‍​‌‍‍‍​‍‌‍​‌⁪of the following are true⁪⁪", "QUARTER": "⁪⁪⁪‌​​​​‌​‌‍‌‌​‌​​​​‍‌​‍‌‌‌‌​‌​​​‌​‍​‍‌‍‌​‍​⁪quarter⁪⁪", "QUARTERS": "⁪⁪⁪‍​‍‍‌​‌​‍‌‌‌‍‍‌‌​‍​‍​‍​‌‌‌‌​​‍​‍‌‍‍‍​‌‍‌⁪quarters⁪⁪", "REMOVE_CONDITION": "⁪⁪⁪‍‌‍​‍​​‍‌‍‍​‍‍‍‍‍​​‌​‌‌‌‌​‌​‌‌​‌​‍​​‌‍​‌⁪Remove Condition⁪⁪", "RESPONSE_COUNT": "⁪⁪⁪‌‍​‌‍‍‌​​‍‌‌​​‍‍‍‌‌‌‍​​‍​‍​‍‌​‍​​‍‍‌‍‌​‌⁪​​​{{count}}‌‌‌ Responses⁪⁪", "SAME_AS_SUBJECT": "⁪⁪⁪‍​​​‌​‍​‌‌‍​‌‌‍‌​‌‌​​‌‍‌‌‌‌​​‍‍‌‌‍‌‍‍⁪Same as Subject⁪⁪", "SAVE": "⁪⁪⁪‍‍‌‍‌‌‌‌‌‌‌‌‍​‍‌‌‌​​​‌‌‍​‌‍​​‌‌​​‌‍‍‌‍‍​⁪Save⁪⁪", "SAVED_FILTERS": "⁪⁪⁪‌‌​‍‌​‌​​​‍‌‌​​‌‍‍‌‌‍​‌‍‍​‌​​‍‍‍​​‌‍‍‌‌​​⁪Saved Filters⁪⁪", "SAVE_AND_APPLY": "⁪⁪⁪‌​​‌‍‍​‍​‌​‍‍​‍​​‍‍‌‌‍‌‌​‍​‌‌​‌‌​‌‍​‍‍​‌‍⁪Save and Apply⁪⁪", "SEARCH": "⁪⁪⁪‍‌​‌‌‍‍​​​‍‌‍​‍‍‌‌​‌‌‍‌‍​‌‍​‍​‍​‍‍‌‌‍‍‍​⁪Search⁪⁪", "SELECTED": "⁪⁪⁪‍​‍‍‌‍‍​‍‍‌‌‌​‌​‍‍‌​​‌​​‍‌​‌‍​‌‍‌​​​‌‌‍​⁪Selected⁪⁪", "SELECTED_CHOICE": "⁪⁪⁪‍‌‌‍​‍‍‌‌​​‍‌‍​‍‍‌‌​​‍‌​​‌‌​‍‍‌‌‌‌‍‍‌‌‌‍⁪Selected choice⁪⁪", "SELECT_FIELD": "⁪⁪⁪‌​​​​‌‌‍‍​‌​‌‍‍‌‍‍‌‌‍‍‌‌‌‍‍‌‌​‌‌‍‍​‍​‌‍​​⁪Select Field⁪⁪", "SELECT_ONE_OR_MORE_FIELDS": "⁪⁪⁪‍​​​‌‌‌‌‌​​​‍​‌‌‍​‍‌‌‌​​‍‌​​​​‍‌​​‌‌‌‌‍⁪Select one or more fields...⁪⁪", "SELECT_OPERAND": "⁪⁪⁪‌‌‌‌‍​​‌​‌​‌​‍‌‌‌​‍‌​‍​‍‌‍‌​​‌‍‍​​‍‌‍‌​​​⁪Select Operand⁪⁪", "SELECT_OPERATOR": "⁪⁪⁪‌‌‌​​​​‍​‍​‍‌‍‍‍‌‌‌‌​‌‍​‌​‌​‌‍‍‍‍‌‍‌‍​‍​​⁪Select Operator⁪⁪", "SHOW_ONLY_RESP": "⁪⁪⁪‌‍‍​​​​‌‌​​‌‍‍‍‍‌‍‍‌​‍‌‍‌​‌‍‌​‍‍‍‍​‍‍​​‌⁪Show only responses:⁪⁪", "SHOW_ONLY_WHERE_COLON": "⁪⁪⁪‍‍‍‌‌‌‌​‌‌​‍‍​‍‍‍‌‌‌​​‌‍​‌​‍​‍‌‍​​​​‍​⁪Show only responses where:⁪⁪", "SURVEY_METADATA": "⁪⁪⁪‌​‌​​‌​‍‌‍‌‍‌‌​‍‌​‌‍‌​‍‌‍​‍‍‍‍‌​‍‌​‍​‍‍⁪Survey Metadata⁪⁪", "TEXT": "⁪⁪⁪‌‌‌‍​​​​​‍‍​​‍‌​​​​‍‍‌​‌‍​‍‍‌‌‌‍‍​​‌‍‍​‍⁪Text⁪⁪", "THIS_MONTH": "⁪⁪⁪‌‌‌​​‌‍‍‌‍‍​​‌​​‌‍‌‍‍​‌‍‌‌‍‍‍​‌‌‌​​​‌‌‍‌​⁪This month⁪⁪", "THIS_QUARTER": "⁪⁪⁪‌​​‍‌​‌‍​​‌‌‍‌‍‌‌‌​‌‌‍​‍‍​​‌‌‍‌‍‌​‌‌​​​‍⁪This quarter⁪⁪", "THIS_WEEK": "⁪⁪⁪‌‌‌‌‌‌‍‍‌‌‌‍‍​‌‍‌‍​‌‍‍​‍‍‍‌‍​‌‍‍‌​‌‍​‍‌‌⁪This week⁪⁪", "THIS_YEAR": "⁪⁪⁪‌‍‌‍‍​‍​​​‌​‍​​‍​‍​‌‍‍‍​​​​​‍‌​​‌‍‌​‌​‌​⁪This year⁪⁪", "TODAY": "⁪⁪⁪‌​​‍​​‍‍‌​‍‍‍‌‌‌‌‍​‍​‍‍‌‌‌‌‌‍​‍‍‌​‌​‍​‍​‍⁪Today⁪⁪", "WEEK": "⁪⁪⁪‍‍​‌‍‍​‍‌​‍‍‍‍​​‌‌‌‍‌‍‍‌‍​‌‌‌​‌​​​‌‍‍‍‌⁪week⁪⁪", "WEEKS": "⁪⁪⁪‌​​‌‍‍‍‌​‍‍‌‍‌‍‍​‌‌‌​​‍​‍​‌​‍‌‌​‌‍‍‌‍‍​​​⁪weeks⁪⁪", "YEAR": "⁪⁪⁪‌​‍‍‍‌​‍​​‍‍‌‍‍‍‍‍‍​‌‌‌‍​‍‌​‍​‌‌‌‍​‍​‍⁪year⁪⁪", "YEARS": "⁪⁪⁪‍‌​‌‍‍‍‌​‍​​​‍‍‌‌‌​‍‍‍‌‌‌​‌‍​​‌‌‌​‌‍‌​⁪years⁪⁪", "YES": "⁪⁪⁪‍​‍‌​​​‍‍‍‍‌‌​‍‍‍​‌‌‍‌​‍‍‌​‌‍‍​​‍‍‌‍‍‍⁪Yes⁪⁪", "YESTERDAY": "⁪⁪⁪‌‍​​‍‍‍‍‌‌‌‌​‍‌‌‌‍‍‍​​‌‍​‍​​‍‍‍‌​‌‍‍‍‌‌‍⁪Yesterday⁪⁪" }, "ru": { "ADD_CONDITION": "Добавить условие", "ADD_FILTER": "Добавить фильтр", "AFTER": "После", "ALL": "Все", "ALL_FILTERS": "Все", "ALL_TIME": "Все время", "AND": "и", "ANY_FILTERS": "Любые", "APPLY": "Применить", "BEFORE": "До", "BETWEEN": "Между", "BREAKOUT_MESSAGE": "Ваше поле имеет более 5000 уникальных значений, мы отобразим только 5000. Чтобы обеспечить поиск точных значений, измените тип поля в редакторе опросов на \"Текст\".", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Невозможно сохранить или применить фильтры. Свяжитесь со службой поддержки Qualtrics для получения дополнительной информации.", "BREAKOUT_WARNING": "Внимание", "BY": "по", "CANCEL": "Отмена", "CANCEL_WITHOUT_SAVING": "Отменить без сохранения", "CHOICES": "Варианты ответов", "CLOSE": "Закрыть", "CONFIRM_CANCEL_WITHOUT_SAVING": "Имеются несохраненные изменения. Действительно отменить без сохранения?", "CONFIRM_DELETE": "Действительно удалить фильтр '{{name}}'?", "CONTACT_FIELDS": "Поля контактов", "CONTAINS": "Содержит", "COPY": "Копировать", "CREATE_A_FILTER": "Создать фильтр", "CREATE_NEW": "Создать новый", "CUSTOM_DATE_RANGE": "Настраиваемый диапазон дат", "DATE": "Дата", "DELETE": "Удалить", "DELETE_FILTER": "Удалить фильтр", "EMBEDDED_DATA": "Встроенные данные", "EQUAL_TO": "Равно", "EVALUATIONS_OTHER": "Другие оценки (не считая оценки субъекта)", "EVALUATIONS_SUBJECT": "Оценки субъекта", "EXCLUDES": "Исключает", "FILTERED_RESPONSES": "Отфильтрованные ответы", "FILTERING_BY": "Фильтр по", "FILTER_ID_COLON": "Идентификатор фильтра:", "FILTER_NAME_COPY": "{{name}} копия", "GREATER_THAN": "Больше", "GT_OR_EQUAL_TO": "Больше или равно", "IN": "Включает", "INCLUDES": "Включает", "INCLUDES_ANY": "Включает любые", "INSERT_NEW_CONDITION": "Вставить новое условие", "INSERT_NEW_CONDITION_SET": "Вставить новый набор условий", "IS": "Равно", "IS_EMPTY": "Пусто", "IS_NOT": "Не является", "IS_NOT_EMPTY": "Не пусто", "LACKS_ALL": "Исключает все", "LAST_120_DAYS": "Последние 120 дней", "LAST_14_DAYS": "За последние 14 дней", "LAST_30_DAYS": "Последние 30 дней", "LAST_365_DAYS": "Последние 365 дней", "LAST_60_DAYS": "Последние 60 дней", "LAST_7_DAYS": "Последние 7 дней", "LAST_90_DAYS": "За последние 90 дней", "LESS_THAN": "Меньше", "LT_OR_EQUAL_TO": "Меньше или равно", "MANAGE_FILTERS": "Управление фильтрами", "MANAGE_FILTERS_ELLIPSIS": "Управление фильтрами...", "MONTH": "мес.", "MONTHS": "мес.", "NEW_FILTER": "Новый фильтр", "NO": "Нет", "NONE": "Нет", "NOT_CONTAINS": "Не содержит", "NOT_EQUAL_TO": "Не равно", "NOT_IN": "Не включает", "NO_AVAILABLE_FIELDS": "Недоступные поля...", "NO_FILTERS_MSG": "У вас еще нет фильтров.", "NPS_GROUP": "Группа NPS®", "NUMBER": "Число", "NUMERIC_VALUE": "Числовое значение", "OFFSET": "Смещение", "OF_THE_FOLLOWING_ARE_TRUE": "из нижеперечисленных правильно", "QUARTER": "квартал", "QUARTERS": "кварталы", "READ_ONLY": "Только для чтения", "REMOVE_CONDITION": "Удалить условие", "RESPONSE_COUNT": "{{count}} отв.", "SAME_AS_SUBJECT": "То же, что субъект", "SAVE": "Сохранить", "SAVED_FILTERS": "Сохраненные фильтры", "SAVE_AND_APPLY": "Сохранить и применить", "SEARCH": "Поиск", "SELECTED": "Выбрано", "SELECTED_CHOICE": "Выбранный вариант", "SELECT_FIELD": "Выбрать поле", "SELECT_ONE_OR_MORE_FIELDS": "Выбрать одно или несколько полей...", "SELECT_OPERAND": "Выбрать операнд", "SELECT_OPERATOR": "Выбрать оператора", "SHOW_ONLY_RESP": "Показывать только ответы, где:", "SHOW_ONLY_WHERE_COLON": "Показывать только ответы, где:", "SURVEY_METADATA": "Метаданные опроса", "TEXT": "Текст", "THIS_MONTH": "Этот месяц", "THIS_QUARTER": "Этот квартал", "THIS_WEEK": "Эта неделя", "THIS_YEAR": "Этот год", "TODAY": "Сегодня", "WEEK": "нед.", "WEEKS": "нед.", "YEAR": "г.", "YEARS": "г.", "YES": "Да", "YESTERDAY": "Вчера" }, "sv": { "ADD_CONDITION": "Lägg till villkor", "ADD_FILTER": "Lägg till filter", "AFTER": "Efter", "ALL": "Alla", "ALL_FILTERS": "Alla", "ALL_TIME": "All tid", "AND": "och", "ANY_FILTERS": "Något", "APPLY": "Tillämpa", "BEFORE": "Före", "BETWEEN": "Mellan", "BREAKOUT_MESSAGE": "Ditt fält innehåller fler än 5 000 unika värden. Vi kommer endast att visa 5 000 av dem! Ändra fälttyp till Text i undersökningseditorn för att kunna söka efter exakta värden.", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "Dina filter kunde inte sparas eller tillämpas. Kontakta Qualtrics-support för mer information.", "BREAKOUT_WARNING": "Varning!", "BY": "efter", "CANCEL": "Avbryt", "CANCEL_WITHOUT_SAVING": "Avbryt utan att spara", "CHOICES": "Alternativ", "CLOSE": "Stäng", "CONFIRM_CANCEL_WITHOUT_SAVING": "Du har ändringar som inte har sparats. Vill du avbryta utan att spara?", "CONFIRM_DELETE": "Vill du radera filtret '{{name}}'?", "CONTACT_FIELDS": "Kontaktfält", "CONTAINS": "Innehåller", "COPY": "Kopiera", "CREATE_A_FILTER": "Skapa filter", "CREATE_NEW": "Skapa ny", "CUSTOM_DATE_RANGE": "Anpassat datumintervall", "DATE": "Datum", "DELETE": "Radera", "DELETE_FILTER": "Radera filter", "EMBEDDED_DATA": "Inbäddade data", "EQUAL_TO": "Lika med", "EVALUATIONS_OTHER": "Övriga utvärderingar (exklusive subjektets)", "EVALUATIONS_SUBJECT": "Subjektets utvärderingar", "EXCLUDES": "Exkluderar", "FILTERED_RESPONSES": "Filtrerade svar", "FILTERING_BY": "Filtrering efter", "FILTER_ID_COLON": "Filter-ID:", "FILTER_NAME_COPY": "{{name}} Kopia", "GREATER_THAN": "Större än", "GT_OR_EQUAL_TO": "Större än eller lika med", "IN": "Inkluderar", "INCLUDES": "Inkluderar", "INCLUDES_ANY": "Inkluderar något", "INSERT_NEW_CONDITION": "Infoga nytt villkor", "INSERT_NEW_CONDITION_SET": "Infoga ny villkorsuppsättning", "IS": "Är", "IS_EMPTY": "Är tom", "IS_NOT": "Är inte", "IS_NOT_EMPTY": "Är inte tom", "LACKS_ALL": "Exkluderar alla", "LAST_120_DAYS": "Senaste 120 dagarna", "LAST_14_DAYS": "Senaste 14 dagarna", "LAST_30_DAYS": "Senaste 30 dagarna", "LAST_365_DAYS": "Senaste 365 dagarna", "LAST_60_DAYS": "Senaste 60 dagarna", "LAST_7_DAYS": "Senaste 7 dagarna", "LAST_90_DAYS": "Senaste 90 dagarna", "LESS_THAN": "Mindre än", "LT_OR_EQUAL_TO": "Mindre än eller lika med", "MANAGE_FILTERS": "Hantera filter", "MANAGE_FILTERS_ELLIPSIS": "Hantera filter ...", "MONTH": "månad", "MONTHS": "månader", "NEW_FILTER": "Nytt filter", "NO": "Nej", "NONE": "Inget", "NOT_CONTAINS": "Innehåller inte", "NOT_EQUAL_TO": "Inte lika med", "NOT_IN": "Inkluderar inte", "NO_AVAILABLE_FIELDS": "Inga fält tillgängliga ...", "NO_FILTERS_MSG": "Du har inga filter ännu.", "NPS_GROUP": "NPS®-grupp", "NUMBER": "Nummer", "NUMERIC_VALUE": "Numeriskt värde", "OFFSET": "Förskjutning", "OF_THE_FOLLOWING_ARE_TRUE": "av följande är sant/sanna", "QUARTER": "kvartal", "QUARTERS": "kvartal", "READ_ONLY": "Skrivskyddad", "REMOVE_CONDITION": "Ta bort villkor", "RESPONSE_COUNT": "{{count}} svar", "SAME_AS_SUBJECT": "Samma som subjekt", "SAVE": "Spara", "SAVED_FILTERS": "Sparade filter", "SAVE_AND_APPLY": "Spara och tillämpa", "SEARCH": "Sök", "SELECTED": "Valda", "SELECTED_CHOICE": "Valt alternativ", "SELECT_FIELD": "Välj fält", "SELECT_ONE_OR_MORE_FIELDS": "Välj ett eller flera fält ...", "SELECT_OPERAND": "Välj operand", "SELECT_OPERATOR": "Välj operator", "SHOW_ONLY_RESP": "Visa endast svar:", "SHOW_ONLY_WHERE_COLON": "Visa endast svar där:", "SURVEY_METADATA": "Metadata för undersökning", "TEXT": "Text", "THIS_MONTH": "Innevarande månad", "THIS_QUARTER": "Innevarande kvartal", "THIS_WEEK": "Innevarande vecka", "THIS_YEAR": "Innevarande år", "TODAY": "Idag", "WEEK": "vecka", "WEEKS": "veckor", "YEAR": "år", "YEARS": "år", "YES": "Ja", "YESTERDAY": "Igår" }, "th": { "ADD_CONDITION": "เพิ่มเงื่อนไข", "ADD_FILTER": "เพิ่มฟิลเตอร์", "AFTER": "หลัง", "ALL": "ทุกรายการ", "ALL_FILTERS": "ทั้งหมด", "ALL_TIME": "เวลาทั้งหมด", "AND": "และ", "ANY_FILTERS": "รายการใดก็ตาม", "APPLY": "นำไปใช้", "BEFORE": "ก่อน", "BETWEEN": "ระหว่าง", "BREAKOUT_MESSAGE": "ฟิลด์ของคุณมีค่าที่ไม่ซ้ำกันมากกว่า 5000 รายการ แต่เราจะแสดงเพียง 5000 รายการเท่านั้น! ให้เปลี่ยนแปลงประเภทฟิลด์ในเอดิเตอร์แบบสำรวจเป็น 'ข้อความ' เพื่อให้สามารถค้นหาค่าที่เฉพาะเจาะจงต่างๆ ได้", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "ไม่สามารถเก็บบันทึกหรือนำฟิลเตอร์ของคุณไปใช้ได้ สำหรับข้อมูลเพิ่มเติม กรุณาติดต่อฝ่ายสนับสนุน Qualtrics", "BREAKOUT_WARNING": "คำเตือน!", "BY": "ตาม", "CANCEL": "ยกเลิก", "CANCEL_WITHOUT_SAVING": "ยกเลิกโดยไม่เก็บบันทึก", "CHOICES": "ตัวเลือก", "CLOSE": "ปิด", "CONFIRM_CANCEL_WITHOUT_SAVING": "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้เก็บบันทึก คุณแน่ใจหรือไม่ว่าต้องการยกเลิกโดยไม่เก็บบันทึก?", "CONFIRM_DELETE": "คุณแน่ใจหรือไม่ว่าต้องการลบฟิลเตอร์ '{{name}}'?", "CONTACT_FIELDS": "ฟิลด์ผู้ติดต่อ", "CONTAINS": "มี", "COPY": "คัดลอก", "CREATE_A_FILTER": "สร้างฟิลเตอร์", "CREATE_NEW": "สร้างใหม่", "CUSTOM_DATE_RANGE": "ช่วงวันที่ที่ปรับแต่งได้", "DATE": "วันที่", "DELETE": "ลบ", "DELETE_FILTER": "ลบฟิลเตอร์", "EMBEDDED_DATA": "ข้อมูลฝังตัว", "EQUAL_TO": "เท่ากับ", "EVALUATIONS_OTHER": "การประเมินอื่นๆ (ไม่รวมส่วนของผู้รับการประเมิน)", "EVALUATIONS_SUBJECT": "การประเมินของผู้รับการประเมิน", "EXCLUDES": "ไม่รวม", "FILTERED_RESPONSES": "การตอบกลับที่ฟิลเตอร์แล้ว", "FILTERING_BY": "การฟิลเตอร์ตาม", "FILTER_ID_COLON": "ID ฟิลเตอร์:", "FILTER_NAME_COPY": "{{name}} สำเนา", "GREATER_THAN": "มากกว่า", "GT_OR_EQUAL_TO": "มากกว่าหรือเท่ากับ", "IN": "รวม", "INCLUDES": "รวม", "INCLUDES_ANY": "รวมทุกรายการ", "INSERT_NEW_CONDITION": "แทรกเงื่อนไขใหม่", "INSERT_NEW_CONDITION_SET": "แทรกชุดเงื่อนไขใหม่", "IS": "คือ", "IS_EMPTY": "ว่างเปล่า", "IS_NOT": "ไม่ใช่", "IS_NOT_EMPTY": "ไม่ว่างเปล่า", "LACKS_ALL": "ไม่รวมทั้งหมด", "LAST_120_DAYS": "120 วันที่ผ่านมา", "LAST_14_DAYS": "14 วันที่ผ่านมา", "LAST_30_DAYS": "30 วันที่ผ่านมา", "LAST_365_DAYS": "365 วันที่ผ่านมา", "LAST_60_DAYS": "60 วันที่ผ่านมา", "LAST_7_DAYS": "7 วันที่ผ่านมา", "LAST_90_DAYS": "90 วันที่ผ่านมา", "LESS_THAN": "น้อยกว่า", "LT_OR_EQUAL_TO": "น้อยกว่าหรือเท่ากับ", "MANAGE_FILTERS": "จัดการฟิลเตอร์", "MANAGE_FILTERS_ELLIPSIS": "จัดการฟิลเตอร์...", "MONTH": "เดือน", "MONTHS": "เดือน", "NEW_FILTER": "ฟิลเตอร์ใหม่", "NO": "ไม่ใช่", "NONE": "ไม่มี", "NOT_CONTAINS": "ไม่มี", "NOT_EQUAL_TO": "ไม่เท่ากับ", "NOT_IN": "ไม่รวม", "NO_AVAILABLE_FIELDS": "ไม่มีฟิลด์ที่ใช้ได้...", "NO_FILTERS_MSG": "คุณยังไม่มีฟิลเตอร์ใดๆ เลย", "NPS_GROUP": "กลุ่ม NPS®", "NUMBER": "ตัวเลข", "NUMERIC_VALUE": "ค่าตัวเลข", "OFFSET": "ออฟเซ็ต", "OF_THE_FOLLOWING_ARE_TRUE": "ของรายการต่อไปนี้เป็นจริง", "QUARTER": "ไตรมาส", "QUARTERS": "ไตรมาส", "READ_ONLY": "อ่านอย่างเดียว", "REMOVE_CONDITION": "ย้ายเงื่อนไขออก", "RESPONSE_COUNT": "{{count}} การตอบกลับ", "SAME_AS_SUBJECT": "เหมือนกับผู้รับการประเมิน", "SAVE": "เก็บบันทึก", "SAVED_FILTERS": "ฟิลเตอร์ที่เก็บบันทึก", "SAVE_AND_APPLY": "เก็บบันทึกและนำไปใช้", "SEARCH": "ค้นหา", "SELECTED": "เลือกแล้ว", "SELECTED_CHOICE": "ตัวเลือกที่เลือกไว้", "SELECT_FIELD": "เลือกฟิลด์", "SELECT_ONE_OR_MORE_FIELDS": "เลือกฟิลด์อย่างน้อยหนึ่งรายการ...", "SELECT_OPERAND": "เลือกตัวถูกดำเนินการ", "SELECT_OPERATOR": "เลือกตัวดำเนินการ", "SHOW_ONLY_RESP": "แสดงเฉพาะการตอบกลับ:", "SHOW_ONLY_WHERE_COLON": "แสดงเฉพาะการตอบกลับที่:", "SURVEY_METADATA": "เมต้าดาต้าแบบสำรวจ", "TEXT": "ข้อความ", "THIS_MONTH": "เดือนนี้", "THIS_QUARTER": "ไตรมาสนี้", "THIS_WEEK": "สัปดาห์นี้", "THIS_YEAR": "ปีนี้", "TODAY": "วันนี้", "WEEK": "สัปดาห์", "WEEKS": "สัปดาห์", "YEAR": "ปี", "YEARS": "ปี", "YES": "ใช่", "YESTERDAY": "เมื่อวานนี้" }, "zh-Hans": { "ADD_CONDITION": "添加条件", "ADD_FILTER": "添加过滤器", "AFTER": "之后", "ALL": "全部", "ALL_FILTERS": "全部", "ALL_TIME": "全部时间", "AND": "和", "ANY_FILTERS": "任意时间", "APPLY": "应用", "BEFORE": "之前", "BETWEEN": "介于", "BREAKOUT_MESSAGE": "字段的唯一值已超过 5000 个，我们将仅显示 5000 个！如需搜索确切值，请将调查编辑器中的字段类型更改为“文本”。", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "无法保存或应用您的过滤器。请联系 Qualtrics 支持以获取更多信息。", "BREAKOUT_WARNING": "警告！", "BY": "截至", "CANCEL": "取消", "CANCEL_WITHOUT_SAVING": "取消而不保存", "CHOICES": "选择", "CLOSE": "关闭", "CONFIRM_CANCEL_WITHOUT_SAVING": "您有未保存的更改。您确定要取消而不保存吗？", "CONFIRM_DELETE": "您确定要删除过滤器“{{name}}”吗？", "CONTACT_FIELDS": "联系人字段", "CONTAINS": "包含", "COPY": "复制", "CREATE_A_FILTER": "创建过滤器", "CREATE_NEW": "新建", "CUSTOM_DATE_RANGE": "自定义日期范围", "DATE": "日期", "DELETE": "删除", "DELETE_FILTER": "删除过滤器", "EMBEDDED_DATA": "嵌入式数据", "EQUAL_TO": "等于", "EVALUATIONS_OTHER": "其他评估（除对象之外）", "EVALUATIONS_SUBJECT": "对象的评估", "EXCLUDES": "排除", "FILTERED_RESPONSES": "已过滤的回复", "FILTERING_BY": "过滤条件", "FILTER_ID_COLON": "过滤器 ID：", "FILTER_NAME_COPY": "{{name}}复制", "GREATER_THAN": "大于", "GT_OR_EQUAL_TO": "大于或等于", "IN": "包括", "INCLUDES": "包括", "INCLUDES_ANY": "包括任何", "INSERT_NEW_CONDITION": "插入新条件", "INSERT_NEW_CONDITION_SET": "插入新条件集合", "IS": "是", "IS_EMPTY": "为空", "IS_NOT": "不是", "IS_NOT_EMPTY": "不为空", "LACKS_ALL": "排除全部", "LAST_120_DAYS": "过去 120 天", "LAST_14_DAYS": "过去 14 天", "LAST_30_DAYS": "过去 30 天", "LAST_365_DAYS": "过去 365 天", "LAST_60_DAYS": "过去 60 天", "LAST_7_DAYS": "过去 7 天", "LAST_90_DAYS": "过去 90 天", "LESS_THAN": "小于", "LT_OR_EQUAL_TO": "小于或等于", "MANAGE_FILTERS": "管理过滤器", "MANAGE_FILTERS_ELLIPSIS": "管理过滤器...", "MONTH": "月", "MONTHS": "月", "NEW_FILTER": "新建过滤器", "NO": "否", "NONE": "无", "NOT_CONTAINS": "不包含", "NOT_EQUAL_TO": "不等于", "NOT_IN": "不包括", "NO_AVAILABLE_FIELDS": "无可用字段...", "NO_FILTERS_MSG": "您还没有任何过滤器。", "NPS_GROUP": "NPS® 组", "NUMBER": "数字", "NUMERIC_VALUE": "数值", "OFFSET": "提前", "OF_THE_FOLLOWING_ARE_TRUE": "的以下内容是正确的", "QUARTER": "季度", "QUARTERS": "季度", "READ_ONLY": "只读", "REMOVE_CONDITION": "移除条件", "RESPONSE_COUNT": "{{count}} 个回复", "SAME_AS_SUBJECT": "与对象相同", "SAVE": "保存", "SAVED_FILTERS": "已保存的过滤器", "SAVE_AND_APPLY": "保存并应用", "SEARCH": "搜索", "SELECTED": "已选定", "SELECTED_CHOICE": "选定的选择", "SELECT_FIELD": "选择字段", "SELECT_ONE_OR_MORE_FIELDS": "选择一个或多个字段...", "SELECT_OPERAND": "选择操作数", "SELECT_OPERATOR": "选择运算符", "SHOW_ONLY_RESP": "仅显示回复：", "SHOW_ONLY_WHERE_COLON": "仅显示符合以下条件的回复：", "SURVEY_METADATA": "调查元数据", "TEXT": "文本", "THIS_MONTH": "本月", "THIS_QUARTER": "本季度", "THIS_WEEK": "本周", "THIS_YEAR": "本年", "TODAY": "今天", "WEEK": "周", "WEEKS": "周", "YEAR": "年", "YEARS": "年", "YES": "是", "YESTERDAY": "昨天" }, "zh-Hant": { "ADD_CONDITION": "新增條件", "ADD_FILTER": "新增篩選器", "AFTER": "之後", "ALL": "所有", "ALL_FILTERS": "所有", "ALL_TIME": "所有時間", "AND": "以及", "ANY_FILTERS": "任何", "APPLY": "套用", "BEFORE": "之前", "BETWEEN": "之間", "BREAKOUT_MESSAGE": "您的欄位有超過 5000 個唯一值，我們只顯示 5000個！在調查編輯器中將欄位類型變更為「文字」以啟用搜尋確切值。", "BREAKOUT_MESSAGE_ERROR_ON_CLOSE": "無法儲存或套用您的篩選。如需詳細資訊，請聯絡 Qualtrics 支援。", "BREAKOUT_WARNING": "警告！", "BY": "透過", "CANCEL": "取消", "CANCEL_WITHOUT_SAVING": "取消而不儲存", "CHOICES": "選項", "CLOSE": "關閉", "CONFIRM_CANCEL_WITHOUT_SAVING": "您尚有未儲存的變更。您確定要取消而不儲存嗎？", "CONFIRM_DELETE": "您確定要刪除篩選器「{{name}}」嗎？", "CONTACT_FIELDS": "聯絡人欄位", "CONTAINS": "包含", "COPY": "複製", "CREATE_A_FILTER": "建立篩選器", "CREATE_NEW": "建立新", "CUSTOM_DATE_RANGE": "自訂日期範圍", "DATE": "日期", "DELETE": "刪除", "DELETE_FILTER": "刪除篩選器", "EMBEDDED_DATA": "嵌入式資料", "EQUAL_TO": "等於", "EVALUATIONS_OTHER": "其他評估（不包括調查對象）", "EVALUATIONS_SUBJECT": "調查對象的評估", "EXCLUDES": "排除項", "FILTERED_RESPONSES": "已篩選的回應", "FILTERING_BY": "篩選依據", "FILTER_ID_COLON": "篩選器 ID：", "FILTER_NAME_COPY": "{{name}}複製", "GREATER_THAN": "大於", "GT_OR_EQUAL_TO": "大於或等於", "IN": "併入項", "INCLUDES": "併入項", "INCLUDES_ANY": "併入任何", "INSERT_NEW_CONDITION": "插入新條件", "INSERT_NEW_CONDITION_SET": "插入新條件集", "IS": "是", "IS_EMPTY": "是空", "IS_NOT": "不是", "IS_NOT_EMPTY": "不是空", "LACKS_ALL": "排除所有", "LAST_120_DAYS": "最後 120 天", "LAST_14_DAYS": "最後14天", "LAST_30_DAYS": "最後 30 天", "LAST_365_DAYS": "過去 365 天", "LAST_60_DAYS": "最後 60 天", "LAST_7_DAYS": "最後 7 天", "LAST_90_DAYS": "最後90天", "LESS_THAN": "小於", "LT_OR_EQUAL_TO": "小於或等於", "MANAGE_FILTERS": "不存在任何配額", "MANAGE_FILTERS_ELLIPSIS": "管理篩選器...", "MONTH": "月份", "MONTHS": "月份數", "NEW_FILTER": "新建篩選器", "NO": "否", "NONE": "無", "NOT_CONTAINS": "不包含", "NOT_EQUAL_TO": "不等於", "NOT_IN": "不包括", "NO_AVAILABLE_FIELDS": "沒有可用的欄位...", "NO_FILTERS_MSG": "您還沒有篩選器。", "NPS_GROUP": "NPS®群組", "NUMBER": "數目", "NUMERIC_VALUE": "數值", "OFFSET": "篩選時段", "OF_THE_FOLLOWING_ARE_TRUE": "符合下列條件", "QUARTER": "季度", "QUARTERS": "季度", "READ_ONLY": "唯讀", "REMOVE_CONDITION": "移除條件", "RESPONSE_COUNT": "{{count}} 個回應", "SAME_AS_SUBJECT": "與調查對象相同", "SAVE": "儲存", "SAVED_FILTERS": "已保存篩選器", "SAVE_AND_APPLY": "儲存並套用", "SEARCH": "搜尋", "SELECTED": "已選取", "SELECTED_CHOICE": "所選選項", "SELECT_FIELD": "選取欄位", "SELECT_ONE_OR_MORE_FIELDS": "選擇一個或多個欄位...", "SELECT_OPERAND": "選擇運算元", "SELECT_OPERATOR": "選擇運算子", "SHOW_ONLY_RESP": "僅顯示回應：", "SHOW_ONLY_WHERE_COLON": "僅顯示滿足下列條件的回應：", "SURVEY_METADATA": "調查中繼資料", "TEXT": "文字", "THIS_MONTH": "本月", "THIS_QUARTER": "本季度", "THIS_WEEK": "本周", "THIS_YEAR": "今年", "TODAY": "今天", "WEEK": "星期", "WEEKS": "星期數", "YEAR": "年份", "YEARS": "年數", "YES": "是", "YESTERDAY": "昨天" } });
}]);

'use strict';
/**
 * A simple mapping of Field types to directive types
 */
angular.module('filters-client').value('fc.typeMap', {
	FreeFormText: 'freeForm',
	GenericValue: 'freeForm',
	Id: 'freeForm',
	EnumerableValue: 'enumerableValue',
	EnumerableValueSet: 'enumerableValueSet',
	ScalarValue: 'scalar',
	EnumerableScalarValue: 'scalar',
	DateTime: 'date',
	Custom: 'custom',
	PersonMetadata: 'custom'
});

angular.module('filters-client').run(['$templateCache', function ($templateCache) {
	'use strict';

	$templateCache.put('templates/fc-cancel-without-save-modal.html', "<div class=\"filters-client\">\n" + "        <div class=\"modal-header\">\n" + "                <div class=\"modal-title\">{{'FSFILTERS.CANCEL_WITHOUT_SAVING' | fcTranslate}}</div>\n" + "        </div>\n" + "        <div class=\"modal-body\">\n" + "                {{'FSFILTERS.CONFIRM_CANCEL_WITHOUT_SAVING' | fcTranslate}}\n" + "        </div>\n" + "        <div class=\"modal-footer\">\n" + "                <div class=\"btn btn-danger\" ng-click=\"closeFiltersModal()\">{{'FSFILTERS.YES' | fcTranslate}}</div>\n" + "                <div class=\"btn btn-hover\" ng-click=\"closeConfirmCancelWithoutSave()\">{{'FSFILTERS.NO' | fcTranslate}}</div>\n" + "        </div>\n" + "</div>");

	$templateCache.put('templates/fc-date-value.html', "<div class=\"input-group-btn no-radius\">\n" + "	<div class=\"btn btn-select operator-drpdwn\" qstrap.select-menu items=\"getOperatorMenu()\" ng-model=\"vm.operator\" ng-change=\"updateViewValue()\">\n" + "		{{operatorTranslations[vm.operator] || 'FSFILTERS.SELECT_OPERATOR' | fcTranslate}}\n" + "		<span class=\"caret\"></span>\n" + "	</div>\n" + "</div>\n" + "<input class=\"form-control operand-form\" bs-datepicker timezone=\"{{getTimezoneKeyForDatePicker()}}\" container=\"body\" ng-if=\"isSingleDate()\" ng-model=\"vm.dateValue\" ng-change=\"updateViewValue()\" ng-class=\"{'highlight': !vm.dateValue}\"/>\n" + "<div ng-if=\"isMultipleDate()\" class=\"left\">\n" + "	<input class=\"form-control operand-form-before\" bs-datepicker timezone=\"{{getTimezoneKeyForDatePicker()}}\" container=\"body\" ng-model=\"vm.dateValue\" ng-change=\"updateViewValue()\" ng-class=\"{'highlight': !vm.dateValue}\"/>\n" + "	<span class=\"input-group-addon\">{{\"FSFILTERS.AND\" | fcTranslate}}</span>\n" + "	<input class=\"form-control operand-form-after\" bs-datepicker timezone=\"{{getTimezoneKeyForDatePicker()}}\" container=\"body\" ng-model=\"vm.beforeDate\" ng-change=\"updateViewValue()\" ng-class=\"{'highlight': !vm.beforeDate}\">\n" + "</div>");

	$templateCache.put('templates/fc-delete-modal.html', "<div class=\"filters-client\">\n" + "        <div class=\"modal-header\">\n" + "                <div class=\"modal-title\">{{'FSFILTERS.DELETE_FILTER' | fcTranslate}}</div>\n" + "        </div>\n" + "        <div class=\"modal-body\">\n" + "        {{'FSFILTERS.CONFIRM_DELETE' | fcTranslate: {name:(filterMetadata.name || ('FSFILTERS.NEW_FILTER' | fcTranslate) )} }}\n" + "        </div>\n" + "        <div class=\"modal-footer\">\n" + "                <div class=\"btn btn-danger\" ng-disabled=\"permissions.readOnly\" ng-click=\"deleteFilter(filterMetadata.id)\">{{'FSFILTERS.DELETE' | fcTranslate}}</div>\n" + "                <div class=\"btn btn-hover\" ng-click=\"close()\">{{'FSFILTERS.CLOSE' | fcTranslate}}</div>\n" + "        </div>\n" + "</div>");

	$templateCache.put('templates/fc-enumerable-value.html', "<div class=\"input-group-btn no-radius\">\n" + "    <div class=\"btn btn-select operator-drpdwn\" qstrap.select-menu items=\"operatorMenu\" ng-model=\"uiOperator\" ng-change=\"updateFilter()\" ng-class=\"{'btn-info': !displayedFilter.filter.operator}\">\n" + "        {{operators[uiOperator] || 'FSFILTERS.SELECT_OPERATOR' | fcTranslate}}\n" + "        <span class=\"caret\"></span>\n" + "    </div>\n" + "</div>\n" + "<div ng-if=\"!operandDisabled\" class=\"input-group-btn\">\n" + "    <div class=\"btn btn-select operand-drpdwn\" fc.qmenu pagination=\"pagination\" multi-select-menu=\"true\" searchable=\"true\" search-callback=\"getOperands($search)\" on-selection=\"onSelection($value, selected)\" ng-class=\"{'btn-info': !displayedFilter.filter.operand.length}\">\n" + "        {{operandLabel}}\n" + "        <span class=\"caret\"></span>\n" + "    </div>\n" + "</div>\n");

	$templateCache.put('templates/fc-filter.html', "<div class=\"input-group filter-group filters-client\">\n" + "     <div class=\"input-group-btn radius\">\n" + "          <div class=\"btn btn-select\" qstrap.select-menu options=\"{searchable:true}\" items=\"getMenuItems(false, permissions)\" on-change=\"fieldChanged($value)\" ng-model=\"displayedFilter.filter.field\" ng-class=\"{'btn-info': !displayedFilter.filter.field}\">\n" + "               {{fieldLabel}}\n" + "               <span class=\"caret\"></span>\n" + "          </div>\n" + "     </div>\n" + "     <div class=\"left\" ng-switch=\"typeMap[type]\">\n" + "          <div ng-switch-when=\"enumerableValue|enumerableValueSet\" ng-switch-when-separator=\"|\" fc.enumerable-value class=\"left\"></div>\n" + "          <div ng-switch-when=\"freeForm\" fc.free-form class=\"left\"></div>\n" + "          <div ng-switch-when=\"scalar\" fc.scalar-value class=\"left\"></div>\n" + "          <div ng-switch-when=\"date\" fc.date-value timezone=\"timezone\" class=\"left\" ng-model=\"displayedFilter.filter\" ng-change=\"filterChanged()\"></div>\n" + "          <div ng-switch-when=\"custom\" fc.custom-filter class=\"left\"></div>\n" + "     </div>\n" + "</div>\n");

	$templateCache.put('templates/fc-filters-modal.html', "<div class=\"filters-client\">\n" + "        <div class=\"modal-header\">\n" + "                <div class=\"modal-title\">{{'FSFILTERS.MANAGE_FILTERS' | fcTranslate}}</div>\n" + "        </div>\n" + "        <div class=\"scrolling-body\">\n" + "                <div class=\"filter-modal-body modal-body filters-client-modal-body-container\">\n" + "                        <div ng-if=\"!noFilters\">\n" + "                                <div class=\"filters-client-col-xs-3 fs-sidebar-section\">\n" + "                                        <div class=\"search-wrapper\">\n" + "                                                <input class=\"search form-control\" type=\"text\" ng-attr-placeholder=\"{{'FSFILTERS.SEARCH' | fcTranslate}}\" ng-model=\"query\" ng-change=\"searchFilters(query)\" ng-disabled=\"permissions.readOnly\">\n" + "                                        </div>\n" + "                                        <div class=\"saved-filters\" style=\"height:{{sideBarHeight()}}px\">\n" + "                                                <div class=\"saved-filter\" ng-repeat=\"f in searchedFilterWrappers track by f.filterId\" ng-class=\"{'selected': f.filterId === currentFilterWrapper.filterId, 'filters-client-invalid-color': f.filterId !== currentFilterWrapper.filterId && f.isNotValid, 'disabled':permissions.readOnly}\">\n" + "                                                        <div class=\"btn saved-filter-btn\" ng-click=\"previewFilter(f)\" ng-class=\"{'filters-client-transparent-background': permissions.readOnly}\"><span ng-if=\"!f.filterName\">{{'FSFILTERS.NEW_FILTER' | fcTranslate}}</span><span ng-if=\"f.filterName\" ng-bind-html=\"f.filterName\"></span><span ng-if=\"f.isNotValid && f.filterId !== currentFilterWrapper.filterId\" class=\"icon icon-caution filters-client-caution-icon\"></span>\n" + "                                                        </div>\n" + "                                                        <div class=\"filters-client-filter-modal-icons\" ng-class=\"{'filters-client-white':f.filterId === currentFilterWrapper.filterId}\">\n" + "                                                                <span qstrap.tooltip position=\"top\" content=\"{{'FSFILTERS.COPY' | fcTranslate}}\" delay=\"1000\" ng-click=\"copyFilter(f.filterId)\" class=\"icon icon-squarestack\"></span><span qstrap.tooltip position=\"top\" content=\"{{'FSFILTERS.DELETE' | fcTranslate}}\" delay=\"1000\" ng-click=\"confirmDeleteFilter(f.filterId, f.filterName)\" class=\"icon icon-x-filled\"></span>\n" + "                                                        </div>\n" + "                                                </div>\n" + "                                        </div>\n" + "                                        <div class=\"create-btn-wrapper\"><div class=\"btn btn-success\" ng-class=\"{'disabled':permissions.readOnly}\" ng-click=\"createNewFilter()\">{{'FSFILTERS.CREATE_NEW' | fcTranslate}}</div></div>\n" + "                                </div>\n" + "                                <div class=\"filters-client-col-xs-9 filter-preview\">\n" + "                                        <div><input type=\"text\" class=\"form-control form-control-full filter-title\" maxlength=\"100\" ng-model=\"currentFilterWrapper.filterName\" placeholder=\"{{getPlaceHolder()}}\" ng-disabled=\"permissions.readOnly\"></div>\n" + "                                        <div ng-if=\"!isTemporaryFilterId(currentFilterWrapper.filterId)\" class=\"filters-displayed-filter-id\">\n" + "                                                {{'FSFILTERS.FILTER_ID_COLON' | fcTranslate}} {{currentFilterWrapper.filterId}}\n" + "                                        </div>\n" + "                                        <div class=\"filters-client-show-only-where-text\">\n" + "                                                {{'FSFILTERS.SHOW_ONLY_WHERE_COLON' | fcTranslate}}\n" + "                                        </div>\n" + "                                        <div class=\"the-tree\">\n" + "                                                <div fc.nested-filter timezone=\"currentFilterWrapper.timezone\" filter-id=\"currentFilterWrapper.filterId\" filter=\"currentFilterWrapper.filter\" permissions=\"permissions\"></div>\n" + "                                        </div>\n" + "                                </div>\n" + "                        </div>\n" + "                        <div ng-if=\"noFilters\">\n" + "                                <div class=\"filters-client-no-filters-container\">\n" + "                                        <div class=\"filters-client-table-cell-aligned filters-client-no-filters-cell\">\n" + "                                                <div class=\"filters-client-no-filters-text\">\n" + "                                                        {{'FSFILTERS.NO_FILTERS_MSG' | fcTranslate}}\n" + "                                                </div>\n" + "                                                <div class=\"btn btn-success\" ng-click=\"createNewFilter()\">\n" + "                                                        {{'FSFILTERS.CREATE_A_FILTER' | fcTranslate}}\n" + "                                                </div>\n" + "                                        </div>\n" + "                                </div>\n" + "                        </div>\n" + "                </div>\n" + "        </div>\n" + "        <div class=\"modal-footer\">\n" + "                <div class=\"pull-left modal-response-count\" ng-show=\"filteredCountObject.count !== undefined\">{{'FSFILTERS.FILTERED_RESPONSES' | fcTranslate}}: {{filteredCountObject.count}} </div>\n" + "                <div class=\"btn btn-success\" ng-click=\"saveFilters()\" ng-class=\"{'disabled': permissions.readOnly || haveInvalidFilters()}\" qstrap.spin spin-if=\"saving\">{{'FSFILTERS.SAVE_AND_APPLY' | fcTranslate}}</div>\n" + "                <div class=\"btn btn-hover\" ng-click=\"closeModal()\">{{'FSFILTERS.CANCEL' | fcTranslate}}</div>\n" + "        </div>\n" + "</div>\n");

	$templateCache.put('templates/fc-free-form.html', "<div class=\"input-group-btn no-radius\">\n" + "	<div class=\"btn btn-select operator-drpdwn\" qstrap.select-menu items=\"getOperators()\" ng-model=\"uiOperator\" ng-change=\"updateOperator()\" ng-class=\"{'btn-info': !displayedFilter.filter.operator}\">\n" + "		{{operators[uiOperator] || 'FSFILTERS.SELECT_OPERATOR' | fcTranslate}}\n" + "		<span class=\"caret\"></span>\n" + "	</div>\n" + "</div>\n" + "<input ng-if=\"!operandDisabled\" type=\"text\" class=\"form-control operand-form\" ng-model=\"displayedFilter.filter.operand\" ng-change=\"updateFilter()\"  ng-class=\"{'highlight':!displayedFilter.filter.operand}\"/>");

	$templateCache.put('templates/fc-nested-filter.html', "<div>\n" + "	<div class=\"btn btn-select middle-aligned\" ng-class=\"{'disabled':isReadOnlyCustomFilter(filterId)}\" style=\"margin:0 5px\" qstrap.select-menu items=\"getTypeMenu()\" ng-model=\"filter.type\" ng-change=\"typeChanged()\">{{filterTypes[filter.type] | fcTranslate}}<span class=\"caret\"></span></div> {{'FSFILTERS.OF_THE_FOLLOWING_ARE_TRUE' | fcTranslate}}\n" + "	<span class=\"icon icon-minus-framed middle-aligned\" ng-click=\"removeList(listIndex)\" ng-show=\"parentFilter\" ng-class=\"{'disabled':permissions.readOnly}\"></span>\n" + "	<ul class=\"filter-list\">\n" + "		<li ng-repeat=\"f in filter.children\">\n" + "			<div ng-switch=\"f.type\">\n" + "				<div ng-switch-when=\"filter\">\n" + "					<div ng-class=\"{'disabled':isReadOnlyCustomFilter(filterId)}\" ng-include=\"'templates/fc-single-filter.html'\"></div>\n" + "				</div>\n" + "				<div ng-switch-default>\n" + "					<div fc.nested-filter permissions=\"permissions\" filter-id=\"filterId\" filter=\"f\" timezone=\"timezone\" parent-filter=\"filter\" grand-parent-filter=\"parentFilter\" list-index=\"$index\"></div>\n" + "				</div>\n" + "			</div>\n" + "		</li>\n" + "		<span class=\"icon icon-lock-sm filters-client-icon-lock-sm middle-aligned\" ng-show=\"isReadOnlyCustomFilter(filterId)\"></span>\n" + "		<span class=\"filters-client-read-only-text middle-aligned\" ng-show=\"isReadOnlyCustomFilter(filterId)\">{{'FSFILTERS.READ_ONLY' | fcTranslate}}</span>\n" + "		<li>\n" + "		    <div class=\"add btn btn-sm btn-success insert-new-condition-btn\" ng-hide=\"isReadOnlyCustomFilter(filterId)\" ng-click=\"insert(filter.children.length - 1)\" ng-class=\"{'disabled':permissions.readOnly}\"><span class=\"icon btn-icon-plus\"></span><span>{{'FSFILTERS.INSERT_NEW_CONDITION' | fcTranslate}}</span></div>\n" + "		    <div class=\"add btn btn-sm btn-success insert-new-condition-set-btn\"  ng-hide=\"isReadOnlyCustomFilter(filterId)\" ng-class=\"{'disabled':permissions.readOnly}\" ng-click=\"insertNewSet()\"><span class=\"icon btn-icon-plus\"></span><span>{{'FSFILTERS.INSERT_NEW_CONDITION_SET' | fcTranslate}}</span></div>\n" + "		</li>\n" + "	</ul>\n" + "</div>\n");

	$templateCache.put('templates/fc-scalar-value.html', "<div class=\"input-group-btn no-radius\">\n" + "    <div class=\"btn btn-select operator-drpdwn\" qstrap.select-menu items=\"getOperators()\" ng-model=\"uiOperator\" ng-change=\"updateFilter()\" ng-class=\"{'btn-info': !displayedFilter.filter.operator}\">\n" + "        {{getOperatorLabel()}}\n" + "        <span class=\"caret\"></span>\n" + "    </div>\n" + "</div>\n" + "<input ng-if=\"!operandDisabled && !hasLabels\" type=\"number\" class=\"form-control operand-form\" fc.number-formatter ng-model=\"displayedFilter.filter.operand\" ng-change=\"fireFilterChanged()\" ng-class=\"{'highlight': !displayedFilter.filter.operand}\" />\n" + "<div class=\"btn btn-select button-overflow operand-drpdwn\" fc.qmenu pagination=\"pagination\" searchable=\"true\" search-callback=\"getOperands($search)\" multi-select-menu=\"true\" ng-class=\"{'btn-info': !displayedFilter.filter.operand || displayedFilter.filter.operand.length === 0}\" on-selection=\"onSelection($value, selected)\" ng-if=\"!operandDisabled && hasLabels && multiSelect()\">\n" + "	{{operandLabel}}\n" + "	<span class=\"caret\"></span>\n" + "</div>\n" + "<div class=\"btn btn-select button-overflow operand-drpdwn\" fc.qmenu pagination=\"pagination\" searchable=\"true\" search-callback=\"getOperands($search)\" ng-class=\"{'btn-info': !displayedFilter.filter.operand || displayedFilter.filter.operand.length === 0}\" select-menu=\"true\" on-selection=\"updateFilter($value)\" ng-if=\"!operandDisabled && hasLabels && !multiSelect()\">\n" + "	{{operandLabel}}\n" + "	<span class=\"caret\"></span>\n" + "</div>");

	$templateCache.put('templates/fc-simple-filter.html', "<ul ng-if=\"displayedFilter.type === 'filter'\" class=\"simple-tree filters-client\">\n" + "	<li class=\"btn\" id=\"manage-filters-button\" ng-click=\"showModal(false)\">{{displayedFilterMetadata.name || 'FSFILTERS.MANAGE_FILTERS_ELLIPSIS' | fcTranslate}}</li>\n" + "	<li class=\"filter-tree-node\">\n" + "		<div fc.filter displayed-filter=\"displayedFilter\" class=\"single-filter\"></div>\n" + "		<span class=\"icon icon-minus-framed left\" ng-click=\"remove()\"></span>\n" + "		<span class=\"icon icon-plus-framed left\" ng-click=\"showModal(true)\"></span>\n" + "		<div class=\"filter-response-count\" ng-show=\"!hideCount && filteredCountObject.count\">{{'FSFILTERS.FILTERED_RESPONSES' | fcTranslate}}: {{filteredCountObject.count}}</div>\n" + "		<div style=\"clear: both;\"></div>\n" + "	</li>\n" + "</ul>");

	$templateCache.put('templates/fc-single-filter.html', "<div fc.filter permissions=\"permissions\" timezone=\"timezone\" displayed-filter=\"f\" class=\"middle-aligned filters-client\"></div>\n" + "<span class=\"icon icon-minus-framed middle-aligned\" ng-click=\"remove($index)\"></span>\n" + "<span class=\"icon icon-plus-framed middle-aligned\" ng-click=\"insert($index)\"></span>\n");

	$templateCache.put('templates/fc-warning-modal.tpl.html', "<div class=\"modal-content warning-modal\">\n" + "    <div class=\"modal-header\">\n" + "        <h4 class=\"modal-title\">\n" + "            <span>{{::title}}</span>\n" + "        </h4>\n" + "    </div>\n" + "    <div class=\"modal-body\">\n" + "        <div class=\"remove-source-container\">\n" + "            <div class=\"caution-icon-container\">\n" + "                <span class=\"caution-icon-size icon icon-caution-lg\"></span>\n" + "            </div>\n" + "            <div>\n" + "                <div class=\"text-center remove-source-msg medium-text\">\n" + "                    <span ng-bind-html=\"message\"></span>\n" + "                </div>\n" + "            </div>\n" + "        </div>\n" + "    </div>\n" + "    <div class=\"modal-footer\">\n" + "        <button class=\"btn btn-hover\"  ng-click=\"close()\">\n" + "            <span>{{::cancel}}</span>\n" + "        </button>\n" + "    </div>\n" + "</div>");
}]);
//# sourceMappingURL=filters-client.js.map
